import { useQuery, ApolloClient, InMemoryCache, from, ApolloLink, createHttpLink } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { createClient } from 'contentful';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/cms/__generated__/graphql.ts
var AboutCompositePageOrder = /* @__PURE__ */ ((AboutCompositePageOrder2) => {
  AboutCompositePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AboutCompositePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AboutCompositePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AboutCompositePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AboutCompositePageOrder2["SysIdAsc"] = "sys_id_ASC";
  AboutCompositePageOrder2["SysIdDesc"] = "sys_id_DESC";
  AboutCompositePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AboutCompositePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AboutCompositePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AboutCompositePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AboutCompositePageOrder2;
})(AboutCompositePageOrder || {});
var AccordionGroupAccordionItemCollectionOrder = /* @__PURE__ */ ((AccordionGroupAccordionItemCollectionOrder2) => {
  AccordionGroupAccordionItemCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupAccordionItemCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SummaryAsc"] = "summary_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SummaryDesc"] = "summary_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupAccordionItemCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupAccordionItemCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionGroupAccordionItemCollectionOrder2;
})(AccordionGroupAccordionItemCollectionOrder || {});
var AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder = /* @__PURE__ */ ((AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2) => {
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["TitleAsc"] = "title_ASC";
  AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2["TitleDesc"] = "title_DESC";
  return AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder2;
})(AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder || {});
var AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder = /* @__PURE__ */ ((AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2) => {
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["MapImageAltTextAsc"] = "mapImageAltText_ASC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["MapImageAltTextDesc"] = "mapImageAltText_DESC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SectionHeadingAsc"] = "sectionHeading_ASC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SectionHeadingDesc"] = "sectionHeading_DESC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder2;
})(AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder || {});
var AccordionGroupItemOrder = /* @__PURE__ */ ((AccordionGroupItemOrder2) => {
  AccordionGroupItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupItemOrder2["SummaryAsc"] = "summary_ASC";
  AccordionGroupItemOrder2["SummaryDesc"] = "summary_DESC";
  AccordionGroupItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupItemOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupItemOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionGroupItemOrder2;
})(AccordionGroupItemOrder || {});
var AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder = /* @__PURE__ */ ((AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2) => {
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["IsFaqAsc"] = "isFaq_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["IsFaqDesc"] = "isFaq_DESC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SectionTitleAsc"] = "sectionTitle_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SectionTitleDesc"] = "sectionTitle_DESC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder2;
})(AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder || {});
var AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder = /* @__PURE__ */ ((AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2) => {
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SailingTimeAsc"] = "sailingTime_ASC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SailingTimeDesc"] = "sailingTime_DESC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["VesselNameAsc"] = "vesselName_ASC";
  AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["VesselNameDesc"] = "vesselName_DESC";
  return AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2;
})(AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder || {});
var AccordionGroupLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((AccordionGroupLinkingCollectionsPageSectionCollectionOrder2) => {
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionGroupLinkingCollectionsPageSectionCollectionOrder2;
})(AccordionGroupLinkingCollectionsPageSectionCollectionOrder || {});
var AccordionGroupOrder = /* @__PURE__ */ ((AccordionGroupOrder2) => {
  AccordionGroupOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionGroupOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionGroupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionGroupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionGroupOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionGroupOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionGroupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionGroupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionGroupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionGroupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AccordionGroupOrder2["TitleAsc"] = "title_ASC";
  AccordionGroupOrder2["TitleDesc"] = "title_DESC";
  return AccordionGroupOrder2;
})(AccordionGroupOrder || {});
var AccordionLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((AccordionLinkingCollectionsPageSectionCollectionOrder2) => {
  AccordionLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionLinkingCollectionsPageSectionCollectionOrder2;
})(AccordionLinkingCollectionsPageSectionCollectionOrder || {});
var AccordionOrder = /* @__PURE__ */ ((AccordionOrder2) => {
  AccordionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionOrder2["SummaryAsc"] = "summary_ASC";
  AccordionOrder2["SummaryDesc"] = "summary_DESC";
  AccordionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionOrder2;
})(AccordionOrder || {});
var AccordionSectionAccordionGroupCollectionOrder = /* @__PURE__ */ ((AccordionSectionAccordionGroupCollectionOrder2) => {
  AccordionSectionAccordionGroupCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionSectionAccordionGroupCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionSectionAccordionGroupCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionSectionAccordionGroupCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionSectionAccordionGroupCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionSectionAccordionGroupCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionSectionAccordionGroupCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionSectionAccordionGroupCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionSectionAccordionGroupCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionSectionAccordionGroupCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AccordionSectionAccordionGroupCollectionOrder2["TitleAsc"] = "title_ASC";
  AccordionSectionAccordionGroupCollectionOrder2["TitleDesc"] = "title_DESC";
  return AccordionSectionAccordionGroupCollectionOrder2;
})(AccordionSectionAccordionGroupCollectionOrder || {});
var AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder2;
})(AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder || {});
var AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder2;
})(AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder || {});
var AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var AccordionSectionOrder = /* @__PURE__ */ ((AccordionSectionOrder2) => {
  AccordionSectionOrder2["ColumnsAsc"] = "columns_ASC";
  AccordionSectionOrder2["ColumnsDesc"] = "columns_DESC";
  AccordionSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AccordionSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AccordionSectionOrder2["IsFaqAsc"] = "isFaq_ASC";
  AccordionSectionOrder2["IsFaqDesc"] = "isFaq_DESC";
  AccordionSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  AccordionSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  AccordionSectionOrder2["SectionTitleAsc"] = "sectionTitle_ASC";
  AccordionSectionOrder2["SectionTitleDesc"] = "sectionTitle_DESC";
  AccordionSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionSectionOrder2;
})(AccordionSectionOrder || {});
var ActionCardLinkingCollectionsCardsSectionCollectionOrder = /* @__PURE__ */ ((ActionCardLinkingCollectionsCardsSectionCollectionOrder2) => {
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeAsc"] = "displayType_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeDesc"] = "displayType_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorAsc"] = "sectionBackgroundAndCardColor_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorDesc"] = "sectionBackgroundAndCardColor_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ActionCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ActionCardLinkingCollectionsCardsSectionCollectionOrder2;
})(ActionCardLinkingCollectionsCardsSectionCollectionOrder || {});
var ActionCardOrder = /* @__PURE__ */ ((ActionCardOrder2) => {
  ActionCardOrder2["BadgeAsc"] = "badge_ASC";
  ActionCardOrder2["BadgeDesc"] = "badge_DESC";
  ActionCardOrder2["CurrencyAsc"] = "currency_ASC";
  ActionCardOrder2["CurrencyDesc"] = "currency_DESC";
  ActionCardOrder2["DiscountAsc"] = "discount_ASC";
  ActionCardOrder2["DiscountDesc"] = "discount_DESC";
  ActionCardOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ActionCardOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ActionCardOrder2["HeaderAsc"] = "header_ASC";
  ActionCardOrder2["HeaderDesc"] = "header_DESC";
  ActionCardOrder2["PriceAsc"] = "price_ASC";
  ActionCardOrder2["PriceDesc"] = "price_DESC";
  ActionCardOrder2["SuffixAsc"] = "suffix_ASC";
  ActionCardOrder2["SuffixDesc"] = "suffix_DESC";
  ActionCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ActionCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ActionCardOrder2["SysIdAsc"] = "sys_id_ASC";
  ActionCardOrder2["SysIdDesc"] = "sys_id_DESC";
  ActionCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ActionCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ActionCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ActionCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ActionCardOrder2;
})(ActionCardOrder || {});
var AmendmentBookingOrder = /* @__PURE__ */ ((AmendmentBookingOrder2) => {
  AmendmentBookingOrder2["DateFormatAsc"] = "dateFormat_ASC";
  AmendmentBookingOrder2["DateFormatDesc"] = "dateFormat_DESC";
  AmendmentBookingOrder2["DisabledLinksPopupHeadingAsc"] = "disabledLinksPopupHeading_ASC";
  AmendmentBookingOrder2["DisabledLinksPopupHeadingDesc"] = "disabledLinksPopupHeading_DESC";
  AmendmentBookingOrder2["PassengerDetailsAsc"] = "passengerDetails_ASC";
  AmendmentBookingOrder2["PassengerDetailsDesc"] = "passengerDetails_DESC";
  AmendmentBookingOrder2["PreliminaryPendingMessageAsc"] = "preliminaryPendingMessage_ASC";
  AmendmentBookingOrder2["PreliminaryPendingMessageDesc"] = "preliminaryPendingMessage_DESC";
  AmendmentBookingOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AmendmentBookingOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AmendmentBookingOrder2["SysIdAsc"] = "sys_id_ASC";
  AmendmentBookingOrder2["SysIdDesc"] = "sys_id_DESC";
  AmendmentBookingOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AmendmentBookingOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AmendmentBookingOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AmendmentBookingOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AmendmentBookingOrder2["TimeFormatAsc"] = "timeFormat_ASC";
  AmendmentBookingOrder2["TimeFormatDesc"] = "timeFormat_DESC";
  return AmendmentBookingOrder2;
})(AmendmentBookingOrder || {});
var AmendmentCabinOrder = /* @__PURE__ */ ((AmendmentCabinOrder2) => {
  AmendmentCabinOrder2["NoCabinsAvailableAsc"] = "noCabinsAvailable_ASC";
  AmendmentCabinOrder2["NoCabinsAvailableDesc"] = "noCabinsAvailable_DESC";
  AmendmentCabinOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AmendmentCabinOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AmendmentCabinOrder2["SysIdAsc"] = "sys_id_ASC";
  AmendmentCabinOrder2["SysIdDesc"] = "sys_id_DESC";
  AmendmentCabinOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AmendmentCabinOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AmendmentCabinOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AmendmentCabinOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AmendmentCabinOrder2;
})(AmendmentCabinOrder || {});
var AmendmentFaresOrder = /* @__PURE__ */ ((AmendmentFaresOrder2) => {
  AmendmentFaresOrder2["AcceptAndContinueAsc"] = "acceptAndContinue_ASC";
  AmendmentFaresOrder2["AcceptAndContinueDesc"] = "acceptAndContinue_DESC";
  AmendmentFaresOrder2["BookingNumberAsc"] = "bookingNumber_ASC";
  AmendmentFaresOrder2["BookingNumberDesc"] = "bookingNumber_DESC";
  AmendmentFaresOrder2["DateFormatAsc"] = "dateFormat_ASC";
  AmendmentFaresOrder2["DateFormatDesc"] = "dateFormat_DESC";
  AmendmentFaresOrder2["DefaultBookingAsc"] = "defaultBooking_ASC";
  AmendmentFaresOrder2["DefaultBookingDesc"] = "defaultBooking_DESC";
  AmendmentFaresOrder2["DepartureDateAsc"] = "departureDate_ASC";
  AmendmentFaresOrder2["DepartureDateDesc"] = "departureDate_DESC";
  AmendmentFaresOrder2["LegendAsc"] = "legend_ASC";
  AmendmentFaresOrder2["LegendDesc"] = "legend_DESC";
  AmendmentFaresOrder2["OutboundTravelAsc"] = "outboundTravel_ASC";
  AmendmentFaresOrder2["OutboundTravelDesc"] = "outboundTravel_DESC";
  AmendmentFaresOrder2["ReturnDateAsc"] = "returnDate_ASC";
  AmendmentFaresOrder2["ReturnDateDesc"] = "returnDate_DESC";
  AmendmentFaresOrder2["ReturnTravelAsc"] = "returnTravel_ASC";
  AmendmentFaresOrder2["ReturnTravelDesc"] = "returnTravel_DESC";
  AmendmentFaresOrder2["SelectDateAsc"] = "selectDate_ASC";
  AmendmentFaresOrder2["SelectDateDesc"] = "selectDate_DESC";
  AmendmentFaresOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AmendmentFaresOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AmendmentFaresOrder2["SysIdAsc"] = "sys_id_ASC";
  AmendmentFaresOrder2["SysIdDesc"] = "sys_id_DESC";
  AmendmentFaresOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AmendmentFaresOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AmendmentFaresOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AmendmentFaresOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AmendmentFaresOrder2["Tier3CategoryChangedHeaderAsc"] = "tier3CategoryChangedHeader_ASC";
  AmendmentFaresOrder2["Tier3CategoryChangedHeaderDesc"] = "tier3CategoryChangedHeader_DESC";
  AmendmentFaresOrder2["Tier3CategoryChangedAsc"] = "tier3CategoryChanged_ASC";
  AmendmentFaresOrder2["Tier3CategoryChangedDesc"] = "tier3CategoryChanged_DESC";
  AmendmentFaresOrder2["Tier3WhatIsIncludedAsc"] = "tier3WhatIsIncluded_ASC";
  AmendmentFaresOrder2["Tier3WhatIsIncludedDesc"] = "tier3WhatIsIncluded_DESC";
  AmendmentFaresOrder2["TimeFormatAsc"] = "timeFormat_ASC";
  AmendmentFaresOrder2["TimeFormatDesc"] = "timeFormat_DESC";
  AmendmentFaresOrder2["TitleAsc"] = "title_ASC";
  AmendmentFaresOrder2["TitleDesc"] = "title_DESC";
  return AmendmentFaresOrder2;
})(AmendmentFaresOrder || {});
var AppOrder = /* @__PURE__ */ ((AppOrder2) => {
  AppOrder2["EdgeLabelAsc"] = "edgeLabel_ASC";
  AppOrder2["EdgeLabelDesc"] = "edgeLabel_DESC";
  AppOrder2["ExploreBannerDescriptionAsc"] = "exploreBannerDescription_ASC";
  AppOrder2["ExploreBannerDescriptionDesc"] = "exploreBannerDescription_DESC";
  AppOrder2["FrontPageButtonTextAsc"] = "frontPageButtonText_ASC";
  AppOrder2["FrontPageButtonTextDesc"] = "frontPageButtonText_DESC";
  AppOrder2["InternetExploreOverlayDescriptionAsc"] = "internetExploreOverlayDescription_ASC";
  AppOrder2["InternetExploreOverlayDescriptionDesc"] = "internetExploreOverlayDescription_DESC";
  AppOrder2["InternetExploreOverlayHeaderAsc"] = "internetExploreOverlayHeader_ASC";
  AppOrder2["InternetExploreOverlayHeaderDesc"] = "internetExploreOverlayHeader_DESC";
  AppOrder2["MicrosoftEdgeButtonTextAsc"] = "microsoftEdgeButtonText_ASC";
  AppOrder2["MicrosoftEdgeButtonTextDesc"] = "microsoftEdgeButtonText_DESC";
  AppOrder2["OktaResumeSessionButtonAsc"] = "oktaResumeSessionButton_ASC";
  AppOrder2["OktaResumeSessionButtonDesc"] = "oktaResumeSessionButton_DESC";
  AppOrder2["OktaSessionAboutToExpireDescriptionAsc"] = "oktaSessionAboutToExpireDescription_ASC";
  AppOrder2["OktaSessionAboutToExpireDescriptionDesc"] = "oktaSessionAboutToExpireDescription_DESC";
  AppOrder2["OktaSessionAboutToExpireHeaderAsc"] = "oktaSessionAboutToExpireHeader_ASC";
  AppOrder2["OktaSessionAboutToExpireHeaderDesc"] = "oktaSessionAboutToExpireHeader_DESC";
  AppOrder2["OktaSessionExpiredDescriptionAsc"] = "oktaSessionExpiredDescription_ASC";
  AppOrder2["OktaSessionExpiredDescriptionDesc"] = "oktaSessionExpiredDescription_DESC";
  AppOrder2["OktaSessionExpiredHeaderAsc"] = "oktaSessionExpiredHeader_ASC";
  AppOrder2["OktaSessionExpiredHeaderDesc"] = "oktaSessionExpiredHeader_DESC";
  AppOrder2["OktaStartOverButtonAsc"] = "oktaStartOverButton_ASC";
  AppOrder2["OktaStartOverButtonDesc"] = "oktaStartOverButton_DESC";
  AppOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AppOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AppOrder2["SysIdAsc"] = "sys_id_ASC";
  AppOrder2["SysIdDesc"] = "sys_id_DESC";
  AppOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AppOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AppOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AppOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AppOrder2;
})(AppOrder || {});
var AppSectionLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((AppSectionLinkingCollectionsArticlePageCollectionOrder2) => {
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AppSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AppSectionLinkingCollectionsArticlePageCollectionOrder2;
})(AppSectionLinkingCollectionsArticlePageCollectionOrder || {});
var AppSectionLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((AppSectionLinkingCollectionsModularPageCollectionOrder2) => {
  AppSectionLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AppSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AppSectionLinkingCollectionsModularPageCollectionOrder2;
})(AppSectionLinkingCollectionsModularPageCollectionOrder || {});
var AppSectionOrder = /* @__PURE__ */ ((AppSectionOrder2) => {
  AppSectionOrder2["AppTypeAsc"] = "appType_ASC";
  AppSectionOrder2["AppTypeDesc"] = "appType_DESC";
  AppSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AppSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AppSectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  AppSectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  AppSectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  AppSectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  AppSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  AppSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  AppSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AppSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AppSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AppSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AppSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AppSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AppSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AppSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AppSectionOrder2;
})(AppSectionOrder || {});
var ArrayOfItemsOrder = /* @__PURE__ */ ((ArrayOfItemsOrder2) => {
  ArrayOfItemsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArrayOfItemsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArrayOfItemsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArrayOfItemsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArrayOfItemsOrder2["SysIdAsc"] = "sys_id_ASC";
  ArrayOfItemsOrder2["SysIdDesc"] = "sys_id_DESC";
  ArrayOfItemsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArrayOfItemsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArrayOfItemsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArrayOfItemsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArrayOfItemsOrder2;
})(ArrayOfItemsOrder || {});
var ArticleCategoryOverviewPageOrder = /* @__PURE__ */ ((ArticleCategoryOverviewPageOrder2) => {
  ArticleCategoryOverviewPageOrder2["CategoryAsc"] = "category_ASC";
  ArticleCategoryOverviewPageOrder2["CategoryDesc"] = "category_DESC";
  ArticleCategoryOverviewPageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleCategoryOverviewPageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleCategoryOverviewPageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleCategoryOverviewPageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleCategoryOverviewPageOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleCategoryOverviewPageOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleCategoryOverviewPageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleCategoryOverviewPageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleCategoryOverviewPageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleCategoryOverviewPageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleCategoryOverviewPageOrder2;
})(ArticleCategoryOverviewPageOrder || {});
var ArticleCompositePageOrder = /* @__PURE__ */ ((ArticleCompositePageOrder2) => {
  ArticleCompositePageOrder2["CategoryAsc"] = "category_ASC";
  ArticleCompositePageOrder2["CategoryDesc"] = "category_DESC";
  ArticleCompositePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleCompositePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleCompositePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleCompositePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleCompositePageOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleCompositePageOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleCompositePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleCompositePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleCompositePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleCompositePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleCompositePageOrder2;
})(ArticleCompositePageOrder || {});
var ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder2;
})(ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder || {});
var ArticleHeroSectionOrder = /* @__PURE__ */ ((ArticleHeroSectionOrder2) => {
  ArticleHeroSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleHeroSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleHeroSectionOrder2["QuoteAuthorAsc"] = "quoteAuthor_ASC";
  ArticleHeroSectionOrder2["QuoteAuthorDesc"] = "quoteAuthor_DESC";
  ArticleHeroSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleHeroSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleHeroSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleHeroSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleHeroSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleHeroSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleHeroSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleHeroSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ArticleHeroSectionOrder2["TitleAsc"] = "title_ASC";
  ArticleHeroSectionOrder2["TitleDesc"] = "title_DESC";
  return ArticleHeroSectionOrder2;
})(ArticleHeroSectionOrder || {});
var ArticlePageOrder = /* @__PURE__ */ ((ArticlePageOrder2) => {
  ArticlePageOrder2["CategoryAsc"] = "category_ASC";
  ArticlePageOrder2["CategoryDesc"] = "category_DESC";
  ArticlePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticlePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticlePageOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  ArticlePageOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  ArticlePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticlePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticlePageOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticlePageOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticlePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticlePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticlePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticlePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticlePageOrder2;
})(ArticlePageOrder || {});
var ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder2;
})(ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder || {});
var ArticleSectionOrder = /* @__PURE__ */ ((ArticleSectionOrder2) => {
  ArticleSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleSectionOrder2;
})(ArticleSectionOrder || {});
var ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder = /* @__PURE__ */ ((ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2) => {
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder2;
})(ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder || {});
var ArticleSidebarContentBlockOrder = /* @__PURE__ */ ((ArticleSidebarContentBlockOrder2) => {
  ArticleSidebarContentBlockOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleSidebarContentBlockOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleSidebarContentBlockOrder2["HeadingAsc"] = "heading_ASC";
  ArticleSidebarContentBlockOrder2["HeadingDesc"] = "heading_DESC";
  ArticleSidebarContentBlockOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleSidebarContentBlockOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleSidebarContentBlockOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleSidebarContentBlockOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleSidebarContentBlockOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleSidebarContentBlockOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleSidebarContentBlockOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleSidebarContentBlockOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleSidebarContentBlockOrder2;
})(ArticleSidebarContentBlockOrder || {});
var ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder = /* @__PURE__ */ ((ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2) => {
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder2;
})(ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder || {});
var ArticleSidebarOrder = /* @__PURE__ */ ((ArticleSidebarOrder2) => {
  ArticleSidebarOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ArticleSidebarOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ArticleSidebarOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  ArticleSidebarOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  ArticleSidebarOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ArticleSidebarOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ArticleSidebarOrder2["SysIdAsc"] = "sys_id_ASC";
  ArticleSidebarOrder2["SysIdDesc"] = "sys_id_DESC";
  ArticleSidebarOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ArticleSidebarOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ArticleSidebarOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ArticleSidebarOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ArticleSidebarOrder2;
})(ArticleSidebarOrder || {});
var AssetLinkLinkingCollectionsMapSectionCollectionOrder = /* @__PURE__ */ ((AssetLinkLinkingCollectionsMapSectionCollectionOrder2) => {
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["MapImageAltTextAsc"] = "mapImageAltText_ASC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["MapImageAltTextDesc"] = "mapImageAltText_DESC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SectionHeadingAsc"] = "sectionHeading_ASC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SectionHeadingDesc"] = "sectionHeading_DESC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AssetLinkLinkingCollectionsMapSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AssetLinkLinkingCollectionsMapSectionCollectionOrder2;
})(AssetLinkLinkingCollectionsMapSectionCollectionOrder || {});
var AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder = /* @__PURE__ */ ((AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2) => {
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["HeaderAsc"] = "header_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["HeaderDesc"] = "header_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["MediaLayoutAsc"] = "mediaLayout_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["MediaLayoutDesc"] = "mediaLayout_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VariantAsc"] = "variant_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VariantDesc"] = "variant_DESC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2;
})(AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder || {});
var AssetLinkOrder = /* @__PURE__ */ ((AssetLinkOrder2) => {
  AssetLinkOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AssetLinkOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AssetLinkOrder2["LinkTextAsc"] = "linkText_ASC";
  AssetLinkOrder2["LinkTextDesc"] = "linkText_DESC";
  AssetLinkOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AssetLinkOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AssetLinkOrder2["SysIdAsc"] = "sys_id_ASC";
  AssetLinkOrder2["SysIdDesc"] = "sys_id_DESC";
  AssetLinkOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AssetLinkOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AssetLinkOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AssetLinkOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AssetLinkOrder2;
})(AssetLinkOrder || {});
var AssetOrder = /* @__PURE__ */ ((AssetOrder2) => {
  AssetOrder2["ContentTypeAsc"] = "contentType_ASC";
  AssetOrder2["ContentTypeDesc"] = "contentType_DESC";
  AssetOrder2["FileNameAsc"] = "fileName_ASC";
  AssetOrder2["FileNameDesc"] = "fileName_DESC";
  AssetOrder2["HeightAsc"] = "height_ASC";
  AssetOrder2["HeightDesc"] = "height_DESC";
  AssetOrder2["SizeAsc"] = "size_ASC";
  AssetOrder2["SizeDesc"] = "size_DESC";
  AssetOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AssetOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AssetOrder2["SysIdAsc"] = "sys_id_ASC";
  AssetOrder2["SysIdDesc"] = "sys_id_DESC";
  AssetOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AssetOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AssetOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AssetOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AssetOrder2["UrlAsc"] = "url_ASC";
  AssetOrder2["UrlDesc"] = "url_DESC";
  AssetOrder2["WidthAsc"] = "width_ASC";
  AssetOrder2["WidthDesc"] = "width_DESC";
  return AssetOrder2;
})(AssetOrder || {});
var AuthorLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((AuthorLinkingCollectionsArticlePageCollectionOrder2) => {
  AuthorLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AuthorLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AuthorLinkingCollectionsArticlePageCollectionOrder2;
})(AuthorLinkingCollectionsArticlePageCollectionOrder || {});
var AuthorLinkingCollectionsArticleSidebarCollectionOrder = /* @__PURE__ */ ((AuthorLinkingCollectionsArticleSidebarCollectionOrder2) => {
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AuthorLinkingCollectionsArticleSidebarCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AuthorLinkingCollectionsArticleSidebarCollectionOrder2;
})(AuthorLinkingCollectionsArticleSidebarCollectionOrder || {});
var AuthorOrder = /* @__PURE__ */ ((AuthorOrder2) => {
  AuthorOrder2["JobTitleAsc"] = "jobTitle_ASC";
  AuthorOrder2["JobTitleDesc"] = "jobTitle_DESC";
  AuthorOrder2["LinkedInAsc"] = "linkedIn_ASC";
  AuthorOrder2["LinkedInDesc"] = "linkedIn_DESC";
  AuthorOrder2["NameAsc"] = "name_ASC";
  AuthorOrder2["NameDesc"] = "name_DESC";
  AuthorOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AuthorOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AuthorOrder2["SysIdAsc"] = "sys_id_ASC";
  AuthorOrder2["SysIdDesc"] = "sys_id_DESC";
  AuthorOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AuthorOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AuthorOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AuthorOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AuthorOrder2;
})(AuthorOrder || {});
var B2BCompositePageOrder = /* @__PURE__ */ ((B2BCompositePageOrder2) => {
  B2BCompositePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BCompositePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BCompositePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BCompositePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BCompositePageOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BCompositePageOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BCompositePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BCompositePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BCompositePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BCompositePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2BCompositePageOrder2;
})(B2BCompositePageOrder || {});
var B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder = /* @__PURE__ */ ((B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2) => {
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["TableVariantAsc"] = "tableVariant_ASC";
  B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2["TableVariantDesc"] = "tableVariant_DESC";
  return B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder2;
})(B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder || {});
var B2BTimetableRouteOrder = /* @__PURE__ */ ((B2BTimetableRouteOrder2) => {
  B2BTimetableRouteOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BTimetableRouteOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BTimetableRouteOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BTimetableRouteOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BTimetableRouteOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BTimetableRouteOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BTimetableRouteOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BTimetableRouteOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BTimetableRouteOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BTimetableRouteOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2BTimetableRouteOrder2;
})(B2BTimetableRouteOrder || {});
var B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder = /* @__PURE__ */ ((B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2) => {
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["TableVariantAsc"] = "tableVariant_ASC";
  B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2["TableVariantDesc"] = "tableVariant_DESC";
  return B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder2;
})(B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder || {});
var B2BTimetableSectionContentOrder = /* @__PURE__ */ ((B2BTimetableSectionContentOrder2) => {
  B2BTimetableSectionContentOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BTimetableSectionContentOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BTimetableSectionContentOrder2["SailingTimeAsc"] = "sailingTime_ASC";
  B2BTimetableSectionContentOrder2["SailingTimeDesc"] = "sailingTime_DESC";
  B2BTimetableSectionContentOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BTimetableSectionContentOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BTimetableSectionContentOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BTimetableSectionContentOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BTimetableSectionContentOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BTimetableSectionContentOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BTimetableSectionContentOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BTimetableSectionContentOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  B2BTimetableSectionContentOrder2["VesselNameAsc"] = "vesselName_ASC";
  B2BTimetableSectionContentOrder2["VesselNameDesc"] = "vesselName_DESC";
  return B2BTimetableSectionContentOrder2;
})(B2BTimetableSectionContentOrder || {});
var B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var B2BTimetableSectionOrder = /* @__PURE__ */ ((B2BTimetableSectionOrder2) => {
  B2BTimetableSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2BTimetableSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2BTimetableSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2BTimetableSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2BTimetableSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  B2BTimetableSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  B2BTimetableSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2BTimetableSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2BTimetableSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2BTimetableSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  B2BTimetableSectionOrder2["TableVariantAsc"] = "tableVariant_ASC";
  B2BTimetableSectionOrder2["TableVariantDesc"] = "tableVariant_DESC";
  return B2BTimetableSectionOrder2;
})(B2BTimetableSectionOrder || {});
var B2CCompositePageOrder = /* @__PURE__ */ ((B2CCompositePageOrder2) => {
  B2CCompositePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  B2CCompositePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  B2CCompositePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  B2CCompositePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  B2CCompositePageOrder2["SysIdAsc"] = "sys_id_ASC";
  B2CCompositePageOrder2["SysIdDesc"] = "sys_id_DESC";
  B2CCompositePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  B2CCompositePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  B2CCompositePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  B2CCompositePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return B2CCompositePageOrder2;
})(B2CCompositePageOrder || {});
var BannerOrder = /* @__PURE__ */ ((BannerOrder2) => {
  BannerOrder2["EnabledAsc"] = "enabled_ASC";
  BannerOrder2["EnabledDesc"] = "enabled_DESC";
  BannerOrder2["EntityNameAsc"] = "entityName_ASC";
  BannerOrder2["EntityNameDesc"] = "entityName_DESC";
  BannerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BannerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BannerOrder2["SysIdAsc"] = "sys_id_ASC";
  BannerOrder2["SysIdDesc"] = "sys_id_DESC";
  BannerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BannerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BannerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BannerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  BannerOrder2["TextAsc"] = "text_ASC";
  BannerOrder2["TextDesc"] = "text_DESC";
  return BannerOrder2;
})(BannerOrder || {});
var CabinDetailsOrder = /* @__PURE__ */ ((CabinDetailsOrder2) => {
  CabinDetailsOrder2["CabinTypeCodeAsc"] = "cabinTypeCode_ASC";
  CabinDetailsOrder2["CabinTypeCodeDesc"] = "cabinTypeCode_DESC";
  CabinDetailsOrder2["HeadlineAsc"] = "headline_ASC";
  CabinDetailsOrder2["HeadlineDesc"] = "headline_DESC";
  CabinDetailsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CabinDetailsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CabinDetailsOrder2["SysIdAsc"] = "sys_id_ASC";
  CabinDetailsOrder2["SysIdDesc"] = "sys_id_DESC";
  CabinDetailsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CabinDetailsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CabinDetailsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CabinDetailsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CabinDetailsOrder2;
})(CabinDetailsOrder || {});
var CabinGroupOrder = /* @__PURE__ */ ((CabinGroupOrder2) => {
  CabinGroupOrder2["CabinGroupCodeAsc"] = "cabinGroupCode_ASC";
  CabinGroupOrder2["CabinGroupCodeDesc"] = "cabinGroupCode_DESC";
  CabinGroupOrder2["EditorDescriptionAsc"] = "editorDescription_ASC";
  CabinGroupOrder2["EditorDescriptionDesc"] = "editorDescription_DESC";
  CabinGroupOrder2["HeadlineAsc"] = "headline_ASC";
  CabinGroupOrder2["HeadlineDesc"] = "headline_DESC";
  CabinGroupOrder2["NoteAsc"] = "note_ASC";
  CabinGroupOrder2["NoteDesc"] = "note_DESC";
  CabinGroupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CabinGroupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CabinGroupOrder2["SysIdAsc"] = "sys_id_ASC";
  CabinGroupOrder2["SysIdDesc"] = "sys_id_DESC";
  CabinGroupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CabinGroupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CabinGroupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CabinGroupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CabinGroupOrder2;
})(CabinGroupOrder || {});
var CabinLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((CabinLinkingCollectionsFerryCollectionOrder2) => {
  CabinLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CabinLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CabinLinkingCollectionsFerryCollectionOrder2;
})(CabinLinkingCollectionsFerryCollectionOrder || {});
var CabinOrder = /* @__PURE__ */ ((CabinOrder2) => {
  CabinOrder2["CabinTitleAsc"] = "cabinTitle_ASC";
  CabinOrder2["CabinTitleDesc"] = "cabinTitle_DESC";
  CabinOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CabinOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CabinOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CabinOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CabinOrder2["SysIdAsc"] = "sys_id_ASC";
  CabinOrder2["SysIdDesc"] = "sys_id_DESC";
  CabinOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CabinOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CabinOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CabinOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CabinOrder2;
})(CabinOrder || {});
var CampaignBlockLinkingCollectionsMobilePageCollectionOrder = /* @__PURE__ */ ((CampaignBlockLinkingCollectionsMobilePageCollectionOrder2) => {
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["PageTitleAsc"] = "pageTitle_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["PageTitleDesc"] = "pageTitle_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CampaignBlockLinkingCollectionsMobilePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CampaignBlockLinkingCollectionsMobilePageCollectionOrder2;
})(CampaignBlockLinkingCollectionsMobilePageCollectionOrder || {});
var CampaignBlockOrder = /* @__PURE__ */ ((CampaignBlockOrder2) => {
  CampaignBlockOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CampaignBlockOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CampaignBlockOrder2["PromotionCodeAsc"] = "promotionCode_ASC";
  CampaignBlockOrder2["PromotionCodeDesc"] = "promotionCode_DESC";
  CampaignBlockOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CampaignBlockOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CampaignBlockOrder2["SysIdAsc"] = "sys_id_ASC";
  CampaignBlockOrder2["SysIdDesc"] = "sys_id_DESC";
  CampaignBlockOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CampaignBlockOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CampaignBlockOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CampaignBlockOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CampaignBlockOrder2;
})(CampaignBlockOrder || {});
var CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder2;
})(CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder || {});
var CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder2;
})(CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder || {});
var CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var CardsSectionOrder = /* @__PURE__ */ ((CardsSectionOrder2) => {
  CardsSectionOrder2["DisplayTypeAsc"] = "displayType_ASC";
  CardsSectionOrder2["DisplayTypeDesc"] = "displayType_DESC";
  CardsSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionOrder2["SectionBackgroundAndCardColorAsc"] = "sectionBackgroundAndCardColor_ASC";
  CardsSectionOrder2["SectionBackgroundAndCardColorDesc"] = "sectionBackgroundAndCardColor_DESC";
  CardsSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  CardsSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  CardsSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionOrder2;
})(CardsSectionOrder || {});
var CardsSectionSectionButtonsCollectionOrder = /* @__PURE__ */ ((CardsSectionSectionButtonsCollectionOrder2) => {
  CardsSectionSectionButtonsCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  CardsSectionSectionButtonsCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  CardsSectionSectionButtonsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CardsSectionSectionButtonsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CardsSectionSectionButtonsCollectionOrder2["IconAsc"] = "icon_ASC";
  CardsSectionSectionButtonsCollectionOrder2["IconDesc"] = "icon_DESC";
  CardsSectionSectionButtonsCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  CardsSectionSectionButtonsCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  CardsSectionSectionButtonsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardsSectionSectionButtonsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardsSectionSectionButtonsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardsSectionSectionButtonsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardsSectionSectionButtonsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardsSectionSectionButtonsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardsSectionSectionButtonsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardsSectionSectionButtonsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardsSectionSectionButtonsCollectionOrder2;
})(CardsSectionSectionButtonsCollectionOrder || {});
var CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder = /* @__PURE__ */ ((CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2) => {
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SailingTimeAsc"] = "sailingTime_ASC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SailingTimeDesc"] = "sailingTime_DESC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["VesselNameAsc"] = "vesselName_ASC";
  CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["VesselNameDesc"] = "vesselName_DESC";
  return CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder2;
})(CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder || {});
var CheckmarkListGroupListSectionsCollectionOrder = /* @__PURE__ */ ((CheckmarkListGroupListSectionsCollectionOrder2) => {
  CheckmarkListGroupListSectionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CheckmarkListGroupListSectionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CheckmarkListGroupListSectionsCollectionOrder2["HeadingAsc"] = "heading_ASC";
  CheckmarkListGroupListSectionsCollectionOrder2["HeadingDesc"] = "heading_DESC";
  CheckmarkListGroupListSectionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CheckmarkListGroupListSectionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CheckmarkListGroupListSectionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CheckmarkListGroupListSectionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CheckmarkListGroupListSectionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CheckmarkListGroupListSectionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CheckmarkListGroupListSectionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CheckmarkListGroupListSectionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CheckmarkListGroupListSectionsCollectionOrder2;
})(CheckmarkListGroupListSectionsCollectionOrder || {});
var CheckmarkListGroupOrder = /* @__PURE__ */ ((CheckmarkListGroupOrder2) => {
  CheckmarkListGroupOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CheckmarkListGroupOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CheckmarkListGroupOrder2["HeadingAsc"] = "heading_ASC";
  CheckmarkListGroupOrder2["HeadingDesc"] = "heading_DESC";
  CheckmarkListGroupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CheckmarkListGroupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CheckmarkListGroupOrder2["SysIdAsc"] = "sys_id_ASC";
  CheckmarkListGroupOrder2["SysIdDesc"] = "sys_id_DESC";
  CheckmarkListGroupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CheckmarkListGroupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CheckmarkListGroupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CheckmarkListGroupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CheckmarkListGroupOrder2;
})(CheckmarkListGroupOrder || {});
var CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder = /* @__PURE__ */ ((CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2) => {
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["HeadingAsc"] = "heading_ASC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["HeadingDesc"] = "heading_DESC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder2;
})(CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder || {});
var CheckmarkListItemOrder = /* @__PURE__ */ ((CheckmarkListItemOrder2) => {
  CheckmarkListItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CheckmarkListItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CheckmarkListItemOrder2["LabelAsc"] = "label_ASC";
  CheckmarkListItemOrder2["LabelDesc"] = "label_DESC";
  CheckmarkListItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CheckmarkListItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CheckmarkListItemOrder2["SysIdAsc"] = "sys_id_ASC";
  CheckmarkListItemOrder2["SysIdDesc"] = "sys_id_DESC";
  CheckmarkListItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CheckmarkListItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CheckmarkListItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CheckmarkListItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CheckmarkListItemOrder2;
})(CheckmarkListItemOrder || {});
var CheckmarkListSectionItemsCollectionOrder = /* @__PURE__ */ ((CheckmarkListSectionItemsCollectionOrder2) => {
  CheckmarkListSectionItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CheckmarkListSectionItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CheckmarkListSectionItemsCollectionOrder2["LabelAsc"] = "label_ASC";
  CheckmarkListSectionItemsCollectionOrder2["LabelDesc"] = "label_DESC";
  CheckmarkListSectionItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CheckmarkListSectionItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CheckmarkListSectionItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CheckmarkListSectionItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CheckmarkListSectionItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CheckmarkListSectionItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CheckmarkListSectionItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CheckmarkListSectionItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CheckmarkListSectionItemsCollectionOrder2;
})(CheckmarkListSectionItemsCollectionOrder || {});
var CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder = /* @__PURE__ */ ((CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2) => {
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["HeadingAsc"] = "heading_ASC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["HeadingDesc"] = "heading_DESC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder2;
})(CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder || {});
var CheckmarkListSectionOrder = /* @__PURE__ */ ((CheckmarkListSectionOrder2) => {
  CheckmarkListSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  CheckmarkListSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  CheckmarkListSectionOrder2["HeadingAsc"] = "heading_ASC";
  CheckmarkListSectionOrder2["HeadingDesc"] = "heading_DESC";
  CheckmarkListSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CheckmarkListSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CheckmarkListSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CheckmarkListSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CheckmarkListSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CheckmarkListSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CheckmarkListSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CheckmarkListSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CheckmarkListSectionOrder2;
})(CheckmarkListSectionOrder || {});
var ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder = /* @__PURE__ */ ((ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2) => {
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["NameAsc"] = "name_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["NameDesc"] = "name_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder2;
})(ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder || {});
var ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder = /* @__PURE__ */ ((ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2) => {
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["NameAsc"] = "name_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["NameDesc"] = "name_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder2;
})(ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder || {});
var ConsentTextOrder = /* @__PURE__ */ ((ConsentTextOrder2) => {
  ConsentTextOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ConsentTextOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ConsentTextOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ConsentTextOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ConsentTextOrder2["SysIdAsc"] = "sys_id_ASC";
  ConsentTextOrder2["SysIdDesc"] = "sys_id_DESC";
  ConsentTextOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ConsentTextOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ConsentTextOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ConsentTextOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ConsentTextOrder2;
})(ConsentTextOrder || {});
var ContentBlockCtasCollectionOrder = /* @__PURE__ */ ((ContentBlockCtasCollectionOrder2) => {
  ContentBlockCtasCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  ContentBlockCtasCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  ContentBlockCtasCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockCtasCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockCtasCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  ContentBlockCtasCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  ContentBlockCtasCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  ContentBlockCtasCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  ContentBlockCtasCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockCtasCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockCtasCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockCtasCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockCtasCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockCtasCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockCtasCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockCtasCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ContentBlockCtasCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  ContentBlockCtasCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return ContentBlockCtasCollectionOrder2;
})(ContentBlockCtasCollectionOrder || {});
var ContentBlockLinkingCollectionsAppSectionCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsAppSectionCollectionOrder2) => {
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["AppTypeAsc"] = "appType_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["AppTypeDesc"] = "appType_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsAppSectionCollectionOrder2;
})(ContentBlockLinkingCollectionsAppSectionCollectionOrder || {});
var ContentBlockLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsArticlePageCollectionOrder2) => {
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsArticlePageCollectionOrder2;
})(ContentBlockLinkingCollectionsArticlePageCollectionOrder || {});
var ContentBlockLinkingCollectionsCampaignBlockCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2) => {
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["PromotionCodeAsc"] = "promotionCode_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["PromotionCodeDesc"] = "promotionCode_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsCampaignBlockCollectionOrder2;
})(ContentBlockLinkingCollectionsCampaignBlockCollectionOrder || {});
var ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2) => {
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["PageMetaDescriptionAsc"] = "pageMetaDescription_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["PageMetaDescriptionDesc"] = "pageMetaDescription_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["PageTitleAsc"] = "pageTitle_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["PageTitleDesc"] = "pageTitle_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["RobotsMetaAsc"] = "robotsMeta_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["RobotsMetaDesc"] = "robotsMeta_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder2;
})(ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder || {});
var ContentBlockLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsNavigationCollectionOrder2) => {
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsNavigationCollectionOrder2;
})(ContentBlockLinkingCollectionsNavigationCollectionOrder || {});
var ContentBlockLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((ContentBlockLinkingCollectionsPageSectionCollectionOrder2) => {
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentBlockLinkingCollectionsPageSectionCollectionOrder2;
})(ContentBlockLinkingCollectionsPageSectionCollectionOrder || {});
var ContentBlockOrder = /* @__PURE__ */ ((ContentBlockOrder2) => {
  ContentBlockOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ContentBlockOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ContentBlockOrder2["ImageDisplayOptionsAsc"] = "imageDisplayOptions_ASC";
  ContentBlockOrder2["ImageDisplayOptionsDesc"] = "imageDisplayOptions_DESC";
  ContentBlockOrder2["MediaTypeAsc"] = "mediaType_ASC";
  ContentBlockOrder2["MediaTypeDesc"] = "mediaType_DESC";
  ContentBlockOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  ContentBlockOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  ContentBlockOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentBlockOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentBlockOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentBlockOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentBlockOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentBlockOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentBlockOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentBlockOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ContentBlockOrder2["TertiaryTextAsc"] = "tertiaryText_ASC";
  ContentBlockOrder2["TertiaryTextDesc"] = "tertiaryText_DESC";
  ContentBlockOrder2["VideoLinkAsc"] = "videoLink_ASC";
  ContentBlockOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return ContentBlockOrder2;
})(ContentBlockOrder || {});
var DfdsAppSimpleStringOrder = /* @__PURE__ */ ((DfdsAppSimpleStringOrder2) => {
  DfdsAppSimpleStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  DfdsAppSimpleStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  DfdsAppSimpleStringOrder2["KeyAsc"] = "key_ASC";
  DfdsAppSimpleStringOrder2["KeyDesc"] = "key_DESC";
  DfdsAppSimpleStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  DfdsAppSimpleStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  DfdsAppSimpleStringOrder2["SysIdAsc"] = "sys_id_ASC";
  DfdsAppSimpleStringOrder2["SysIdDesc"] = "sys_id_DESC";
  DfdsAppSimpleStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  DfdsAppSimpleStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  DfdsAppSimpleStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  DfdsAppSimpleStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return DfdsAppSimpleStringOrder2;
})(DfdsAppSimpleStringOrder || {});
var EntryOrder = /* @__PURE__ */ ((EntryOrder2) => {
  EntryOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EntryOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EntryOrder2["SysIdAsc"] = "sys_id_ASC";
  EntryOrder2["SysIdDesc"] = "sys_id_DESC";
  EntryOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EntryOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EntryOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EntryOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return EntryOrder2;
})(EntryOrder || {});
var EventGroupEventsCollectionOrder = /* @__PURE__ */ ((EventGroupEventsCollectionOrder2) => {
  EventGroupEventsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  EventGroupEventsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  EventGroupEventsCollectionOrder2["EventNameAsc"] = "eventName_ASC";
  EventGroupEventsCollectionOrder2["EventNameDesc"] = "eventName_DESC";
  EventGroupEventsCollectionOrder2["LocationAsc"] = "location_ASC";
  EventGroupEventsCollectionOrder2["LocationDesc"] = "location_DESC";
  EventGroupEventsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EventGroupEventsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EventGroupEventsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  EventGroupEventsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  EventGroupEventsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EventGroupEventsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EventGroupEventsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EventGroupEventsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  EventGroupEventsCollectionOrder2["TimeAsc"] = "time_ASC";
  EventGroupEventsCollectionOrder2["TimeDesc"] = "time_DESC";
  return EventGroupEventsCollectionOrder2;
})(EventGroupEventsCollectionOrder || {});
var EventGroupLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((EventGroupLinkingCollectionsFerryCollectionOrder2) => {
  EventGroupLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EventGroupLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return EventGroupLinkingCollectionsFerryCollectionOrder2;
})(EventGroupLinkingCollectionsFerryCollectionOrder || {});
var EventGroupOrder = /* @__PURE__ */ ((EventGroupOrder2) => {
  EventGroupOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  EventGroupOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  EventGroupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EventGroupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EventGroupOrder2["SysIdAsc"] = "sys_id_ASC";
  EventGroupOrder2["SysIdDesc"] = "sys_id_DESC";
  EventGroupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EventGroupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EventGroupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EventGroupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return EventGroupOrder2;
})(EventGroupOrder || {});
var EventLinkingCollectionsEventGroupCollectionOrder = /* @__PURE__ */ ((EventLinkingCollectionsEventGroupCollectionOrder2) => {
  EventLinkingCollectionsEventGroupCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  EventLinkingCollectionsEventGroupCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  EventLinkingCollectionsEventGroupCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EventLinkingCollectionsEventGroupCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EventLinkingCollectionsEventGroupCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  EventLinkingCollectionsEventGroupCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  EventLinkingCollectionsEventGroupCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EventLinkingCollectionsEventGroupCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EventLinkingCollectionsEventGroupCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EventLinkingCollectionsEventGroupCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return EventLinkingCollectionsEventGroupCollectionOrder2;
})(EventLinkingCollectionsEventGroupCollectionOrder || {});
var EventOrder = /* @__PURE__ */ ((EventOrder2) => {
  EventOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  EventOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  EventOrder2["EventNameAsc"] = "eventName_ASC";
  EventOrder2["EventNameDesc"] = "eventName_DESC";
  EventOrder2["LocationAsc"] = "location_ASC";
  EventOrder2["LocationDesc"] = "location_DESC";
  EventOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EventOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EventOrder2["SysIdAsc"] = "sys_id_ASC";
  EventOrder2["SysIdDesc"] = "sys_id_DESC";
  EventOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EventOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EventOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EventOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  EventOrder2["TimeAsc"] = "time_ASC";
  EventOrder2["TimeDesc"] = "time_DESC";
  return EventOrder2;
})(EventOrder || {});
var FaresTiersTncOrder = /* @__PURE__ */ ((FaresTiersTncOrder2) => {
  FaresTiersTncOrder2["AmendableRowAsc"] = "amendableRow_ASC";
  FaresTiersTncOrder2["AmendableRowDesc"] = "amendableRow_DESC";
  FaresTiersTncOrder2["MealRowAsc"] = "mealRow_ASC";
  FaresTiersTncOrder2["MealRowDesc"] = "mealRow_DESC";
  FaresTiersTncOrder2["PortFlexibilityRowAsc"] = "portFlexibilityRow_ASC";
  FaresTiersTncOrder2["PortFlexibilityRowDesc"] = "portFlexibilityRow_DESC";
  FaresTiersTncOrder2["PremiumLoungeRowAsc"] = "premiumLoungeRow_ASC";
  FaresTiersTncOrder2["PremiumLoungeRowDesc"] = "premiumLoungeRow_DESC";
  FaresTiersTncOrder2["PriorityBoardingRowAsc"] = "priorityBoardingRow_ASC";
  FaresTiersTncOrder2["PriorityBoardingRowDesc"] = "priorityBoardingRow_DESC";
  FaresTiersTncOrder2["RefundableRowAsc"] = "refundableRow_ASC";
  FaresTiersTncOrder2["RefundableRowDesc"] = "refundableRow_DESC";
  FaresTiersTncOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FaresTiersTncOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FaresTiersTncOrder2["SysIdAsc"] = "sys_id_ASC";
  FaresTiersTncOrder2["SysIdDesc"] = "sys_id_DESC";
  FaresTiersTncOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FaresTiersTncOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FaresTiersTncOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FaresTiersTncOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FaresTiersTncOrder2["Tier1AmendableAsc"] = "tier1Amendable_ASC";
  FaresTiersTncOrder2["Tier1AmendableDesc"] = "tier1Amendable_DESC";
  FaresTiersTncOrder2["Tier1MealAsc"] = "tier1Meal_ASC";
  FaresTiersTncOrder2["Tier1MealDesc"] = "tier1Meal_DESC";
  FaresTiersTncOrder2["Tier1NameAsc"] = "tier1Name_ASC";
  FaresTiersTncOrder2["Tier1NameDesc"] = "tier1Name_DESC";
  FaresTiersTncOrder2["Tier1PortFlexibilityAsc"] = "tier1PortFlexibility_ASC";
  FaresTiersTncOrder2["Tier1PortFlexibilityDesc"] = "tier1PortFlexibility_DESC";
  FaresTiersTncOrder2["Tier1PremiumLoungeAsc"] = "tier1PremiumLounge_ASC";
  FaresTiersTncOrder2["Tier1PremiumLoungeDesc"] = "tier1PremiumLounge_DESC";
  FaresTiersTncOrder2["Tier1PriorityBoardingAsc"] = "tier1PriorityBoarding_ASC";
  FaresTiersTncOrder2["Tier1PriorityBoardingDesc"] = "tier1PriorityBoarding_DESC";
  FaresTiersTncOrder2["Tier1RefundableAsc"] = "tier1Refundable_ASC";
  FaresTiersTncOrder2["Tier1RefundableDesc"] = "tier1Refundable_DESC";
  FaresTiersTncOrder2["Tier1WifiAsc"] = "tier1Wifi_ASC";
  FaresTiersTncOrder2["Tier1WifiDesc"] = "tier1Wifi_DESC";
  FaresTiersTncOrder2["Tier2AmendableAsc"] = "tier2Amendable_ASC";
  FaresTiersTncOrder2["Tier2AmendableDesc"] = "tier2Amendable_DESC";
  FaresTiersTncOrder2["Tier2MealAsc"] = "tier2Meal_ASC";
  FaresTiersTncOrder2["Tier2MealDesc"] = "tier2Meal_DESC";
  FaresTiersTncOrder2["Tier2NameAsc"] = "tier2Name_ASC";
  FaresTiersTncOrder2["Tier2NameDesc"] = "tier2Name_DESC";
  FaresTiersTncOrder2["Tier2PortFlexibilityAsc"] = "tier2PortFlexibility_ASC";
  FaresTiersTncOrder2["Tier2PortFlexibilityDesc"] = "tier2PortFlexibility_DESC";
  FaresTiersTncOrder2["Tier2PremiumLoungeAsc"] = "tier2PremiumLounge_ASC";
  FaresTiersTncOrder2["Tier2PremiumLoungeDesc"] = "tier2PremiumLounge_DESC";
  FaresTiersTncOrder2["Tier2PriorityBoardingAsc"] = "tier2PriorityBoarding_ASC";
  FaresTiersTncOrder2["Tier2PriorityBoardingDesc"] = "tier2PriorityBoarding_DESC";
  FaresTiersTncOrder2["Tier2RefundableAsc"] = "tier2Refundable_ASC";
  FaresTiersTncOrder2["Tier2RefundableDesc"] = "tier2Refundable_DESC";
  FaresTiersTncOrder2["Tier2WifiAsc"] = "tier2Wifi_ASC";
  FaresTiersTncOrder2["Tier2WifiDesc"] = "tier2Wifi_DESC";
  FaresTiersTncOrder2["Tier3AmendableAsc"] = "tier3Amendable_ASC";
  FaresTiersTncOrder2["Tier3AmendableDesc"] = "tier3Amendable_DESC";
  FaresTiersTncOrder2["Tier3MealAsc"] = "tier3Meal_ASC";
  FaresTiersTncOrder2["Tier3MealDesc"] = "tier3Meal_DESC";
  FaresTiersTncOrder2["Tier3NameAsc"] = "tier3Name_ASC";
  FaresTiersTncOrder2["Tier3NameDesc"] = "tier3Name_DESC";
  FaresTiersTncOrder2["Tier3PortFlexibilityAsc"] = "tier3PortFlexibility_ASC";
  FaresTiersTncOrder2["Tier3PortFlexibilityDesc"] = "tier3PortFlexibility_DESC";
  FaresTiersTncOrder2["Tier3PremiumLoungeAsc"] = "tier3PremiumLounge_ASC";
  FaresTiersTncOrder2["Tier3PremiumLoungeDesc"] = "tier3PremiumLounge_DESC";
  FaresTiersTncOrder2["Tier3PriorityBoardingAsc"] = "tier3PriorityBoarding_ASC";
  FaresTiersTncOrder2["Tier3PriorityBoardingDesc"] = "tier3PriorityBoarding_DESC";
  FaresTiersTncOrder2["Tier3RefundableAsc"] = "tier3Refundable_ASC";
  FaresTiersTncOrder2["Tier3RefundableDesc"] = "tier3Refundable_DESC";
  FaresTiersTncOrder2["Tier3WifiAsc"] = "tier3Wifi_ASC";
  FaresTiersTncOrder2["Tier3WifiDesc"] = "tier3Wifi_DESC";
  FaresTiersTncOrder2["TitleDesktopAsc"] = "titleDesktop_ASC";
  FaresTiersTncOrder2["TitleDesktopDesc"] = "titleDesktop_DESC";
  FaresTiersTncOrder2["TitleMobileAsc"] = "titleMobile_ASC";
  FaresTiersTncOrder2["TitleMobileDesc"] = "titleMobile_DESC";
  FaresTiersTncOrder2["WifiRowAsc"] = "wifiRow_ASC";
  FaresTiersTncOrder2["WifiRowDesc"] = "wifiRow_DESC";
  return FaresTiersTncOrder2;
})(FaresTiersTncOrder || {});
var FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder = /* @__PURE__ */ ((FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2) => {
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder2;
})(FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder || {});
var FeatureListItemOrder = /* @__PURE__ */ ((FeatureListItemOrder2) => {
  FeatureListItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListItemOrder2["IconAsc"] = "icon_ASC";
  FeatureListItemOrder2["IconDesc"] = "icon_DESC";
  FeatureListItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListItemOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListItemOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FeatureListItemOrder2["TitleAsc"] = "title_ASC";
  FeatureListItemOrder2["TitleDesc"] = "title_DESC";
  return FeatureListItemOrder2;
})(FeatureListItemOrder || {});
var FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder2;
})(FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder || {});
var FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder2;
})(FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder || {});
var FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var FeatureListSectionOrder = /* @__PURE__ */ ((FeatureListSectionOrder2) => {
  FeatureListSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  FeatureListSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  FeatureListSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  FeatureListSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  FeatureListSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FeatureListSectionOrder2;
})(FeatureListSectionOrder || {});
var FeatureListSectionSectionButtonsCollectionOrder = /* @__PURE__ */ ((FeatureListSectionSectionButtonsCollectionOrder2) => {
  FeatureListSectionSectionButtonsCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  FeatureListSectionSectionButtonsCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  FeatureListSectionSectionButtonsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListSectionSectionButtonsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListSectionSectionButtonsCollectionOrder2["IconAsc"] = "icon_ASC";
  FeatureListSectionSectionButtonsCollectionOrder2["IconDesc"] = "icon_DESC";
  FeatureListSectionSectionButtonsCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  FeatureListSectionSectionButtonsCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  FeatureListSectionSectionButtonsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListSectionSectionButtonsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListSectionSectionButtonsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListSectionSectionButtonsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListSectionSectionButtonsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListSectionSectionButtonsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListSectionSectionButtonsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListSectionSectionButtonsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FeatureListSectionSectionButtonsCollectionOrder2;
})(FeatureListSectionSectionButtonsCollectionOrder || {});
var FeatureListSectionSectionItemsCollectionOrder = /* @__PURE__ */ ((FeatureListSectionSectionItemsCollectionOrder2) => {
  FeatureListSectionSectionItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FeatureListSectionSectionItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FeatureListSectionSectionItemsCollectionOrder2["IconAsc"] = "icon_ASC";
  FeatureListSectionSectionItemsCollectionOrder2["IconDesc"] = "icon_DESC";
  FeatureListSectionSectionItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FeatureListSectionSectionItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FeatureListSectionSectionItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FeatureListSectionSectionItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FeatureListSectionSectionItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FeatureListSectionSectionItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FeatureListSectionSectionItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FeatureListSectionSectionItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FeatureListSectionSectionItemsCollectionOrder2["TitleAsc"] = "title_ASC";
  FeatureListSectionSectionItemsCollectionOrder2["TitleDesc"] = "title_DESC";
  return FeatureListSectionSectionItemsCollectionOrder2;
})(FeatureListSectionSectionItemsCollectionOrder || {});
var FerryCabinsCollectionOrder = /* @__PURE__ */ ((FerryCabinsCollectionOrder2) => {
  FerryCabinsCollectionOrder2["CabinTitleAsc"] = "cabinTitle_ASC";
  FerryCabinsCollectionOrder2["CabinTitleDesc"] = "cabinTitle_DESC";
  FerryCabinsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryCabinsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryCabinsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryCabinsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryCabinsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryCabinsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryCabinsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryCabinsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryCabinsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryCabinsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryCabinsCollectionOrder2;
})(FerryCabinsCollectionOrder || {});
var FerryEventGroupsCollectionOrder = /* @__PURE__ */ ((FerryEventGroupsCollectionOrder2) => {
  FerryEventGroupsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryEventGroupsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryEventGroupsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryEventGroupsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryEventGroupsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryEventGroupsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryEventGroupsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryEventGroupsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryEventGroupsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryEventGroupsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryEventGroupsCollectionOrder2;
})(FerryEventGroupsCollectionOrder || {});
var FerryFacilitiesCollectionOrder = /* @__PURE__ */ ((FerryFacilitiesCollectionOrder2) => {
  FerryFacilitiesCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryFacilitiesCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryFacilitiesCollectionOrder2["FacilityTypeAsc"] = "facilityType_ASC";
  FerryFacilitiesCollectionOrder2["FacilityTypeDesc"] = "facilityType_DESC";
  FerryFacilitiesCollectionOrder2["IdAsc"] = "id_ASC";
  FerryFacilitiesCollectionOrder2["IdDesc"] = "id_DESC";
  FerryFacilitiesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryFacilitiesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryFacilitiesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryFacilitiesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryFacilitiesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryFacilitiesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryFacilitiesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryFacilitiesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryFacilitiesCollectionOrder2;
})(FerryFacilitiesCollectionOrder || {});
var FerryFacilitiesLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((FerryFacilitiesLinkingCollectionsFerryCollectionOrder2) => {
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryFacilitiesLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryFacilitiesLinkingCollectionsFerryCollectionOrder2;
})(FerryFacilitiesLinkingCollectionsFerryCollectionOrder || {});
var FerryFacilitiesOrder = /* @__PURE__ */ ((FerryFacilitiesOrder2) => {
  FerryFacilitiesOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryFacilitiesOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryFacilitiesOrder2["FacilityTypeAsc"] = "facilityType_ASC";
  FerryFacilitiesOrder2["FacilityTypeDesc"] = "facilityType_DESC";
  FerryFacilitiesOrder2["IdAsc"] = "id_ASC";
  FerryFacilitiesOrder2["IdDesc"] = "id_DESC";
  FerryFacilitiesOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryFacilitiesOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryFacilitiesOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryFacilitiesOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryFacilitiesOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryFacilitiesOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryFacilitiesOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryFacilitiesOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryFacilitiesOrder2;
})(FerryFacilitiesOrder || {});
var FerryInstructionAndSignalisationCollectionOrder = /* @__PURE__ */ ((FerryInstructionAndSignalisationCollectionOrder2) => {
  FerryInstructionAndSignalisationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FerryInstructionAndSignalisationCollectionOrder2["TypeAsc"] = "type_ASC";
  FerryInstructionAndSignalisationCollectionOrder2["TypeDesc"] = "type_DESC";
  return FerryInstructionAndSignalisationCollectionOrder2;
})(FerryInstructionAndSignalisationCollectionOrder || {});
var FerryLinkingCollectionsPaxRouteCollectionOrder = /* @__PURE__ */ ((FerryLinkingCollectionsPaxRouteCollectionOrder2) => {
  FerryLinkingCollectionsPaxRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["NameAsc"] = "name_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["NameDesc"] = "name_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["PaxScheduleApiCodeIdAsc"] = "paxScheduleApiCodeId_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["PaxScheduleApiCodeIdDesc"] = "paxScheduleApiCodeId_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["RouteMarketingTitleAsc"] = "routeMarketingTitle_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["RouteMarketingTitleDesc"] = "routeMarketingTitle_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryLinkingCollectionsPaxRouteCollectionOrder2;
})(FerryLinkingCollectionsPaxRouteCollectionOrder || {});
var FerryOrder = /* @__PURE__ */ ((FerryOrder2) => {
  FerryOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryOrder2;
})(FerryOrder || {});
var FerryPetsInfoCollectionOrder = /* @__PURE__ */ ((FerryPetsInfoCollectionOrder2) => {
  FerryPetsInfoCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FerryPetsInfoCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FerryPetsInfoCollectionOrder2["IdAsc"] = "id_ASC";
  FerryPetsInfoCollectionOrder2["IdDesc"] = "id_DESC";
  FerryPetsInfoCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryPetsInfoCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryPetsInfoCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryPetsInfoCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryPetsInfoCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryPetsInfoCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryPetsInfoCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryPetsInfoCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FerryPetsInfoCollectionOrder2["TypeAsc"] = "type_ASC";
  FerryPetsInfoCollectionOrder2["TypeDesc"] = "type_DESC";
  return FerryPetsInfoCollectionOrder2;
})(FerryPetsInfoCollectionOrder || {});
var FerryRestaurantsCollectionOrder = /* @__PURE__ */ ((FerryRestaurantsCollectionOrder2) => {
  FerryRestaurantsCollectionOrder2["BannerLine1Asc"] = "bannerLine1_ASC";
  FerryRestaurantsCollectionOrder2["BannerLine1Desc"] = "bannerLine1_DESC";
  FerryRestaurantsCollectionOrder2["BannerLine2LargeAsc"] = "bannerLine2Large_ASC";
  FerryRestaurantsCollectionOrder2["BannerLine2LargeDesc"] = "bannerLine2Large_DESC";
  FerryRestaurantsCollectionOrder2["BannerLine2SmallAsc"] = "bannerLine2Small_ASC";
  FerryRestaurantsCollectionOrder2["BannerLine2SmallDesc"] = "bannerLine2Small_DESC";
  FerryRestaurantsCollectionOrder2["BannerLine3Asc"] = "bannerLine3_ASC";
  FerryRestaurantsCollectionOrder2["BannerLine3Desc"] = "bannerLine3_DESC";
  FerryRestaurantsCollectionOrder2["CloseButtonLightThemeAsc"] = "closeButtonLightTheme_ASC";
  FerryRestaurantsCollectionOrder2["CloseButtonLightThemeDesc"] = "closeButtonLightTheme_DESC";
  FerryRestaurantsCollectionOrder2["DefaultSeatingTimeAsc"] = "defaultSeatingTime_ASC";
  FerryRestaurantsCollectionOrder2["DefaultSeatingTimeDesc"] = "defaultSeatingTime_DESC";
  FerryRestaurantsCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  FerryRestaurantsCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  FerryRestaurantsCollectionOrder2["HighlightedAsc"] = "highlighted_ASC";
  FerryRestaurantsCollectionOrder2["HighlightedDesc"] = "highlighted_DESC";
  FerryRestaurantsCollectionOrder2["MenuBeveragesHeadlineAsc"] = "menuBeveragesHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuBeveragesHeadlineDesc"] = "menuBeveragesHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuCardForChildrenTitleAsc"] = "menuCardForChildrenTitle_ASC";
  FerryRestaurantsCollectionOrder2["MenuCardForChildrenTitleDesc"] = "menuCardForChildrenTitle_DESC";
  FerryRestaurantsCollectionOrder2["MenuCardTitleAsc"] = "menuCardTitle_ASC";
  FerryRestaurantsCollectionOrder2["MenuCardTitleDesc"] = "menuCardTitle_DESC";
  FerryRestaurantsCollectionOrder2["MenuDessertsHeadlineAsc"] = "menuDessertsHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuDessertsHeadlineDesc"] = "menuDessertsHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuForChildrenHeadlineAsc"] = "menuForChildrenHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuForChildrenHeadlineDesc"] = "menuForChildrenHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuMainCourseExtrasHeadlineAsc"] = "menuMainCourseExtrasHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuMainCourseExtrasHeadlineDesc"] = "menuMainCourseExtrasHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuMainCoursesExpandedAsc"] = "menuMainCoursesExpanded_ASC";
  FerryRestaurantsCollectionOrder2["MenuMainCoursesExpandedDesc"] = "menuMainCoursesExpanded_DESC";
  FerryRestaurantsCollectionOrder2["MenuMainCoursesHeadlineAsc"] = "menuMainCoursesHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuMainCoursesHeadlineDesc"] = "menuMainCoursesHeadline_DESC";
  FerryRestaurantsCollectionOrder2["MenuSectionsNoCollapseAsc"] = "menuSectionsNoCollapse_ASC";
  FerryRestaurantsCollectionOrder2["MenuSectionsNoCollapseDesc"] = "menuSectionsNoCollapse_DESC";
  FerryRestaurantsCollectionOrder2["MenuStartersExpandedAsc"] = "menuStartersExpanded_ASC";
  FerryRestaurantsCollectionOrder2["MenuStartersExpandedDesc"] = "menuStartersExpanded_DESC";
  FerryRestaurantsCollectionOrder2["MenuStartersHeadlineAsc"] = "menuStartersHeadline_ASC";
  FerryRestaurantsCollectionOrder2["MenuStartersHeadlineDesc"] = "menuStartersHeadline_DESC";
  FerryRestaurantsCollectionOrder2["RestaurantCodeAsc"] = "restaurantCode_ASC";
  FerryRestaurantsCollectionOrder2["RestaurantCodeDesc"] = "restaurantCode_DESC";
  FerryRestaurantsCollectionOrder2["RestaurantNameAsc"] = "restaurantName_ASC";
  FerryRestaurantsCollectionOrder2["RestaurantNameDesc"] = "restaurantName_DESC";
  FerryRestaurantsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FerryRestaurantsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FerryRestaurantsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FerryRestaurantsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FerryRestaurantsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FerryRestaurantsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FerryRestaurantsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FerryRestaurantsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FerryRestaurantsCollectionOrder2;
})(FerryRestaurantsCollectionOrder || {});
var FieldControllerLinkingCollectionsFormRowCollectionOrder = /* @__PURE__ */ ((FieldControllerLinkingCollectionsFormRowCollectionOrder2) => {
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldControllerLinkingCollectionsFormRowCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FieldControllerLinkingCollectionsFormRowCollectionOrder2;
})(FieldControllerLinkingCollectionsFormRowCollectionOrder || {});
var FieldControllerOrder = /* @__PURE__ */ ((FieldControllerOrder2) => {
  FieldControllerOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldControllerOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldControllerOrder2["QuestionAsc"] = "question_ASC";
  FieldControllerOrder2["QuestionDesc"] = "question_DESC";
  FieldControllerOrder2["RequiredAsc"] = "required_ASC";
  FieldControllerOrder2["RequiredDesc"] = "required_DESC";
  FieldControllerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldControllerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldControllerOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldControllerOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldControllerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldControllerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldControllerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldControllerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FieldControllerOrder2;
})(FieldControllerOrder || {});
var FieldLinkingCollectionsFieldControllerCollectionOrder = /* @__PURE__ */ ((FieldLinkingCollectionsFieldControllerCollectionOrder2) => {
  FieldLinkingCollectionsFieldControllerCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["QuestionAsc"] = "question_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["QuestionDesc"] = "question_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["RequiredAsc"] = "required_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["RequiredDesc"] = "required_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldLinkingCollectionsFieldControllerCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FieldLinkingCollectionsFieldControllerCollectionOrder2;
})(FieldLinkingCollectionsFieldControllerCollectionOrder || {});
var FieldOptionsCollectionOrder = /* @__PURE__ */ ((FieldOptionsCollectionOrder2) => {
  FieldOptionsCollectionOrder2["DisplayValueAsc"] = "displayValue_ASC";
  FieldOptionsCollectionOrder2["DisplayValueDesc"] = "displayValue_DESC";
  FieldOptionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldOptionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldOptionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldOptionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldOptionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldOptionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldOptionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldOptionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldOptionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldOptionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FieldOptionsCollectionOrder2["ValueAsc"] = "value_ASC";
  FieldOptionsCollectionOrder2["ValueDesc"] = "value_DESC";
  return FieldOptionsCollectionOrder2;
})(FieldOptionsCollectionOrder || {});
var FieldOrder = /* @__PURE__ */ ((FieldOrder2) => {
  FieldOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FieldOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FieldOrder2["CounterAsc"] = "counter_ASC";
  FieldOrder2["CounterDesc"] = "counter_DESC";
  FieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FieldOrder2["IdAsc"] = "id_ASC";
  FieldOrder2["IdDesc"] = "id_DESC";
  FieldOrder2["InputTypeAsc"] = "inputType_ASC";
  FieldOrder2["InputTypeDesc"] = "inputType_DESC";
  FieldOrder2["PlaceholderAsc"] = "placeholder_ASC";
  FieldOrder2["PlaceholderDesc"] = "placeholder_DESC";
  FieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FieldOrder2;
})(FieldOrder || {});
var FlowCabinFaresOrder = /* @__PURE__ */ ((FlowCabinFaresOrder2) => {
  FlowCabinFaresOrder2["DepartureDateAsc"] = "departureDate_ASC";
  FlowCabinFaresOrder2["DepartureDateDesc"] = "departureDate_DESC";
  FlowCabinFaresOrder2["HeadlineAsc"] = "headline_ASC";
  FlowCabinFaresOrder2["HeadlineDesc"] = "headline_DESC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupContinueButtonAsc"] = "moreThanOneCabinSelectedPopupContinueButton_ASC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupContinueButtonDesc"] = "moreThanOneCabinSelectedPopupContinueButton_DESC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupStayButtonAsc"] = "moreThanOneCabinSelectedPopupStayButton_ASC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupStayButtonDesc"] = "moreThanOneCabinSelectedPopupStayButton_DESC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupTitleAsc"] = "moreThanOneCabinSelectedPopupTitle_ASC";
  FlowCabinFaresOrder2["MoreThanOneCabinSelectedPopupTitleDesc"] = "moreThanOneCabinSelectedPopupTitle_DESC";
  FlowCabinFaresOrder2["NavigationDateFormatAsc"] = "navigationDateFormat_ASC";
  FlowCabinFaresOrder2["NavigationDateFormatDesc"] = "navigationDateFormat_DESC";
  FlowCabinFaresOrder2["NoDeparturesAsc"] = "noDepartures_ASC";
  FlowCabinFaresOrder2["NoDeparturesDesc"] = "noDepartures_DESC";
  FlowCabinFaresOrder2["NotAvailablePopupHeadingAsc"] = "notAvailablePopupHeading_ASC";
  FlowCabinFaresOrder2["NotAvailablePopupHeadingDesc"] = "notAvailablePopupHeading_DESC";
  FlowCabinFaresOrder2["NotAvailablePopupReloadAsc"] = "notAvailablePopupReload_ASC";
  FlowCabinFaresOrder2["NotAvailablePopupReloadDesc"] = "notAvailablePopupReload_DESC";
  FlowCabinFaresOrder2["ReturnDateAsc"] = "returnDate_ASC";
  FlowCabinFaresOrder2["ReturnDateDesc"] = "returnDate_DESC";
  FlowCabinFaresOrder2["SelectDateAsc"] = "selectDate_ASC";
  FlowCabinFaresOrder2["SelectDateDesc"] = "selectDate_DESC";
  FlowCabinFaresOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowCabinFaresOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowCabinFaresOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowCabinFaresOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowCabinFaresOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowCabinFaresOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowCabinFaresOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowCabinFaresOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FlowCabinFaresOrder2["TitleAsc"] = "title_ASC";
  FlowCabinFaresOrder2["TitleDesc"] = "title_DESC";
  return FlowCabinFaresOrder2;
})(FlowCabinFaresOrder || {});
var FlowCabinOrder = /* @__PURE__ */ ((FlowCabinOrder2) => {
  FlowCabinOrder2["NoCabinsAvailableAsc"] = "noCabinsAvailable_ASC";
  FlowCabinOrder2["NoCabinsAvailableDesc"] = "noCabinsAvailable_DESC";
  FlowCabinOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowCabinOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowCabinOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowCabinOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowCabinOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowCabinOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowCabinOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowCabinOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FlowCabinOrder2;
})(FlowCabinOrder || {});
var FlowFaresOrder = /* @__PURE__ */ ((FlowFaresOrder2) => {
  FlowFaresOrder2["AcceptAndContinueAsc"] = "acceptAndContinue_ASC";
  FlowFaresOrder2["AcceptAndContinueDesc"] = "acceptAndContinue_DESC";
  FlowFaresOrder2["DepartureDateAsc"] = "departureDate_ASC";
  FlowFaresOrder2["DepartureDateDesc"] = "departureDate_DESC";
  FlowFaresOrder2["ReturnDateAsc"] = "returnDate_ASC";
  FlowFaresOrder2["ReturnDateDesc"] = "returnDate_DESC";
  FlowFaresOrder2["SelectDateAsc"] = "selectDate_ASC";
  FlowFaresOrder2["SelectDateDesc"] = "selectDate_DESC";
  FlowFaresOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowFaresOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowFaresOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowFaresOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowFaresOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowFaresOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowFaresOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowFaresOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FlowFaresOrder2["Tier3CategoryChangedHeaderAsc"] = "tier3CategoryChangedHeader_ASC";
  FlowFaresOrder2["Tier3CategoryChangedHeaderDesc"] = "tier3CategoryChangedHeader_DESC";
  FlowFaresOrder2["Tier3CategoryChangedAsc"] = "tier3CategoryChanged_ASC";
  FlowFaresOrder2["Tier3CategoryChangedDesc"] = "tier3CategoryChanged_DESC";
  FlowFaresOrder2["Tier3WhatIsIncludedAsc"] = "tier3WhatIsIncluded_ASC";
  FlowFaresOrder2["Tier3WhatIsIncludedDesc"] = "tier3WhatIsIncluded_DESC";
  return FlowFaresOrder2;
})(FlowFaresOrder || {});
var FlowMealsOrder = /* @__PURE__ */ ((FlowMealsOrder2) => {
  FlowMealsOrder2["NoMealsAvailableAsc"] = "noMealsAvailable_ASC";
  FlowMealsOrder2["NoMealsAvailableDesc"] = "noMealsAvailable_DESC";
  FlowMealsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowMealsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowMealsOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowMealsOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowMealsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowMealsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowMealsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowMealsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FlowMealsOrder2;
})(FlowMealsOrder || {});
var FlowTravelOrder = /* @__PURE__ */ ((FlowTravelOrder2) => {
  FlowTravelOrder2["OnewayAsc"] = "oneway_ASC";
  FlowTravelOrder2["OnewayDesc"] = "oneway_DESC";
  FlowTravelOrder2["PetParameterRequiresVehicleAsc"] = "petParameterRequiresVehicle_ASC";
  FlowTravelOrder2["PetParameterRequiresVehicleDesc"] = "petParameterRequiresVehicle_DESC";
  FlowTravelOrder2["ReturnAsc"] = "return_ASC";
  FlowTravelOrder2["ReturnDesc"] = "return_DESC";
  FlowTravelOrder2["SelectDateAsc"] = "selectDate_ASC";
  FlowTravelOrder2["SelectDateDesc"] = "selectDate_DESC";
  FlowTravelOrder2["SelectedDateNotAvailableAsc"] = "selectedDateNotAvailable_ASC";
  FlowTravelOrder2["SelectedDateNotAvailableDesc"] = "selectedDateNotAvailable_DESC";
  FlowTravelOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FlowTravelOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FlowTravelOrder2["SysIdAsc"] = "sys_id_ASC";
  FlowTravelOrder2["SysIdDesc"] = "sys_id_DESC";
  FlowTravelOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FlowTravelOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FlowTravelOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FlowTravelOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FlowTravelOrder2["VehicleParameterRequiresTrailerTypeAsc"] = "vehicleParameterRequiresTrailerType_ASC";
  FlowTravelOrder2["VehicleParameterRequiresTrailerTypeDesc"] = "vehicleParameterRequiresTrailerType_DESC";
  return FlowTravelOrder2;
})(FlowTravelOrder || {});
var FooterColumnsCollectionOrder = /* @__PURE__ */ ((FooterColumnsCollectionOrder2) => {
  FooterColumnsCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  FooterColumnsCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  FooterColumnsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FooterColumnsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FooterColumnsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FooterColumnsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FooterColumnsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FooterColumnsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FooterColumnsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FooterColumnsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FooterColumnsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FooterColumnsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FooterColumnsCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  FooterColumnsCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return FooterColumnsCollectionOrder2;
})(FooterColumnsCollectionOrder || {});
var FooterOrder = /* @__PURE__ */ ((FooterOrder2) => {
  FooterOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  FooterOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  FooterOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FooterOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FooterOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  FooterOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  FooterOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FooterOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FooterOrder2["SysIdAsc"] = "sys_id_ASC";
  FooterOrder2["SysIdDesc"] = "sys_id_DESC";
  FooterOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FooterOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FooterOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FooterOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FooterOrder2;
})(FooterOrder || {});
var FormCheckboxFieldOrder = /* @__PURE__ */ ((FormCheckboxFieldOrder2) => {
  FormCheckboxFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormCheckboxFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormCheckboxFieldOrder2["RequiredAsc"] = "required_ASC";
  FormCheckboxFieldOrder2["RequiredDesc"] = "required_DESC";
  FormCheckboxFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormCheckboxFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormCheckboxFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormCheckboxFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormCheckboxFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormCheckboxFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormCheckboxFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormCheckboxFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormCheckboxFieldOrder2["TitleAsc"] = "title_ASC";
  FormCheckboxFieldOrder2["TitleDesc"] = "title_DESC";
  return FormCheckboxFieldOrder2;
})(FormCheckboxFieldOrder || {});
var FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2) => {
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2;
})(FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder || {});
var FormConsentCheckboxFieldOrder = /* @__PURE__ */ ((FormConsentCheckboxFieldOrder2) => {
  FormConsentCheckboxFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormConsentCheckboxFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormConsentCheckboxFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormConsentCheckboxFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormConsentCheckboxFieldOrder2["NameAsc"] = "name_ASC";
  FormConsentCheckboxFieldOrder2["NameDesc"] = "name_DESC";
  FormConsentCheckboxFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormConsentCheckboxFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormConsentCheckboxFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormConsentCheckboxFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormConsentCheckboxFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormConsentCheckboxFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormConsentCheckboxFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormConsentCheckboxFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormConsentCheckboxFieldOrder2;
})(FormConsentCheckboxFieldOrder || {});
var FormInputFieldOrder = /* @__PURE__ */ ((FormInputFieldOrder2) => {
  FormInputFieldOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormInputFieldOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormInputFieldOrder2["DefaultValueAsc"] = "defaultValue_ASC";
  FormInputFieldOrder2["DefaultValueDesc"] = "defaultValue_DESC";
  FormInputFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormInputFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormInputFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormInputFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormInputFieldOrder2["HintTextAsc"] = "hintText_ASC";
  FormInputFieldOrder2["HintTextDesc"] = "hintText_DESC";
  FormInputFieldOrder2["KeyAsc"] = "key_ASC";
  FormInputFieldOrder2["KeyDesc"] = "key_DESC";
  FormInputFieldOrder2["LabelAsc"] = "label_ASC";
  FormInputFieldOrder2["LabelDesc"] = "label_DESC";
  FormInputFieldOrder2["NameAsc"] = "name_ASC";
  FormInputFieldOrder2["NameDesc"] = "name_DESC";
  FormInputFieldOrder2["RequiredAsc"] = "required_ASC";
  FormInputFieldOrder2["RequiredDesc"] = "required_DESC";
  FormInputFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormInputFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormInputFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormInputFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormInputFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormInputFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormInputFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormInputFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormInputFieldOrder2["TypeAsc"] = "type_ASC";
  FormInputFieldOrder2["TypeDesc"] = "type_DESC";
  return FormInputFieldOrder2;
})(FormInputFieldOrder || {});
var FormLinkingCollectionsAppSectionCollectionOrder = /* @__PURE__ */ ((FormLinkingCollectionsAppSectionCollectionOrder2) => {
  FormLinkingCollectionsAppSectionCollectionOrder2["AppTypeAsc"] = "appType_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["AppTypeDesc"] = "appType_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormLinkingCollectionsAppSectionCollectionOrder2;
})(FormLinkingCollectionsAppSectionCollectionOrder || {});
var FormLinkingCollectionsFormSectionCollectionOrder = /* @__PURE__ */ ((FormLinkingCollectionsFormSectionCollectionOrder2) => {
  FormLinkingCollectionsFormSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormLinkingCollectionsFormSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormLinkingCollectionsFormSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormLinkingCollectionsFormSectionCollectionOrder2;
})(FormLinkingCollectionsFormSectionCollectionOrder || {});
var FormMarkdownFieldLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormMarkdownFieldLinkingCollectionsFormCollectionOrder2) => {
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormMarkdownFieldLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormMarkdownFieldLinkingCollectionsFormCollectionOrder2;
})(FormMarkdownFieldLinkingCollectionsFormCollectionOrder || {});
var FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder = /* @__PURE__ */ ((FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2) => {
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder2;
})(FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder || {});
var FormMarkdownFieldOrder = /* @__PURE__ */ ((FormMarkdownFieldOrder2) => {
  FormMarkdownFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMarkdownFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMarkdownFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMarkdownFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMarkdownFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMarkdownFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMarkdownFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMarkdownFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMarkdownFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMarkdownFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormMarkdownFieldOrder2;
})(FormMarkdownFieldOrder || {});
var FormMessageLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormMessageLinkingCollectionsFormCollectionOrder2) => {
  FormMessageLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormMessageLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormMessageLinkingCollectionsFormCollectionOrder2;
})(FormMessageLinkingCollectionsFormCollectionOrder || {});
var FormMessageOrder = /* @__PURE__ */ ((FormMessageOrder2) => {
  FormMessageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormMessageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormMessageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormMessageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormMessageOrder2["SysIdAsc"] = "sys_id_ASC";
  FormMessageOrder2["SysIdDesc"] = "sys_id_DESC";
  FormMessageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormMessageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormMessageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormMessageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormMessageOrder2;
})(FormMessageOrder || {});
var FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2) => {
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder2;
})(FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder || {});
var FormOptionalConsentCheckboxFieldOrder = /* @__PURE__ */ ((FormOptionalConsentCheckboxFieldOrder2) => {
  FormOptionalConsentCheckboxFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormOptionalConsentCheckboxFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormOptionalConsentCheckboxFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormOptionalConsentCheckboxFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormOptionalConsentCheckboxFieldOrder2["NameAsc"] = "name_ASC";
  FormOptionalConsentCheckboxFieldOrder2["NameDesc"] = "name_DESC";
  FormOptionalConsentCheckboxFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormOptionalConsentCheckboxFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormOptionalConsentCheckboxFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormOptionalConsentCheckboxFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormOptionalConsentCheckboxFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormOptionalConsentCheckboxFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormOptionalConsentCheckboxFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormOptionalConsentCheckboxFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormOptionalConsentCheckboxFieldOrder2;
})(FormOptionalConsentCheckboxFieldOrder || {});
var FormOrder = /* @__PURE__ */ ((FormOrder2) => {
  FormOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormOrder2["SysIdAsc"] = "sys_id_ASC";
  FormOrder2["SysIdDesc"] = "sys_id_DESC";
  FormOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormOrder2;
})(FormOrder || {});
var FormRatingFieldOrder = /* @__PURE__ */ ((FormRatingFieldOrder2) => {
  FormRatingFieldOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormRatingFieldOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormRatingFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormRatingFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormRatingFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormRatingFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormRatingFieldOrder2["LabelAsc"] = "label_ASC";
  FormRatingFieldOrder2["LabelDesc"] = "label_DESC";
  FormRatingFieldOrder2["NameAsc"] = "name_ASC";
  FormRatingFieldOrder2["NameDesc"] = "name_DESC";
  FormRatingFieldOrder2["RatingCountAsc"] = "ratingCount_ASC";
  FormRatingFieldOrder2["RatingCountDesc"] = "ratingCount_DESC";
  FormRatingFieldOrder2["RequiredAsc"] = "required_ASC";
  FormRatingFieldOrder2["RequiredDesc"] = "required_DESC";
  FormRatingFieldOrder2["ShowScaleLabelsAsc"] = "showScaleLabels_ASC";
  FormRatingFieldOrder2["ShowScaleLabelsDesc"] = "showScaleLabels_DESC";
  FormRatingFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormRatingFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormRatingFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormRatingFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormRatingFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormRatingFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormRatingFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormRatingFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormRatingFieldOrder2["TypeAsc"] = "type_ASC";
  FormRatingFieldOrder2["TypeDesc"] = "type_DESC";
  return FormRatingFieldOrder2;
})(FormRatingFieldOrder || {});
var FormRowLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormRowLinkingCollectionsFormCollectionOrder2) => {
  FormRowLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormRowLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormRowLinkingCollectionsFormCollectionOrder2;
})(FormRowLinkingCollectionsFormCollectionOrder || {});
var FormRowOrder = /* @__PURE__ */ ((FormRowOrder2) => {
  FormRowOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormRowOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormRowOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormRowOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormRowOrder2["SysIdAsc"] = "sys_id_ASC";
  FormRowOrder2["SysIdDesc"] = "sys_id_DESC";
  FormRowOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormRowOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormRowOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormRowOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormRowOrder2;
})(FormRowOrder || {});
var FormSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(FormSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var FormSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(FormSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var FormSectionOrder = /* @__PURE__ */ ((FormSectionOrder2) => {
  FormSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  FormSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  FormSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  FormSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  FormSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormSectionOrder2;
})(FormSectionOrder || {});
var FormSelectFieldOptionsCollectionOrder = /* @__PURE__ */ ((FormSelectFieldOptionsCollectionOrder2) => {
  FormSelectFieldOptionsCollectionOrder2["DisplayValueAsc"] = "displayValue_ASC";
  FormSelectFieldOptionsCollectionOrder2["DisplayValueDesc"] = "displayValue_DESC";
  FormSelectFieldOptionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectFieldOptionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectFieldOptionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectFieldOptionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectFieldOptionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectFieldOptionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectFieldOptionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectFieldOptionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectFieldOptionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectFieldOptionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSelectFieldOptionsCollectionOrder2["ValueAsc"] = "value_ASC";
  FormSelectFieldOptionsCollectionOrder2["ValueDesc"] = "value_DESC";
  return FormSelectFieldOptionsCollectionOrder2;
})(FormSelectFieldOptionsCollectionOrder || {});
var FormSelectFieldOrder = /* @__PURE__ */ ((FormSelectFieldOrder2) => {
  FormSelectFieldOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormSelectFieldOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormSelectFieldOrder2["DefaultValueAsc"] = "defaultValue_ASC";
  FormSelectFieldOrder2["DefaultValueDesc"] = "defaultValue_DESC";
  FormSelectFieldOrder2["DisabledAsc"] = "disabled_ASC";
  FormSelectFieldOrder2["DisabledDesc"] = "disabled_DESC";
  FormSelectFieldOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectFieldOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectFieldOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormSelectFieldOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormSelectFieldOrder2["KeyAsc"] = "key_ASC";
  FormSelectFieldOrder2["KeyDesc"] = "key_DESC";
  FormSelectFieldOrder2["LabelAsc"] = "label_ASC";
  FormSelectFieldOrder2["LabelDesc"] = "label_DESC";
  FormSelectFieldOrder2["RequiredAsc"] = "required_ASC";
  FormSelectFieldOrder2["RequiredDesc"] = "required_DESC";
  FormSelectFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSelectFieldOrder2["TypeAsc"] = "type_ASC";
  FormSelectFieldOrder2["TypeDesc"] = "type_DESC";
  return FormSelectFieldOrder2;
})(FormSelectFieldOrder || {});
var FormSelectOptionLinkingCollectionsFieldCollectionOrder = /* @__PURE__ */ ((FormSelectOptionLinkingCollectionsFieldCollectionOrder2) => {
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["CounterAsc"] = "counter_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["CounterDesc"] = "counter_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["IdAsc"] = "id_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["IdDesc"] = "id_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["InputTypeAsc"] = "inputType_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["InputTypeDesc"] = "inputType_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["PlaceholderAsc"] = "placeholder_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["PlaceholderDesc"] = "placeholder_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectOptionLinkingCollectionsFieldCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormSelectOptionLinkingCollectionsFieldCollectionOrder2;
})(FormSelectOptionLinkingCollectionsFieldCollectionOrder || {});
var FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder = /* @__PURE__ */ ((FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2) => {
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["AssistiveTextAsc"] = "assistiveText_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["AssistiveTextDesc"] = "assistiveText_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["DefaultValueAsc"] = "defaultValue_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["DefaultValueDesc"] = "defaultValue_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["DisabledAsc"] = "disabled_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["DisabledDesc"] = "disabled_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["ErrorMessageAsc"] = "errorMessage_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["ErrorMessageDesc"] = "errorMessage_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["KeyAsc"] = "key_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["KeyDesc"] = "key_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["LabelAsc"] = "label_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["LabelDesc"] = "label_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["RequiredAsc"] = "required_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["RequiredDesc"] = "required_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["TypeAsc"] = "type_ASC";
  FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2["TypeDesc"] = "type_DESC";
  return FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder2;
})(FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder || {});
var FormSelectOptionOrder = /* @__PURE__ */ ((FormSelectOptionOrder2) => {
  FormSelectOptionOrder2["DisplayValueAsc"] = "displayValue_ASC";
  FormSelectOptionOrder2["DisplayValueDesc"] = "displayValue_DESC";
  FormSelectOptionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSelectOptionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSelectOptionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSelectOptionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSelectOptionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSelectOptionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSelectOptionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSelectOptionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSelectOptionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSelectOptionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSelectOptionOrder2["ValueAsc"] = "value_ASC";
  FormSelectOptionOrder2["ValueDesc"] = "value_DESC";
  return FormSelectOptionOrder2;
})(FormSelectOptionOrder || {});
var FormSubmitButtonLinkingCollectionsFormCollectionOrder = /* @__PURE__ */ ((FormSubmitButtonLinkingCollectionsFormCollectionOrder2) => {
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeAsc"] = "trackingConversionType_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingConversionTypeDesc"] = "trackingConversionType_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingNameAsc"] = "trackingName_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingNameDesc"] = "trackingName_DESC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  FormSubmitButtonLinkingCollectionsFormCollectionOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return FormSubmitButtonLinkingCollectionsFormCollectionOrder2;
})(FormSubmitButtonLinkingCollectionsFormCollectionOrder || {});
var FormSubmitButtonOrder = /* @__PURE__ */ ((FormSubmitButtonOrder2) => {
  FormSubmitButtonOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FormSubmitButtonOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FormSubmitButtonOrder2["LabelAsc"] = "label_ASC";
  FormSubmitButtonOrder2["LabelDesc"] = "label_DESC";
  FormSubmitButtonOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FormSubmitButtonOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FormSubmitButtonOrder2["SysIdAsc"] = "sys_id_ASC";
  FormSubmitButtonOrder2["SysIdDesc"] = "sys_id_DESC";
  FormSubmitButtonOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FormSubmitButtonOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FormSubmitButtonOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FormSubmitButtonOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FormSubmitButtonOrder2;
})(FormSubmitButtonOrder || {});
var FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder = /* @__PURE__ */ ((FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2) => {
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder2;
})(FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder || {});
var FreightTerminalOrder = /* @__PURE__ */ ((FreightTerminalOrder2) => {
  FreightTerminalOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  FreightTerminalOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  FreightTerminalOrder2["NameAsc"] = "name_ASC";
  FreightTerminalOrder2["NameDesc"] = "name_DESC";
  FreightTerminalOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  FreightTerminalOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  FreightTerminalOrder2["SysIdAsc"] = "sys_id_ASC";
  FreightTerminalOrder2["SysIdDesc"] = "sys_id_DESC";
  FreightTerminalOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  FreightTerminalOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  FreightTerminalOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  FreightTerminalOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  FreightTerminalOrder2["TerminalIdAsc"] = "terminalId_ASC";
  FreightTerminalOrder2["TerminalIdDesc"] = "terminalId_DESC";
  return FreightTerminalOrder2;
})(FreightTerminalOrder || {});
var GdprSettingsOrder = /* @__PURE__ */ ((GdprSettingsOrder2) => {
  GdprSettingsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  GdprSettingsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  GdprSettingsOrder2["FormCheckboxLabelAsc"] = "formCheckboxLabel_ASC";
  GdprSettingsOrder2["FormCheckboxLabelDesc"] = "formCheckboxLabel_DESC";
  GdprSettingsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  GdprSettingsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  GdprSettingsOrder2["SysIdAsc"] = "sys_id_ASC";
  GdprSettingsOrder2["SysIdDesc"] = "sys_id_DESC";
  GdprSettingsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  GdprSettingsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  GdprSettingsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  GdprSettingsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return GdprSettingsOrder2;
})(GdprSettingsOrder || {});
var GenericRouteOrder = /* @__PURE__ */ ((GenericRouteOrder2) => {
  GenericRouteOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  GenericRouteOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  GenericRouteOrder2["RouteCodeAsc"] = "routeCode_ASC";
  GenericRouteOrder2["RouteCodeDesc"] = "routeCode_DESC";
  GenericRouteOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  GenericRouteOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  GenericRouteOrder2["SysIdAsc"] = "sys_id_ASC";
  GenericRouteOrder2["SysIdDesc"] = "sys_id_DESC";
  GenericRouteOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  GenericRouteOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  GenericRouteOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  GenericRouteOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return GenericRouteOrder2;
})(GenericRouteOrder || {});
var HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var HeroPromotionalSectionOrder = /* @__PURE__ */ ((HeroPromotionalSectionOrder2) => {
  HeroPromotionalSectionOrder2["BadgeAsc"] = "badge_ASC";
  HeroPromotionalSectionOrder2["BadgeDesc"] = "badge_DESC";
  HeroPromotionalSectionOrder2["CurrencyAsc"] = "currency_ASC";
  HeroPromotionalSectionOrder2["CurrencyDesc"] = "currency_DESC";
  HeroPromotionalSectionOrder2["DiscountAsc"] = "discount_ASC";
  HeroPromotionalSectionOrder2["DiscountDesc"] = "discount_DESC";
  HeroPromotionalSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroPromotionalSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroPromotionalSectionOrder2["EyebrowAsc"] = "eyebrow_ASC";
  HeroPromotionalSectionOrder2["EyebrowDesc"] = "eyebrow_DESC";
  HeroPromotionalSectionOrder2["PriceAsc"] = "price_ASC";
  HeroPromotionalSectionOrder2["PriceDesc"] = "price_DESC";
  HeroPromotionalSectionOrder2["SuffixAsc"] = "suffix_ASC";
  HeroPromotionalSectionOrder2["SuffixDesc"] = "suffix_DESC";
  HeroPromotionalSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroPromotionalSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroPromotionalSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroPromotionalSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroPromotionalSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroPromotionalSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroPromotionalSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroPromotionalSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  HeroPromotionalSectionOrder2["TitleAsc"] = "title_ASC";
  HeroPromotionalSectionOrder2["TitleDesc"] = "title_DESC";
  return HeroPromotionalSectionOrder2;
})(HeroPromotionalSectionOrder || {});
var HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder2;
})(HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder || {});
var HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var HeroSectionLinksCollectionOrder = /* @__PURE__ */ ((HeroSectionLinksCollectionOrder2) => {
  HeroSectionLinksCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  HeroSectionLinksCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  HeroSectionLinksCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionLinksCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionLinksCollectionOrder2["IconAsc"] = "icon_ASC";
  HeroSectionLinksCollectionOrder2["IconDesc"] = "icon_DESC";
  HeroSectionLinksCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  HeroSectionLinksCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  HeroSectionLinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionLinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionLinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionLinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionLinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionLinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionLinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionLinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroSectionLinksCollectionOrder2;
})(HeroSectionLinksCollectionOrder || {});
var HeroSectionOrder = /* @__PURE__ */ ((HeroSectionOrder2) => {
  HeroSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  HeroSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  HeroSectionOrder2["EyebrowAsc"] = "eyebrow_ASC";
  HeroSectionOrder2["EyebrowDesc"] = "eyebrow_DESC";
  HeroSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  HeroSectionOrder2["TitleAsc"] = "title_ASC";
  HeroSectionOrder2["TitleDesc"] = "title_DESC";
  return HeroSectionOrder2;
})(HeroSectionOrder || {});
var ImageFormat = /* @__PURE__ */ ((ImageFormat2) => {
  ImageFormat2["Avif"] = "AVIF";
  ImageFormat2["Jpg"] = "JPG";
  ImageFormat2["JpgProgressive"] = "JPG_PROGRESSIVE";
  ImageFormat2["Png"] = "PNG";
  ImageFormat2["Png8"] = "PNG8";
  ImageFormat2["Webp"] = "WEBP";
  return ImageFormat2;
})(ImageFormat || {});
var ImageResizeFocus = /* @__PURE__ */ ((ImageResizeFocus2) => {
  ImageResizeFocus2["Bottom"] = "BOTTOM";
  ImageResizeFocus2["BottomLeft"] = "BOTTOM_LEFT";
  ImageResizeFocus2["BottomRight"] = "BOTTOM_RIGHT";
  ImageResizeFocus2["Center"] = "CENTER";
  ImageResizeFocus2["Face"] = "FACE";
  ImageResizeFocus2["Faces"] = "FACES";
  ImageResizeFocus2["Left"] = "LEFT";
  ImageResizeFocus2["Right"] = "RIGHT";
  ImageResizeFocus2["Top"] = "TOP";
  ImageResizeFocus2["TopLeft"] = "TOP_LEFT";
  ImageResizeFocus2["TopRight"] = "TOP_RIGHT";
  return ImageResizeFocus2;
})(ImageResizeFocus || {});
var ImageResizeStrategy = /* @__PURE__ */ ((ImageResizeStrategy2) => {
  ImageResizeStrategy2["Crop"] = "CROP";
  ImageResizeStrategy2["Fill"] = "FILL";
  ImageResizeStrategy2["Fit"] = "FIT";
  ImageResizeStrategy2["Pad"] = "PAD";
  ImageResizeStrategy2["Scale"] = "SCALE";
  ImageResizeStrategy2["Thumb"] = "THUMB";
  return ImageResizeStrategy2;
})(ImageResizeStrategy || {});
var InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2) => {
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder2;
})(InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder || {});
var InstructionAndSignalisationOrder = /* @__PURE__ */ ((InstructionAndSignalisationOrder2) => {
  InstructionAndSignalisationOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  InstructionAndSignalisationOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  InstructionAndSignalisationOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  InstructionAndSignalisationOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  InstructionAndSignalisationOrder2["SysIdAsc"] = "sys_id_ASC";
  InstructionAndSignalisationOrder2["SysIdDesc"] = "sys_id_DESC";
  InstructionAndSignalisationOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  InstructionAndSignalisationOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  InstructionAndSignalisationOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  InstructionAndSignalisationOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  InstructionAndSignalisationOrder2["TypeAsc"] = "type_ASC";
  InstructionAndSignalisationOrder2["TypeDesc"] = "type_DESC";
  return InstructionAndSignalisationOrder2;
})(InstructionAndSignalisationOrder || {});
var KeyValuePairCollectionItemsCollectionOrder = /* @__PURE__ */ ((KeyValuePairCollectionItemsCollectionOrder2) => {
  KeyValuePairCollectionItemsCollectionOrder2["KeyAsc"] = "key_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["KeyDesc"] = "key_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  KeyValuePairCollectionItemsCollectionOrder2["ValueAsc"] = "value_ASC";
  KeyValuePairCollectionItemsCollectionOrder2["ValueDesc"] = "value_DESC";
  return KeyValuePairCollectionItemsCollectionOrder2;
})(KeyValuePairCollectionItemsCollectionOrder || {});
var KeyValuePairCollectionOrder = /* @__PURE__ */ ((KeyValuePairCollectionOrder2) => {
  KeyValuePairCollectionOrder2["CollectionNameAsc"] = "collectionName_ASC";
  KeyValuePairCollectionOrder2["CollectionNameDesc"] = "collectionName_DESC";
  KeyValuePairCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  KeyValuePairCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  KeyValuePairCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  KeyValuePairCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  KeyValuePairCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  KeyValuePairCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  KeyValuePairCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  KeyValuePairCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return KeyValuePairCollectionOrder2;
})(KeyValuePairCollectionOrder || {});
var KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder = /* @__PURE__ */ ((KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2) => {
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["CollectionNameAsc"] = "collectionName_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["CollectionNameDesc"] = "collectionName_DESC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder2;
})(KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder || {});
var LinkLinkingCollectionsBannerCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsBannerCollectionOrder2) => {
  LinkLinkingCollectionsBannerCollectionOrder2["EnabledAsc"] = "enabled_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["EnabledDesc"] = "enabled_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["EntityNameAsc"] = "entityName_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["EntityNameDesc"] = "entityName_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkLinkingCollectionsBannerCollectionOrder2["TextAsc"] = "text_ASC";
  LinkLinkingCollectionsBannerCollectionOrder2["TextDesc"] = "text_DESC";
  return LinkLinkingCollectionsBannerCollectionOrder2;
})(LinkLinkingCollectionsBannerCollectionOrder || {});
var LinkLinkingCollectionsContentBlockCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsContentBlockCollectionOrder2) => {
  LinkLinkingCollectionsContentBlockCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["ImageDisplayOptionsAsc"] = "imageDisplayOptions_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["ImageDisplayOptionsDesc"] = "imageDisplayOptions_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["MediaTypeAsc"] = "mediaType_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["MediaTypeDesc"] = "mediaType_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["TertiaryTextAsc"] = "tertiaryText_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["TertiaryTextDesc"] = "tertiaryText_DESC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  LinkLinkingCollectionsContentBlockCollectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return LinkLinkingCollectionsContentBlockCollectionOrder2;
})(LinkLinkingCollectionsContentBlockCollectionOrder || {});
var LinkLinkingCollectionsFooterCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsFooterCollectionOrder2) => {
  LinkLinkingCollectionsFooterCollectionOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsFooterCollectionOrder2;
})(LinkLinkingCollectionsFooterCollectionOrder || {});
var LinkLinkingCollectionsGdprSettingsCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsGdprSettingsCollectionOrder2) => {
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["FormCheckboxLabelAsc"] = "formCheckboxLabel_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["FormCheckboxLabelDesc"] = "formCheckboxLabel_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsGdprSettingsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsGdprSettingsCollectionOrder2;
})(LinkLinkingCollectionsGdprSettingsCollectionOrder || {});
var LinkLinkingCollectionsLinksListCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsLinksListCollectionOrder2) => {
  LinkLinkingCollectionsLinksListCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["LinksListTitleAsc"] = "linksListTitle_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["LinksListTitleDesc"] = "linksListTitle_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsLinksListCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsLinksListCollectionOrder2;
})(LinkLinkingCollectionsLinksListCollectionOrder || {});
var LinkLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsNavigationCollectionOrder2) => {
  LinkLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsNavigationCollectionOrder2;
})(LinkLinkingCollectionsNavigationCollectionOrder || {});
var LinkLinkingCollectionsNavigationItemCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsNavigationItemCollectionOrder2) => {
  LinkLinkingCollectionsNavigationItemCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  LinkLinkingCollectionsNavigationItemCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return LinkLinkingCollectionsNavigationItemCollectionOrder2;
})(LinkLinkingCollectionsNavigationItemCollectionOrder || {});
var LinkLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((LinkLinkingCollectionsPageSectionCollectionOrder2) => {
  LinkLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkLinkingCollectionsPageSectionCollectionOrder2;
})(LinkLinkingCollectionsPageSectionCollectionOrder || {});
var LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var LinkListSectionOrder = /* @__PURE__ */ ((LinkListSectionOrder2) => {
  LinkListSectionOrder2["ColumnsAsc"] = "columns_ASC";
  LinkListSectionOrder2["ColumnsDesc"] = "columns_DESC";
  LinkListSectionOrder2["DescriptionAsc"] = "description_ASC";
  LinkListSectionOrder2["DescriptionDesc"] = "description_DESC";
  LinkListSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkListSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkListSectionOrder2["SectionHeadingAsc"] = "sectionHeading_ASC";
  LinkListSectionOrder2["SectionHeadingDesc"] = "sectionHeading_DESC";
  LinkListSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkListSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkListSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkListSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkListSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkListSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkListSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkListSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkListSectionOrder2;
})(LinkListSectionOrder || {});
var LinkListSectionSubsectionsCollectionOrder = /* @__PURE__ */ ((LinkListSectionSubsectionsCollectionOrder2) => {
  LinkListSectionSubsectionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkListSectionSubsectionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkListSectionSubsectionsCollectionOrder2["HeadingAsc"] = "heading_ASC";
  LinkListSectionSubsectionsCollectionOrder2["HeadingDesc"] = "heading_DESC";
  LinkListSectionSubsectionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkListSectionSubsectionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkListSectionSubsectionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkListSectionSubsectionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkListSectionSubsectionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkListSectionSubsectionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkListSectionSubsectionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkListSectionSubsectionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkListSectionSubsectionsCollectionOrder2;
})(LinkListSectionSubsectionsCollectionOrder || {});
var LinkListSubsectionLinkItemsCollectionOrder = /* @__PURE__ */ ((LinkListSubsectionLinkItemsCollectionOrder2) => {
  LinkListSubsectionLinkItemsCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinkListSubsectionLinkItemsCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinkListSubsectionLinkItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkListSubsectionLinkItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkListSubsectionLinkItemsCollectionOrder2["IconAsc"] = "icon_ASC";
  LinkListSubsectionLinkItemsCollectionOrder2["IconDesc"] = "icon_DESC";
  LinkListSubsectionLinkItemsCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  LinkListSubsectionLinkItemsCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  LinkListSubsectionLinkItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkListSubsectionLinkItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkListSubsectionLinkItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkListSubsectionLinkItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkListSubsectionLinkItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkListSubsectionLinkItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkListSubsectionLinkItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkListSubsectionLinkItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkListSubsectionLinkItemsCollectionOrder2;
})(LinkListSubsectionLinkItemsCollectionOrder || {});
var LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder = /* @__PURE__ */ ((LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2) => {
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["DescriptionAsc"] = "description_ASC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["DescriptionDesc"] = "description_DESC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SectionHeadingAsc"] = "sectionHeading_ASC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SectionHeadingDesc"] = "sectionHeading_DESC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder2;
})(LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder || {});
var LinkListSubsectionOrder = /* @__PURE__ */ ((LinkListSubsectionOrder2) => {
  LinkListSubsectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkListSubsectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkListSubsectionOrder2["HeadingAsc"] = "heading_ASC";
  LinkListSubsectionOrder2["HeadingDesc"] = "heading_DESC";
  LinkListSubsectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkListSubsectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkListSubsectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkListSubsectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkListSubsectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkListSubsectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkListSubsectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkListSubsectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinkListSubsectionOrder2;
})(LinkListSubsectionOrder || {});
var LinkOrder = /* @__PURE__ */ ((LinkOrder2) => {
  LinkOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinkOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinkOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinkOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinkOrder2["LinkTypeAsc"] = "linkType_ASC";
  LinkOrder2["LinkTypeDesc"] = "linkType_DESC";
  LinkOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  LinkOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  LinkOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinkOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinkOrder2["SysIdAsc"] = "sys_id_ASC";
  LinkOrder2["SysIdDesc"] = "sys_id_DESC";
  LinkOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinkOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinkOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinkOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinkOrder2["TooltipAsc"] = "tooltip_ASC";
  LinkOrder2["TooltipDesc"] = "tooltip_DESC";
  return LinkOrder2;
})(LinkOrder || {});
var LinksListLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((LinksListLinkingCollectionsPageSectionCollectionOrder2) => {
  LinksListLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksListLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksListLinkingCollectionsPageSectionCollectionOrder2;
})(LinksListLinkingCollectionsPageSectionCollectionOrder || {});
var LinksListLinksListItemsCollectionOrder = /* @__PURE__ */ ((LinksListLinksListItemsCollectionOrder2) => {
  LinksListLinksListItemsCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  LinksListLinksListItemsCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  LinksListLinksListItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinksListLinksListItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinksListLinksListItemsCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  LinksListLinksListItemsCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  LinksListLinksListItemsCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  LinksListLinksListItemsCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  LinksListLinksListItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksListLinksListItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksListLinksListItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksListLinksListItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksListLinksListItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksListLinksListItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksListLinksListItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksListLinksListItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LinksListLinksListItemsCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  LinksListLinksListItemsCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return LinksListLinksListItemsCollectionOrder2;
})(LinksListLinksListItemsCollectionOrder || {});
var LinksListOrder = /* @__PURE__ */ ((LinksListOrder2) => {
  LinksListOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LinksListOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LinksListOrder2["LinksListTitleAsc"] = "linksListTitle_ASC";
  LinksListOrder2["LinksListTitleDesc"] = "linksListTitle_DESC";
  LinksListOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksListOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksListOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksListOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksListOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksListOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksListOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksListOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksListOrder2;
})(LinksListOrder || {});
var LongStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((LongStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LongStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LongStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(LongStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var LongStringOrder = /* @__PURE__ */ ((LongStringOrder2) => {
  LongStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  LongStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  LongStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LongStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LongStringOrder2["SysIdAsc"] = "sys_id_ASC";
  LongStringOrder2["SysIdDesc"] = "sys_id_DESC";
  LongStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LongStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LongStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LongStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LongStringOrder2;
})(LongStringOrder || {});
var MapSectionAccordionsCollectionOrder = /* @__PURE__ */ ((MapSectionAccordionsCollectionOrder2) => {
  MapSectionAccordionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MapSectionAccordionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MapSectionAccordionsCollectionOrder2["SummaryAsc"] = "summary_ASC";
  MapSectionAccordionsCollectionOrder2["SummaryDesc"] = "summary_DESC";
  MapSectionAccordionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MapSectionAccordionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MapSectionAccordionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MapSectionAccordionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MapSectionAccordionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MapSectionAccordionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MapSectionAccordionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MapSectionAccordionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MapSectionAccordionsCollectionOrder2;
})(MapSectionAccordionsCollectionOrder || {});
var MapSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MapSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(MapSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var MapSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MapSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(MapSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var MapSectionOrder = /* @__PURE__ */ ((MapSectionOrder2) => {
  MapSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MapSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MapSectionOrder2["MapImageAltTextAsc"] = "mapImageAltText_ASC";
  MapSectionOrder2["MapImageAltTextDesc"] = "mapImageAltText_DESC";
  MapSectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  MapSectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  MapSectionOrder2["SectionHeadingAsc"] = "sectionHeading_ASC";
  MapSectionOrder2["SectionHeadingDesc"] = "sectionHeading_DESC";
  MapSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MapSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MapSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MapSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MapSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MapSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MapSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MapSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MapSectionOrder2;
})(MapSectionOrder || {});
var MealsRestaurantLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((MealsRestaurantLinkingCollectionsFerryCollectionOrder2) => {
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MealsRestaurantLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MealsRestaurantLinkingCollectionsFerryCollectionOrder2;
})(MealsRestaurantLinkingCollectionsFerryCollectionOrder || {});
var MealsRestaurantOrder = /* @__PURE__ */ ((MealsRestaurantOrder2) => {
  MealsRestaurantOrder2["BannerLine1Asc"] = "bannerLine1_ASC";
  MealsRestaurantOrder2["BannerLine1Desc"] = "bannerLine1_DESC";
  MealsRestaurantOrder2["BannerLine2LargeAsc"] = "bannerLine2Large_ASC";
  MealsRestaurantOrder2["BannerLine2LargeDesc"] = "bannerLine2Large_DESC";
  MealsRestaurantOrder2["BannerLine2SmallAsc"] = "bannerLine2Small_ASC";
  MealsRestaurantOrder2["BannerLine2SmallDesc"] = "bannerLine2Small_DESC";
  MealsRestaurantOrder2["BannerLine3Asc"] = "bannerLine3_ASC";
  MealsRestaurantOrder2["BannerLine3Desc"] = "bannerLine3_DESC";
  MealsRestaurantOrder2["CloseButtonLightThemeAsc"] = "closeButtonLightTheme_ASC";
  MealsRestaurantOrder2["CloseButtonLightThemeDesc"] = "closeButtonLightTheme_DESC";
  MealsRestaurantOrder2["DefaultSeatingTimeAsc"] = "defaultSeatingTime_ASC";
  MealsRestaurantOrder2["DefaultSeatingTimeDesc"] = "defaultSeatingTime_DESC";
  MealsRestaurantOrder2["HeadlineAsc"] = "headline_ASC";
  MealsRestaurantOrder2["HeadlineDesc"] = "headline_DESC";
  MealsRestaurantOrder2["HighlightedAsc"] = "highlighted_ASC";
  MealsRestaurantOrder2["HighlightedDesc"] = "highlighted_DESC";
  MealsRestaurantOrder2["MenuBeveragesHeadlineAsc"] = "menuBeveragesHeadline_ASC";
  MealsRestaurantOrder2["MenuBeveragesHeadlineDesc"] = "menuBeveragesHeadline_DESC";
  MealsRestaurantOrder2["MenuCardForChildrenTitleAsc"] = "menuCardForChildrenTitle_ASC";
  MealsRestaurantOrder2["MenuCardForChildrenTitleDesc"] = "menuCardForChildrenTitle_DESC";
  MealsRestaurantOrder2["MenuCardTitleAsc"] = "menuCardTitle_ASC";
  MealsRestaurantOrder2["MenuCardTitleDesc"] = "menuCardTitle_DESC";
  MealsRestaurantOrder2["MenuDessertsHeadlineAsc"] = "menuDessertsHeadline_ASC";
  MealsRestaurantOrder2["MenuDessertsHeadlineDesc"] = "menuDessertsHeadline_DESC";
  MealsRestaurantOrder2["MenuForChildrenHeadlineAsc"] = "menuForChildrenHeadline_ASC";
  MealsRestaurantOrder2["MenuForChildrenHeadlineDesc"] = "menuForChildrenHeadline_DESC";
  MealsRestaurantOrder2["MenuMainCourseExtrasHeadlineAsc"] = "menuMainCourseExtrasHeadline_ASC";
  MealsRestaurantOrder2["MenuMainCourseExtrasHeadlineDesc"] = "menuMainCourseExtrasHeadline_DESC";
  MealsRestaurantOrder2["MenuMainCoursesExpandedAsc"] = "menuMainCoursesExpanded_ASC";
  MealsRestaurantOrder2["MenuMainCoursesExpandedDesc"] = "menuMainCoursesExpanded_DESC";
  MealsRestaurantOrder2["MenuMainCoursesHeadlineAsc"] = "menuMainCoursesHeadline_ASC";
  MealsRestaurantOrder2["MenuMainCoursesHeadlineDesc"] = "menuMainCoursesHeadline_DESC";
  MealsRestaurantOrder2["MenuSectionsNoCollapseAsc"] = "menuSectionsNoCollapse_ASC";
  MealsRestaurantOrder2["MenuSectionsNoCollapseDesc"] = "menuSectionsNoCollapse_DESC";
  MealsRestaurantOrder2["MenuStartersExpandedAsc"] = "menuStartersExpanded_ASC";
  MealsRestaurantOrder2["MenuStartersExpandedDesc"] = "menuStartersExpanded_DESC";
  MealsRestaurantOrder2["MenuStartersHeadlineAsc"] = "menuStartersHeadline_ASC";
  MealsRestaurantOrder2["MenuStartersHeadlineDesc"] = "menuStartersHeadline_DESC";
  MealsRestaurantOrder2["RestaurantCodeAsc"] = "restaurantCode_ASC";
  MealsRestaurantOrder2["RestaurantCodeDesc"] = "restaurantCode_DESC";
  MealsRestaurantOrder2["RestaurantNameAsc"] = "restaurantName_ASC";
  MealsRestaurantOrder2["RestaurantNameDesc"] = "restaurantName_DESC";
  MealsRestaurantOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MealsRestaurantOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MealsRestaurantOrder2["SysIdAsc"] = "sys_id_ASC";
  MealsRestaurantOrder2["SysIdDesc"] = "sys_id_DESC";
  MealsRestaurantOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MealsRestaurantOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MealsRestaurantOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MealsRestaurantOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MealsRestaurantOrder2;
})(MealsRestaurantOrder || {});
var MediaCardLinkingCollectionsCardsSectionCollectionOrder = /* @__PURE__ */ ((MediaCardLinkingCollectionsCardsSectionCollectionOrder2) => {
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeAsc"] = "displayType_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeDesc"] = "displayType_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorAsc"] = "sectionBackgroundAndCardColor_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorDesc"] = "sectionBackgroundAndCardColor_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MediaCardLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MediaCardLinkingCollectionsCardsSectionCollectionOrder2;
})(MediaCardLinkingCollectionsCardsSectionCollectionOrder || {});
var MediaCardOrder = /* @__PURE__ */ ((MediaCardOrder2) => {
  MediaCardOrder2["BadgeAsc"] = "badge_ASC";
  MediaCardOrder2["BadgeDesc"] = "badge_DESC";
  MediaCardOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MediaCardOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MediaCardOrder2["HeaderAsc"] = "header_ASC";
  MediaCardOrder2["HeaderDesc"] = "header_DESC";
  MediaCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MediaCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MediaCardOrder2["SysIdAsc"] = "sys_id_ASC";
  MediaCardOrder2["SysIdDesc"] = "sys_id_DESC";
  MediaCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MediaCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MediaCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MediaCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MediaCardOrder2;
})(MediaCardOrder || {});
var MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryAsc"] = "category_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryDesc"] = "category_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder || {});
var MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2) => {
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder2;
})(MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder || {});
var MetaDataAndSeoOrder = /* @__PURE__ */ ((MetaDataAndSeoOrder2) => {
  MetaDataAndSeoOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MetaDataAndSeoOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MetaDataAndSeoOrder2["PageMetaDescriptionAsc"] = "pageMetaDescription_ASC";
  MetaDataAndSeoOrder2["PageMetaDescriptionDesc"] = "pageMetaDescription_DESC";
  MetaDataAndSeoOrder2["PageTitleAsc"] = "pageTitle_ASC";
  MetaDataAndSeoOrder2["PageTitleDesc"] = "pageTitle_DESC";
  MetaDataAndSeoOrder2["RobotsMetaAsc"] = "robotsMeta_ASC";
  MetaDataAndSeoOrder2["RobotsMetaDesc"] = "robotsMeta_DESC";
  MetaDataAndSeoOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MetaDataAndSeoOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MetaDataAndSeoOrder2["SysIdAsc"] = "sys_id_ASC";
  MetaDataAndSeoOrder2["SysIdDesc"] = "sys_id_DESC";
  MetaDataAndSeoOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MetaDataAndSeoOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MetaDataAndSeoOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MetaDataAndSeoOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MetaDataAndSeoOrder2;
})(MetaDataAndSeoOrder || {});
var MigrationLogOrder = /* @__PURE__ */ ((MigrationLogOrder2) => {
  MigrationLogOrder2["LatestMigrationAsc"] = "latestMigration_ASC";
  MigrationLogOrder2["LatestMigrationDesc"] = "latestMigration_DESC";
  MigrationLogOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MigrationLogOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MigrationLogOrder2["SysIdAsc"] = "sys_id_ASC";
  MigrationLogOrder2["SysIdDesc"] = "sys_id_DESC";
  MigrationLogOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MigrationLogOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MigrationLogOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MigrationLogOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MigrationLogOrder2;
})(MigrationLogOrder || {});
var MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder = /* @__PURE__ */ ((MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2) => {
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["BusinessTypeAsc"] = "businessType_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["BusinessTypeDesc"] = "businessType_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["IdAsc"] = "id_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["IdDesc"] = "id_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["TitleAsc"] = "title_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["TitleDesc"] = "title_DESC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["TypeAsc"] = "type_ASC";
  MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2["TypeDesc"] = "type_DESC";
  return MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder2;
})(MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder || {});
var MobileContentBlockOrder = /* @__PURE__ */ ((MobileContentBlockOrder2) => {
  MobileContentBlockOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileContentBlockOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileContentBlockOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  MobileContentBlockOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  MobileContentBlockOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileContentBlockOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileContentBlockOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileContentBlockOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileContentBlockOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileContentBlockOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileContentBlockOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileContentBlockOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MobileContentBlockOrder2;
})(MobileContentBlockOrder || {});
var MobilePageCampaignBlocksCollectionOrder = /* @__PURE__ */ ((MobilePageCampaignBlocksCollectionOrder2) => {
  MobilePageCampaignBlocksCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobilePageCampaignBlocksCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobilePageCampaignBlocksCollectionOrder2["PromotionCodeAsc"] = "promotionCode_ASC";
  MobilePageCampaignBlocksCollectionOrder2["PromotionCodeDesc"] = "promotionCode_DESC";
  MobilePageCampaignBlocksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobilePageCampaignBlocksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobilePageCampaignBlocksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobilePageCampaignBlocksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobilePageCampaignBlocksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobilePageCampaignBlocksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobilePageCampaignBlocksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobilePageCampaignBlocksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MobilePageCampaignBlocksCollectionOrder2;
})(MobilePageCampaignBlocksCollectionOrder || {});
var MobilePageOrder = /* @__PURE__ */ ((MobilePageOrder2) => {
  MobilePageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobilePageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobilePageOrder2["PageTitleAsc"] = "pageTitle_ASC";
  MobilePageOrder2["PageTitleDesc"] = "pageTitle_DESC";
  MobilePageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobilePageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobilePageOrder2["SysIdAsc"] = "sys_id_ASC";
  MobilePageOrder2["SysIdDesc"] = "sys_id_DESC";
  MobilePageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobilePageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobilePageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobilePageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MobilePageOrder2;
})(MobilePageOrder || {});
var MobileScreenMobileSectionsCollectionOrder = /* @__PURE__ */ ((MobileScreenMobileSectionsCollectionOrder2) => {
  MobileScreenMobileSectionsCollectionOrder2["BusinessTypeAsc"] = "businessType_ASC";
  MobileScreenMobileSectionsCollectionOrder2["BusinessTypeDesc"] = "businessType_DESC";
  MobileScreenMobileSectionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileScreenMobileSectionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileScreenMobileSectionsCollectionOrder2["IdAsc"] = "id_ASC";
  MobileScreenMobileSectionsCollectionOrder2["IdDesc"] = "id_DESC";
  MobileScreenMobileSectionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileScreenMobileSectionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileScreenMobileSectionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileScreenMobileSectionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileScreenMobileSectionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileScreenMobileSectionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileScreenMobileSectionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileScreenMobileSectionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileScreenMobileSectionsCollectionOrder2["TitleAsc"] = "title_ASC";
  MobileScreenMobileSectionsCollectionOrder2["TitleDesc"] = "title_DESC";
  MobileScreenMobileSectionsCollectionOrder2["TypeAsc"] = "type_ASC";
  MobileScreenMobileSectionsCollectionOrder2["TypeDesc"] = "type_DESC";
  return MobileScreenMobileSectionsCollectionOrder2;
})(MobileScreenMobileSectionsCollectionOrder || {});
var MobileScreenOrder = /* @__PURE__ */ ((MobileScreenOrder2) => {
  MobileScreenOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileScreenOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileScreenOrder2["IdAsc"] = "id_ASC";
  MobileScreenOrder2["IdDesc"] = "id_DESC";
  MobileScreenOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileScreenOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileScreenOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileScreenOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileScreenOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileScreenOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileScreenOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileScreenOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileScreenOrder2["TitleAsc"] = "title_ASC";
  MobileScreenOrder2["TitleDesc"] = "title_DESC";
  return MobileScreenOrder2;
})(MobileScreenOrder || {});
var MobileSectionLinkingCollectionsMobileScreenCollectionOrder = /* @__PURE__ */ ((MobileSectionLinkingCollectionsMobileScreenCollectionOrder2) => {
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["IdAsc"] = "id_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["IdDesc"] = "id_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["TitleAsc"] = "title_ASC";
  MobileSectionLinkingCollectionsMobileScreenCollectionOrder2["TitleDesc"] = "title_DESC";
  return MobileSectionLinkingCollectionsMobileScreenCollectionOrder2;
})(MobileSectionLinkingCollectionsMobileScreenCollectionOrder || {});
var MobileSectionOrder = /* @__PURE__ */ ((MobileSectionOrder2) => {
  MobileSectionOrder2["BusinessTypeAsc"] = "businessType_ASC";
  MobileSectionOrder2["BusinessTypeDesc"] = "businessType_DESC";
  MobileSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileSectionOrder2["IdAsc"] = "id_ASC";
  MobileSectionOrder2["IdDesc"] = "id_DESC";
  MobileSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  MobileSectionOrder2["TitleAsc"] = "title_ASC";
  MobileSectionOrder2["TitleDesc"] = "title_DESC";
  MobileSectionOrder2["TypeAsc"] = "type_ASC";
  MobileSectionOrder2["TypeDesc"] = "type_DESC";
  return MobileSectionOrder2;
})(MobileSectionOrder || {});
var MobileSectionSectionItemsCollectionOrder = /* @__PURE__ */ ((MobileSectionSectionItemsCollectionOrder2) => {
  MobileSectionSectionItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  MobileSectionSectionItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  MobileSectionSectionItemsCollectionOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  MobileSectionSectionItemsCollectionOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  MobileSectionSectionItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MobileSectionSectionItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MobileSectionSectionItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  MobileSectionSectionItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  MobileSectionSectionItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MobileSectionSectionItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MobileSectionSectionItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MobileSectionSectionItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MobileSectionSectionItemsCollectionOrder2;
})(MobileSectionSectionItemsCollectionOrder || {});
var ModularPageOrder = /* @__PURE__ */ ((ModularPageOrder2) => {
  ModularPageOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ModularPageOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ModularPageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ModularPageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ModularPageOrder2["SysIdAsc"] = "sys_id_ASC";
  ModularPageOrder2["SysIdDesc"] = "sys_id_DESC";
  ModularPageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ModularPageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ModularPageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ModularPageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ModularPageOrder2;
})(ModularPageOrder || {});
var NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var NamespaceAndStringOrder = /* @__PURE__ */ ((NamespaceAndStringOrder2) => {
  NamespaceAndStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NamespaceAndStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NamespaceAndStringOrder2["KeyAsc"] = "key_ASC";
  NamespaceAndStringOrder2["KeyDesc"] = "key_DESC";
  NamespaceAndStringOrder2["NamespaceAsc"] = "namespace_ASC";
  NamespaceAndStringOrder2["NamespaceDesc"] = "namespace_DESC";
  NamespaceAndStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NamespaceAndStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NamespaceAndStringOrder2["SysIdAsc"] = "sys_id_ASC";
  NamespaceAndStringOrder2["SysIdDesc"] = "sys_id_DESC";
  NamespaceAndStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NamespaceAndStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NamespaceAndStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NamespaceAndStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NamespaceAndStringOrder2;
})(NamespaceAndStringOrder || {});
var NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2) => {
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder2;
})(NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder || {});
var NavigationDiscoverSectionOrder = /* @__PURE__ */ ((NavigationDiscoverSectionOrder2) => {
  NavigationDiscoverSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationDiscoverSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationDiscoverSectionOrder2["SearchAsc"] = "search_ASC";
  NavigationDiscoverSectionOrder2["SearchDesc"] = "search_DESC";
  NavigationDiscoverSectionOrder2["ShowResultsTextAsc"] = "showResultsText_ASC";
  NavigationDiscoverSectionOrder2["ShowResultsTextDesc"] = "showResultsText_DESC";
  NavigationDiscoverSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationDiscoverSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationDiscoverSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationDiscoverSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationDiscoverSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationDiscoverSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationDiscoverSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationDiscoverSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationDiscoverSectionOrder2;
})(NavigationDiscoverSectionOrder || {});
var NavigationItemLinkingCollectionsFooterCollectionOrder = /* @__PURE__ */ ((NavigationItemLinkingCollectionsFooterCollectionOrder2) => {
  NavigationItemLinkingCollectionsFooterCollectionOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationItemLinkingCollectionsFooterCollectionOrder2;
})(NavigationItemLinkingCollectionsFooterCollectionOrder || {});
var NavigationItemLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((NavigationItemLinkingCollectionsNavigationCollectionOrder2) => {
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationItemLinkingCollectionsNavigationCollectionOrder2;
})(NavigationItemLinkingCollectionsNavigationCollectionOrder || {});
var NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder = /* @__PURE__ */ ((NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2) => {
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchAsc"] = "search_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchDesc"] = "search_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextAsc"] = "showResultsText_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextDesc"] = "showResultsText_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder2;
})(NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder || {});
var NavigationItemLinkingCollectionsNavigationItemCollectionOrder = /* @__PURE__ */ ((NavigationItemLinkingCollectionsNavigationItemCollectionOrder2) => {
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  NavigationItemLinkingCollectionsNavigationItemCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return NavigationItemLinkingCollectionsNavigationItemCollectionOrder2;
})(NavigationItemLinkingCollectionsNavigationItemCollectionOrder || {});
var NavigationItemOrder = /* @__PURE__ */ ((NavigationItemOrder2) => {
  NavigationItemOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationItemOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationItemOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationItemOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NavigationItemOrder2["TooltipAsc"] = "tooltip_ASC";
  NavigationItemOrder2["TooltipDesc"] = "tooltip_DESC";
  return NavigationItemOrder2;
})(NavigationItemOrder || {});
var NavigationOrder = /* @__PURE__ */ ((NavigationOrder2) => {
  NavigationOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  NavigationOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  NavigationOrder2["DisplayTextAsc"] = "displayText_ASC";
  NavigationOrder2["DisplayTextDesc"] = "displayText_DESC";
  NavigationOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationOrder2["OrderAsc"] = "order_ASC";
  NavigationOrder2["OrderDesc"] = "order_DESC";
  NavigationOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NavigationOrder2;
})(NavigationOrder || {});
var NavigationPromotionsCollectionOrder = /* @__PURE__ */ ((NavigationPromotionsCollectionOrder2) => {
  NavigationPromotionsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NavigationPromotionsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NavigationPromotionsCollectionOrder2["ImageDisplayOptionsAsc"] = "imageDisplayOptions_ASC";
  NavigationPromotionsCollectionOrder2["ImageDisplayOptionsDesc"] = "imageDisplayOptions_DESC";
  NavigationPromotionsCollectionOrder2["MediaTypeAsc"] = "mediaType_ASC";
  NavigationPromotionsCollectionOrder2["MediaTypeDesc"] = "mediaType_DESC";
  NavigationPromotionsCollectionOrder2["PrimaryTextAsc"] = "primaryText_ASC";
  NavigationPromotionsCollectionOrder2["PrimaryTextDesc"] = "primaryText_DESC";
  NavigationPromotionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NavigationPromotionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NavigationPromotionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NavigationPromotionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NavigationPromotionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NavigationPromotionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NavigationPromotionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NavigationPromotionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NavigationPromotionsCollectionOrder2["TertiaryTextAsc"] = "tertiaryText_ASC";
  NavigationPromotionsCollectionOrder2["TertiaryTextDesc"] = "tertiaryText_DESC";
  NavigationPromotionsCollectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  NavigationPromotionsCollectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return NavigationPromotionsCollectionOrder2;
})(NavigationPromotionsCollectionOrder || {});
var NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var NewsletterSectionOrder = /* @__PURE__ */ ((NewsletterSectionOrder2) => {
  NewsletterSectionOrder2["CdmSourceIdAsc"] = "cdmSourceId_ASC";
  NewsletterSectionOrder2["CdmSourceIdDesc"] = "cdmSourceId_DESC";
  NewsletterSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NewsletterSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NewsletterSectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  NewsletterSectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  NewsletterSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NewsletterSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NewsletterSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NewsletterSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NewsletterSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NewsletterSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NewsletterSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NewsletterSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NewsletterSectionOrder2["TitleAsc"] = "title_ASC";
  NewsletterSectionOrder2["TitleDesc"] = "title_DESC";
  NewsletterSectionOrder2["TypeAsc"] = "type_ASC";
  NewsletterSectionOrder2["TypeDesc"] = "type_DESC";
  return NewsletterSectionOrder2;
})(NewsletterSectionOrder || {});
var NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder = /* @__PURE__ */ ((NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2) => {
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SailingTimeAsc"] = "sailingTime_ASC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SailingTimeDesc"] = "sailingTime_DESC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["VesselNameAsc"] = "vesselName_ASC";
  NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2["VesselNameDesc"] = "vesselName_DESC";
  return NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder2;
})(NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder || {});
var NotificationOrder = /* @__PURE__ */ ((NotificationOrder2) => {
  NotificationOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  NotificationOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  NotificationOrder2["HeadingAsc"] = "heading_ASC";
  NotificationOrder2["HeadingDesc"] = "heading_DESC";
  NotificationOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  NotificationOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  NotificationOrder2["SysIdAsc"] = "sys_id_ASC";
  NotificationOrder2["SysIdDesc"] = "sys_id_DESC";
  NotificationOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  NotificationOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  NotificationOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  NotificationOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  NotificationOrder2["VariantAsc"] = "variant_ASC";
  NotificationOrder2["VariantDesc"] = "variant_DESC";
  return NotificationOrder2;
})(NotificationOrder || {});
var OpenGraphSettingsOrder = /* @__PURE__ */ ((OpenGraphSettingsOrder2) => {
  OpenGraphSettingsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  OpenGraphSettingsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  OpenGraphSettingsOrder2["OgFacebookAppIdFreightShippingAsc"] = "ogFacebookAppIdFreightShipping_ASC";
  OpenGraphSettingsOrder2["OgFacebookAppIdFreightShippingDesc"] = "ogFacebookAppIdFreightShipping_DESC";
  OpenGraphSettingsOrder2["OgFacebookAppIdGroupAsc"] = "ogFacebookAppIdGroup_ASC";
  OpenGraphSettingsOrder2["OgFacebookAppIdGroupDesc"] = "ogFacebookAppIdGroup_DESC";
  OpenGraphSettingsOrder2["OgFacebookAppIdLogisticsAsc"] = "ogFacebookAppIdLogistics_ASC";
  OpenGraphSettingsOrder2["OgFacebookAppIdLogisticsDesc"] = "ogFacebookAppIdLogistics_DESC";
  OpenGraphSettingsOrder2["OgFacebookAppIdPaxAsc"] = "ogFacebookAppIdPax_ASC";
  OpenGraphSettingsOrder2["OgFacebookAppIdPaxDesc"] = "ogFacebookAppIdPax_DESC";
  OpenGraphSettingsOrder2["OgSiteNameAsc"] = "ogSiteName_ASC";
  OpenGraphSettingsOrder2["OgSiteNameDesc"] = "ogSiteName_DESC";
  OpenGraphSettingsOrder2["OgTwitterSiteAsc"] = "ogTwitterSite_ASC";
  OpenGraphSettingsOrder2["OgTwitterSiteDesc"] = "ogTwitterSite_DESC";
  OpenGraphSettingsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  OpenGraphSettingsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  OpenGraphSettingsOrder2["SysIdAsc"] = "sys_id_ASC";
  OpenGraphSettingsOrder2["SysIdDesc"] = "sys_id_DESC";
  OpenGraphSettingsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  OpenGraphSettingsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  OpenGraphSettingsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  OpenGraphSettingsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return OpenGraphSettingsOrder2;
})(OpenGraphSettingsOrder || {});
var PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder = /* @__PURE__ */ ((PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2) => {
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryAsc"] = "category_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryDesc"] = "category_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2;
})(PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder || {});
var PageSectionLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((PageSectionLinkingCollectionsArticlePageCollectionOrder2) => {
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageSectionLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PageSectionLinkingCollectionsArticlePageCollectionOrder2;
})(PageSectionLinkingCollectionsArticlePageCollectionOrder || {});
var PageSectionLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((PageSectionLinkingCollectionsModularPageCollectionOrder2) => {
  PageSectionLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageSectionLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PageSectionLinkingCollectionsModularPageCollectionOrder2;
})(PageSectionLinkingCollectionsModularPageCollectionOrder || {});
var PageSectionOrder = /* @__PURE__ */ ((PageSectionOrder2) => {
  PageSectionOrder2["ColumnsAsc"] = "columns_ASC";
  PageSectionOrder2["ColumnsDesc"] = "columns_DESC";
  PageSectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  PageSectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  PageSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PageSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PageSectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  PageSectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  PageSectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  PageSectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  PageSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  PageSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  PageSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PageSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PageSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PageSectionOrder2;
})(PageSectionOrder || {});
var PaxObCardItemsCollectionOrder = /* @__PURE__ */ ((PaxObCardItemsCollectionOrder2) => {
  PaxObCardItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObCardItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObCardItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObCardItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObCardItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObCardItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObCardItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObCardItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObCardItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObCardItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PaxObCardItemsCollectionOrder2["TypeAsc"] = "type_ASC";
  PaxObCardItemsCollectionOrder2["TypeDesc"] = "type_DESC";
  return PaxObCardItemsCollectionOrder2;
})(PaxObCardItemsCollectionOrder || {});
var PaxObCardOrder = /* @__PURE__ */ ((PaxObCardOrder2) => {
  PaxObCardOrder2["DescriptionAsc"] = "description_ASC";
  PaxObCardOrder2["DescriptionDesc"] = "description_DESC";
  PaxObCardOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObCardOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObCardOrder2["MappingCodeAsc"] = "mappingCode_ASC";
  PaxObCardOrder2["MappingCodeDesc"] = "mappingCode_DESC";
  PaxObCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObCardOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObCardOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PaxObCardOrder2["TitleAsc"] = "title_ASC";
  PaxObCardOrder2["TitleDesc"] = "title_DESC";
  PaxObCardOrder2["TypeAsc"] = "type_ASC";
  PaxObCardOrder2["TypeDesc"] = "type_DESC";
  return PaxObCardOrder2;
})(PaxObCardOrder || {});
var PaxObItemLinkingCollectionsPaxObCardCollectionOrder = /* @__PURE__ */ ((PaxObItemLinkingCollectionsPaxObCardCollectionOrder2) => {
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["DescriptionAsc"] = "description_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["DescriptionDesc"] = "description_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["MappingCodeAsc"] = "mappingCode_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["MappingCodeDesc"] = "mappingCode_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["TitleAsc"] = "title_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["TitleDesc"] = "title_DESC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["TypeAsc"] = "type_ASC";
  PaxObItemLinkingCollectionsPaxObCardCollectionOrder2["TypeDesc"] = "type_DESC";
  return PaxObItemLinkingCollectionsPaxObCardCollectionOrder2;
})(PaxObItemLinkingCollectionsPaxObCardCollectionOrder || {});
var PaxObItemOrder = /* @__PURE__ */ ((PaxObItemOrder2) => {
  PaxObItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObItemOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObItemOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PaxObItemOrder2["TypeAsc"] = "type_ASC";
  PaxObItemOrder2["TypeDesc"] = "type_DESC";
  return PaxObItemOrder2;
})(PaxObItemOrder || {});
var PaxObResourceOrder = /* @__PURE__ */ ((PaxObResourceOrder2) => {
  PaxObResourceOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxObResourceOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxObResourceOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxObResourceOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxObResourceOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxObResourceOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxObResourceOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxObResourceOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxObResourceOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxObResourceOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PaxObResourceOrder2;
})(PaxObResourceOrder || {});
var PaxRouteFerriesCollectionOrder = /* @__PURE__ */ ((PaxRouteFerriesCollectionOrder2) => {
  PaxRouteFerriesCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxRouteFerriesCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxRouteFerriesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxRouteFerriesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxRouteFerriesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxRouteFerriesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxRouteFerriesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxRouteFerriesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxRouteFerriesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxRouteFerriesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PaxRouteFerriesCollectionOrder2;
})(PaxRouteFerriesCollectionOrder || {});
var PaxRouteOrder = /* @__PURE__ */ ((PaxRouteOrder2) => {
  PaxRouteOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PaxRouteOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PaxRouteOrder2["NameAsc"] = "name_ASC";
  PaxRouteOrder2["NameDesc"] = "name_DESC";
  PaxRouteOrder2["PaxScheduleApiCodeIdAsc"] = "paxScheduleApiCodeId_ASC";
  PaxRouteOrder2["PaxScheduleApiCodeIdDesc"] = "paxScheduleApiCodeId_DESC";
  PaxRouteOrder2["RouteMarketingTitleAsc"] = "routeMarketingTitle_ASC";
  PaxRouteOrder2["RouteMarketingTitleDesc"] = "routeMarketingTitle_DESC";
  PaxRouteOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PaxRouteOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PaxRouteOrder2["SysIdAsc"] = "sys_id_ASC";
  PaxRouteOrder2["SysIdDesc"] = "sys_id_DESC";
  PaxRouteOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PaxRouteOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PaxRouteOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PaxRouteOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PaxRouteOrder2;
})(PaxRouteOrder || {});
var PetsLinkingCollectionsFerryCollectionOrder = /* @__PURE__ */ ((PetsLinkingCollectionsFerryCollectionOrder2) => {
  PetsLinkingCollectionsFerryCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PetsLinkingCollectionsFerryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PetsLinkingCollectionsFerryCollectionOrder2;
})(PetsLinkingCollectionsFerryCollectionOrder || {});
var PetsOrder = /* @__PURE__ */ ((PetsOrder2) => {
  PetsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PetsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PetsOrder2["IdAsc"] = "id_ASC";
  PetsOrder2["IdDesc"] = "id_DESC";
  PetsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PetsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PetsOrder2["SysIdAsc"] = "sys_id_ASC";
  PetsOrder2["SysIdDesc"] = "sys_id_DESC";
  PetsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PetsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PetsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PetsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PetsOrder2["TypeAsc"] = "type_ASC";
  PetsOrder2["TypeDesc"] = "type_DESC";
  return PetsOrder2;
})(PetsOrder || {});
var PluralStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PluralStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(PluralStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var PluralStringOrder = /* @__PURE__ */ ((PluralStringOrder2) => {
  PluralStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  PluralStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  PluralStringOrder2["Key_0Asc"] = "key_0_ASC";
  PluralStringOrder2["Key_0Desc"] = "key_0_DESC";
  PluralStringOrder2["Key_1Asc"] = "key_1_ASC";
  PluralStringOrder2["Key_1Desc"] = "key_1_DESC";
  PluralStringOrder2["Key_2Asc"] = "key_2_ASC";
  PluralStringOrder2["Key_2Desc"] = "key_2_DESC";
  PluralStringOrder2["Key_3Asc"] = "key_3_ASC";
  PluralStringOrder2["Key_3Desc"] = "key_3_DESC";
  PluralStringOrder2["Key_4Asc"] = "key_4_ASC";
  PluralStringOrder2["Key_4Desc"] = "key_4_DESC";
  PluralStringOrder2["Key_5Asc"] = "key_5_ASC";
  PluralStringOrder2["Key_5Desc"] = "key_5_DESC";
  PluralStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PluralStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PluralStringOrder2["SysIdAsc"] = "sys_id_ASC";
  PluralStringOrder2["SysIdDesc"] = "sys_id_DESC";
  PluralStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PluralStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PluralStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PluralStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PluralStringOrder2;
})(PluralStringOrder || {});
var PriceChangedPopupOrder = /* @__PURE__ */ ((PriceChangedPopupOrder2) => {
  PriceChangedPopupOrder2["AcceptNewPriceAsc"] = "acceptNewPrice_ASC";
  PriceChangedPopupOrder2["AcceptNewPriceDesc"] = "acceptNewPrice_DESC";
  PriceChangedPopupOrder2["GoBackAsc"] = "goBack_ASC";
  PriceChangedPopupOrder2["GoBackDesc"] = "goBack_DESC";
  PriceChangedPopupOrder2["HeaderAsc"] = "header_ASC";
  PriceChangedPopupOrder2["HeaderDesc"] = "header_DESC";
  PriceChangedPopupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PriceChangedPopupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PriceChangedPopupOrder2["SysIdAsc"] = "sys_id_ASC";
  PriceChangedPopupOrder2["SysIdDesc"] = "sys_id_DESC";
  PriceChangedPopupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PriceChangedPopupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PriceChangedPopupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PriceChangedPopupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PriceChangedPopupOrder2;
})(PriceChangedPopupOrder || {});
var ProductCardSectionIconItemsCollectionOrder = /* @__PURE__ */ ((ProductCardSectionIconItemsCollectionOrder2) => {
  ProductCardSectionIconItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ProductCardSectionIconItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ProductCardSectionIconItemsCollectionOrder2["IconAsc"] = "icon_ASC";
  ProductCardSectionIconItemsCollectionOrder2["IconDesc"] = "icon_DESC";
  ProductCardSectionIconItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCardSectionIconItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCardSectionIconItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCardSectionIconItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCardSectionIconItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCardSectionIconItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCardSectionIconItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCardSectionIconItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductCardSectionIconItemsCollectionOrder2["TitleAsc"] = "title_ASC";
  ProductCardSectionIconItemsCollectionOrder2["TitleDesc"] = "title_DESC";
  return ProductCardSectionIconItemsCollectionOrder2;
})(ProductCardSectionIconItemsCollectionOrder || {});
var ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var ProductCardSectionOrder = /* @__PURE__ */ ((ProductCardSectionOrder2) => {
  ProductCardSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ProductCardSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ProductCardSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  ProductCardSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  ProductCardSectionOrder2["SectionHeadingAsc"] = "sectionHeading_ASC";
  ProductCardSectionOrder2["SectionHeadingDesc"] = "sectionHeading_DESC";
  ProductCardSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCardSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCardSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCardSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCardSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCardSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCardSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCardSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ProductCardSectionOrder2;
})(ProductCardSectionOrder || {});
var ReleaseNotesOrder = /* @__PURE__ */ ((ReleaseNotesOrder2) => {
  ReleaseNotesOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ReleaseNotesOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ReleaseNotesOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ReleaseNotesOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ReleaseNotesOrder2["SysIdAsc"] = "sys_id_ASC";
  ReleaseNotesOrder2["SysIdDesc"] = "sys_id_DESC";
  ReleaseNotesOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ReleaseNotesOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ReleaseNotesOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ReleaseNotesOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ReleaseNotesOrder2["VersionNumberAsc"] = "versionNumber_ASC";
  ReleaseNotesOrder2["VersionNumberDesc"] = "versionNumber_DESC";
  return ReleaseNotesOrder2;
})(ReleaseNotesOrder || {});
var ResourceOrder = /* @__PURE__ */ ((ResourceOrder2) => {
  ResourceOrder2["ComponentAsc"] = "component_ASC";
  ResourceOrder2["ComponentDesc"] = "component_DESC";
  ResourceOrder2["ContentTypeAsc"] = "contentType_ASC";
  ResourceOrder2["ContentTypeDesc"] = "contentType_DESC";
  ResourceOrder2["DontUseFallbackAsc"] = "dontUseFallback_ASC";
  ResourceOrder2["DontUseFallbackDesc"] = "dontUseFallback_DESC";
  ResourceOrder2["KeyAsc"] = "key_ASC";
  ResourceOrder2["KeyDesc"] = "key_DESC";
  ResourceOrder2["RouteAsc"] = "route_ASC";
  ResourceOrder2["RouteDesc"] = "route_DESC";
  ResourceOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ResourceOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ResourceOrder2["SysIdAsc"] = "sys_id_ASC";
  ResourceOrder2["SysIdDesc"] = "sys_id_DESC";
  ResourceOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ResourceOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ResourceOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ResourceOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ResourceOrder2;
})(ResourceOrder || {});
var RichTextItemLinkingCollectionsRichTextSectionCollectionOrder = /* @__PURE__ */ ((RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2) => {
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextItemLinkingCollectionsRichTextSectionCollectionOrder2;
})(RichTextItemLinkingCollectionsRichTextSectionCollectionOrder || {});
var RichTextItemLinksCollectionOrder = /* @__PURE__ */ ((RichTextItemLinksCollectionOrder2) => {
  RichTextItemLinksCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  RichTextItemLinksCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  RichTextItemLinksCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextItemLinksCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextItemLinksCollectionOrder2["IconAsc"] = "icon_ASC";
  RichTextItemLinksCollectionOrder2["IconDesc"] = "icon_DESC";
  RichTextItemLinksCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  RichTextItemLinksCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  RichTextItemLinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextItemLinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextItemLinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextItemLinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextItemLinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextItemLinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextItemLinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextItemLinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextItemLinksCollectionOrder2;
})(RichTextItemLinksCollectionOrder || {});
var RichTextItemOrder = /* @__PURE__ */ ((RichTextItemOrder2) => {
  RichTextItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextItemOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextItemOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  RichTextItemOrder2["TitleAsc"] = "title_ASC";
  RichTextItemOrder2["TitleDesc"] = "title_DESC";
  return RichTextItemOrder2;
})(RichTextItemOrder || {});
var RichTextSectionItemsCollectionOrder = /* @__PURE__ */ ((RichTextSectionItemsCollectionOrder2) => {
  RichTextSectionItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextSectionItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextSectionItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextSectionItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextSectionItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextSectionItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextSectionItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextSectionItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextSectionItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextSectionItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  RichTextSectionItemsCollectionOrder2["TitleAsc"] = "title_ASC";
  RichTextSectionItemsCollectionOrder2["TitleDesc"] = "title_DESC";
  return RichTextSectionItemsCollectionOrder2;
})(RichTextSectionItemsCollectionOrder || {});
var RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var RichTextSectionOrder = /* @__PURE__ */ ((RichTextSectionOrder2) => {
  RichTextSectionOrder2["ColumnsAsc"] = "columns_ASC";
  RichTextSectionOrder2["ColumnsDesc"] = "columns_DESC";
  RichTextSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  RichTextSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  RichTextSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  RichTextSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  RichTextSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextSectionOrder2;
})(RichTextSectionOrder || {});
var RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var RichTextStringOrder = /* @__PURE__ */ ((RichTextStringOrder2) => {
  RichTextStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  RichTextStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  RichTextStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RichTextStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RichTextStringOrder2["SysIdAsc"] = "sys_id_ASC";
  RichTextStringOrder2["SysIdDesc"] = "sys_id_DESC";
  RichTextStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RichTextStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RichTextStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RichTextStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RichTextStringOrder2;
})(RichTextStringOrder || {});
var RouteLinkingCollectionsCabinDetailsCollectionOrder = /* @__PURE__ */ ((RouteLinkingCollectionsCabinDetailsCollectionOrder2) => {
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["CabinTypeCodeAsc"] = "cabinTypeCode_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["CabinTypeCodeDesc"] = "cabinTypeCode_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteLinkingCollectionsCabinDetailsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RouteLinkingCollectionsCabinDetailsCollectionOrder2;
})(RouteLinkingCollectionsCabinDetailsCollectionOrder || {});
var RouteLinkingCollectionsCabinGroupCollectionOrder = /* @__PURE__ */ ((RouteLinkingCollectionsCabinGroupCollectionOrder2) => {
  RouteLinkingCollectionsCabinGroupCollectionOrder2["CabinGroupCodeAsc"] = "cabinGroupCode_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["CabinGroupCodeDesc"] = "cabinGroupCode_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["EditorDescriptionAsc"] = "editorDescription_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["EditorDescriptionDesc"] = "editorDescription_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["NoteAsc"] = "note_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["NoteDesc"] = "note_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteLinkingCollectionsCabinGroupCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RouteLinkingCollectionsCabinGroupCollectionOrder2;
})(RouteLinkingCollectionsCabinGroupCollectionOrder || {});
var RouteLinkingCollectionsFlowCabinFaresCollectionOrder = /* @__PURE__ */ ((RouteLinkingCollectionsFlowCabinFaresCollectionOrder2) => {
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["DepartureDateAsc"] = "departureDate_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["DepartureDateDesc"] = "departureDate_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupContinueButtonAsc"] = "moreThanOneCabinSelectedPopupContinueButton_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupContinueButtonDesc"] = "moreThanOneCabinSelectedPopupContinueButton_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupStayButtonAsc"] = "moreThanOneCabinSelectedPopupStayButton_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupStayButtonDesc"] = "moreThanOneCabinSelectedPopupStayButton_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupTitleAsc"] = "moreThanOneCabinSelectedPopupTitle_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["MoreThanOneCabinSelectedPopupTitleDesc"] = "moreThanOneCabinSelectedPopupTitle_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NavigationDateFormatAsc"] = "navigationDateFormat_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NavigationDateFormatDesc"] = "navigationDateFormat_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NoDeparturesAsc"] = "noDepartures_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NoDeparturesDesc"] = "noDepartures_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NotAvailablePopupHeadingAsc"] = "notAvailablePopupHeading_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NotAvailablePopupHeadingDesc"] = "notAvailablePopupHeading_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NotAvailablePopupReloadAsc"] = "notAvailablePopupReload_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["NotAvailablePopupReloadDesc"] = "notAvailablePopupReload_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["ReturnDateAsc"] = "returnDate_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["ReturnDateDesc"] = "returnDate_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SelectDateAsc"] = "selectDate_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SelectDateDesc"] = "selectDate_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["TitleAsc"] = "title_ASC";
  RouteLinkingCollectionsFlowCabinFaresCollectionOrder2["TitleDesc"] = "title_DESC";
  return RouteLinkingCollectionsFlowCabinFaresCollectionOrder2;
})(RouteLinkingCollectionsFlowCabinFaresCollectionOrder || {});
var RouteLinkingCollectionsMealsRestaurantCollectionOrder = /* @__PURE__ */ ((RouteLinkingCollectionsMealsRestaurantCollectionOrder2) => {
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine1Asc"] = "bannerLine1_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine1Desc"] = "bannerLine1_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine2LargeAsc"] = "bannerLine2Large_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine2LargeDesc"] = "bannerLine2Large_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine2SmallAsc"] = "bannerLine2Small_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine2SmallDesc"] = "bannerLine2Small_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine3Asc"] = "bannerLine3_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["BannerLine3Desc"] = "bannerLine3_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["CloseButtonLightThemeAsc"] = "closeButtonLightTheme_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["CloseButtonLightThemeDesc"] = "closeButtonLightTheme_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["DefaultSeatingTimeAsc"] = "defaultSeatingTime_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["DefaultSeatingTimeDesc"] = "defaultSeatingTime_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["HeadlineAsc"] = "headline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["HeadlineDesc"] = "headline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["HighlightedAsc"] = "highlighted_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["HighlightedDesc"] = "highlighted_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuBeveragesHeadlineAsc"] = "menuBeveragesHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuBeveragesHeadlineDesc"] = "menuBeveragesHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuCardForChildrenTitleAsc"] = "menuCardForChildrenTitle_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuCardForChildrenTitleDesc"] = "menuCardForChildrenTitle_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuCardTitleAsc"] = "menuCardTitle_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuCardTitleDesc"] = "menuCardTitle_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuDessertsHeadlineAsc"] = "menuDessertsHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuDessertsHeadlineDesc"] = "menuDessertsHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuForChildrenHeadlineAsc"] = "menuForChildrenHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuForChildrenHeadlineDesc"] = "menuForChildrenHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCourseExtrasHeadlineAsc"] = "menuMainCourseExtrasHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCourseExtrasHeadlineDesc"] = "menuMainCourseExtrasHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCoursesExpandedAsc"] = "menuMainCoursesExpanded_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCoursesExpandedDesc"] = "menuMainCoursesExpanded_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCoursesHeadlineAsc"] = "menuMainCoursesHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuMainCoursesHeadlineDesc"] = "menuMainCoursesHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuSectionsNoCollapseAsc"] = "menuSectionsNoCollapse_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuSectionsNoCollapseDesc"] = "menuSectionsNoCollapse_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuStartersExpandedAsc"] = "menuStartersExpanded_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuStartersExpandedDesc"] = "menuStartersExpanded_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuStartersHeadlineAsc"] = "menuStartersHeadline_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["MenuStartersHeadlineDesc"] = "menuStartersHeadline_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["RestaurantCodeAsc"] = "restaurantCode_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["RestaurantCodeDesc"] = "restaurantCode_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["RestaurantNameAsc"] = "restaurantName_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["RestaurantNameDesc"] = "restaurantName_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteLinkingCollectionsMealsRestaurantCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RouteLinkingCollectionsMealsRestaurantCollectionOrder2;
})(RouteLinkingCollectionsMealsRestaurantCollectionOrder || {});
var RouteOrder = /* @__PURE__ */ ((RouteOrder2) => {
  RouteOrder2["RouteCodeAsc"] = "routeCode_ASC";
  RouteOrder2["RouteCodeDesc"] = "routeCode_DESC";
  RouteOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RouteOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RouteOrder2["SysIdAsc"] = "sys_id_ASC";
  RouteOrder2["SysIdDesc"] = "sys_id_DESC";
  RouteOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RouteOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RouteOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RouteOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RouteOrder2;
})(RouteOrder || {});
var SeabookResourceOrder = /* @__PURE__ */ ((SeabookResourceOrder2) => {
  SeabookResourceOrder2["KeyAsc"] = "key_ASC";
  SeabookResourceOrder2["KeyDesc"] = "key_DESC";
  SeabookResourceOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SeabookResourceOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SeabookResourceOrder2["SysIdAsc"] = "sys_id_ASC";
  SeabookResourceOrder2["SysIdDesc"] = "sys_id_DESC";
  SeabookResourceOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SeabookResourceOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SeabookResourceOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SeabookResourceOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  SeabookResourceOrder2["TypeAsc"] = "type_ASC";
  SeabookResourceOrder2["TypeDesc"] = "type_DESC";
  return SeabookResourceOrder2;
})(SeabookResourceOrder || {});
var SectionTypeLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((SectionTypeLinkingCollectionsPageSectionCollectionOrder2) => {
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SectionTypeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SectionTypeLinkingCollectionsPageSectionCollectionOrder2;
})(SectionTypeLinkingCollectionsPageSectionCollectionOrder || {});
var SectionTypeOrder = /* @__PURE__ */ ((SectionTypeOrder2) => {
  SectionTypeOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SectionTypeOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SectionTypeOrder2["SectionCodeIdAsc"] = "sectionCodeId_ASC";
  SectionTypeOrder2["SectionCodeIdDesc"] = "sectionCodeId_DESC";
  SectionTypeOrder2["SectionTypeAsc"] = "sectionType_ASC";
  SectionTypeOrder2["SectionTypeDesc"] = "sectionType_DESC";
  SectionTypeOrder2["SectionVariantIdAsc"] = "sectionVariantId_ASC";
  SectionTypeOrder2["SectionVariantIdDesc"] = "sectionVariantId_DESC";
  SectionTypeOrder2["SectionVariantAsc"] = "sectionVariant_ASC";
  SectionTypeOrder2["SectionVariantDesc"] = "sectionVariant_DESC";
  SectionTypeOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SectionTypeOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SectionTypeOrder2["SysIdAsc"] = "sys_id_ASC";
  SectionTypeOrder2["SysIdDesc"] = "sys_id_DESC";
  SectionTypeOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SectionTypeOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SectionTypeOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SectionTypeOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SectionTypeOrder2;
})(SectionTypeOrder || {});
var SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder2;
})(SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder || {});
var SimpleStringLinkingCollectionsFooterCollectionOrder = /* @__PURE__ */ ((SimpleStringLinkingCollectionsFooterCollectionOrder2) => {
  SimpleStringLinkingCollectionsFooterCollectionOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringLinkingCollectionsFooterCollectionOrder2;
})(SimpleStringLinkingCollectionsFooterCollectionOrder || {});
var SimpleStringLinkingCollectionsGenericRouteCollectionOrder = /* @__PURE__ */ ((SimpleStringLinkingCollectionsGenericRouteCollectionOrder2) => {
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["RouteCodeAsc"] = "routeCode_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["RouteCodeDesc"] = "routeCode_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringLinkingCollectionsGenericRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringLinkingCollectionsGenericRouteCollectionOrder2;
})(SimpleStringLinkingCollectionsGenericRouteCollectionOrder || {});
var SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder = /* @__PURE__ */ ((SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2) => {
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchAsc"] = "search_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchDesc"] = "search_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextAsc"] = "showResultsText_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextDesc"] = "showResultsText_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder2;
})(SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder || {});
var SimpleStringOrder = /* @__PURE__ */ ((SimpleStringOrder2) => {
  SimpleStringOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SimpleStringOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SimpleStringOrder2["KeyAsc"] = "key_ASC";
  SimpleStringOrder2["KeyDesc"] = "key_DESC";
  SimpleStringOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SimpleStringOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SimpleStringOrder2["SysIdAsc"] = "sys_id_ASC";
  SimpleStringOrder2["SysIdDesc"] = "sys_id_DESC";
  SimpleStringOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SimpleStringOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SimpleStringOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SimpleStringOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SimpleStringOrder2;
})(SimpleStringOrder || {});
var SiteSettingsLinkingCollectionsFooterCollectionOrder = /* @__PURE__ */ ((SiteSettingsLinkingCollectionsFooterCollectionOrder2) => {
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["BusinessUnitAsc"] = "businessUnit_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["BusinessUnitDesc"] = "businessUnit_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelAsc"] = "localeSelectorLabel_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["LocaleSelectorLabelDesc"] = "localeSelectorLabel_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SiteSettingsLinkingCollectionsFooterCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SiteSettingsLinkingCollectionsFooterCollectionOrder2;
})(SiteSettingsLinkingCollectionsFooterCollectionOrder || {});
var SiteSettingsLinkingCollectionsNavigationCollectionOrder = /* @__PURE__ */ ((SiteSettingsLinkingCollectionsNavigationCollectionOrder2) => {
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["BusinessAreaAsc"] = "businessArea_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["BusinessAreaDesc"] = "businessArea_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["OrderAsc"] = "order_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["OrderDesc"] = "order_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SiteSettingsLinkingCollectionsNavigationCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SiteSettingsLinkingCollectionsNavigationCollectionOrder2;
})(SiteSettingsLinkingCollectionsNavigationCollectionOrder || {});
var SiteSettingsOrder = /* @__PURE__ */ ((SiteSettingsOrder2) => {
  SiteSettingsOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  SiteSettingsOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  SiteSettingsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SiteSettingsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SiteSettingsOrder2["SysIdAsc"] = "sys_id_ASC";
  SiteSettingsOrder2["SysIdDesc"] = "sys_id_DESC";
  SiteSettingsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SiteSettingsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SiteSettingsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SiteSettingsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SiteSettingsOrder2;
})(SiteSettingsOrder || {});
var TeamNameLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsArrayOfItemsCollectionOrder2;
})(TeamNameLinkingCollectionsArrayOfItemsCollectionOrder || {});
var TeamNameLinkingCollectionsLongStringCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsLongStringCollectionOrder2) => {
  TeamNameLinkingCollectionsLongStringCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsLongStringCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsLongStringCollectionOrder2;
})(TeamNameLinkingCollectionsLongStringCollectionOrder || {});
var TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2) => {
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["KeyAsc"] = "key_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["KeyDesc"] = "key_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["NamespaceAsc"] = "namespace_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["NamespaceDesc"] = "namespace_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder2;
})(TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder || {});
var TeamNameLinkingCollectionsReleaseNotesCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsReleaseNotesCollectionOrder2) => {
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["VersionNumberAsc"] = "versionNumber_ASC";
  TeamNameLinkingCollectionsReleaseNotesCollectionOrder2["VersionNumberDesc"] = "versionNumber_DESC";
  return TeamNameLinkingCollectionsReleaseNotesCollectionOrder2;
})(TeamNameLinkingCollectionsReleaseNotesCollectionOrder || {});
var TeamNameLinkingCollectionsRichTextStringCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsRichTextStringCollectionOrder2) => {
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsRichTextStringCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsRichTextStringCollectionOrder2;
})(TeamNameLinkingCollectionsRichTextStringCollectionOrder || {});
var TeamNameLinkingCollectionsSimpleStringCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsSimpleStringCollectionOrder2) => {
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["KeyAsc"] = "key_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["KeyDesc"] = "key_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsSimpleStringCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameLinkingCollectionsSimpleStringCollectionOrder2;
})(TeamNameLinkingCollectionsSimpleStringCollectionOrder || {});
var TeamNameLinkingCollectionsTitleAndLinkCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2) => {
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["LinkAsc"] = "link_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["LinkDesc"] = "link_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["TitleAsc"] = "title_ASC";
  TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2["TitleDesc"] = "title_DESC";
  return TeamNameLinkingCollectionsTitleAndLinkCollectionOrder2;
})(TeamNameLinkingCollectionsTitleAndLinkCollectionOrder || {});
var TeamNameLinkingCollectionsTitleAndMediaCollectionOrder = /* @__PURE__ */ ((TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2) => {
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["TitleAsc"] = "title_ASC";
  TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2["TitleDesc"] = "title_DESC";
  return TeamNameLinkingCollectionsTitleAndMediaCollectionOrder2;
})(TeamNameLinkingCollectionsTitleAndMediaCollectionOrder || {});
var TeamNameOrder = /* @__PURE__ */ ((TeamNameOrder2) => {
  TeamNameOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TeamNameOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TeamNameOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TeamNameOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TeamNameOrder2["SysIdAsc"] = "sys_id_ASC";
  TeamNameOrder2["SysIdDesc"] = "sys_id_DESC";
  TeamNameOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TeamNameOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TeamNameOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TeamNameOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TeamNameOrder2;
})(TeamNameOrder || {});
var TerminalLinkingCollectionsPaxRouteCollectionOrder = /* @__PURE__ */ ((TerminalLinkingCollectionsPaxRouteCollectionOrder2) => {
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["NameAsc"] = "name_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["NameDesc"] = "name_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["PaxScheduleApiCodeIdAsc"] = "paxScheduleApiCodeId_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["PaxScheduleApiCodeIdDesc"] = "paxScheduleApiCodeId_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["RouteMarketingTitleAsc"] = "routeMarketingTitle_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["RouteMarketingTitleDesc"] = "routeMarketingTitle_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TerminalLinkingCollectionsPaxRouteCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TerminalLinkingCollectionsPaxRouteCollectionOrder2;
})(TerminalLinkingCollectionsPaxRouteCollectionOrder || {});
var TerminalOrder = /* @__PURE__ */ ((TerminalOrder2) => {
  TerminalOrder2["AddressDescriptionAsc"] = "addressDescription_ASC";
  TerminalOrder2["AddressDescriptionDesc"] = "addressDescription_DESC";
  TerminalOrder2["CountryCodeAsc"] = "countryCode_ASC";
  TerminalOrder2["CountryCodeDesc"] = "countryCode_DESC";
  TerminalOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TerminalOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TerminalOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TerminalOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TerminalOrder2["SysIdAsc"] = "sys_id_ASC";
  TerminalOrder2["SysIdDesc"] = "sys_id_DESC";
  TerminalOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TerminalOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TerminalOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TerminalOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TerminalOrder2["TerminalIdAsc"] = "terminalId_ASC";
  TerminalOrder2["TerminalIdDesc"] = "terminalId_DESC";
  TerminalOrder2["TerminalNameAsc"] = "terminalName_ASC";
  TerminalOrder2["TerminalNameDesc"] = "terminalName_DESC";
  return TerminalOrder2;
})(TerminalOrder || {});
var TestOrder = /* @__PURE__ */ ((TestOrder2) => {
  TestOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TestOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TestOrder2["SysIdAsc"] = "sys_id_ASC";
  TestOrder2["SysIdDesc"] = "sys_id_DESC";
  TestOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TestOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TestOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TestOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TestOrder2;
})(TestOrder || {});
var TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder = /* @__PURE__ */ ((TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2) => {
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SectionHeadingAsc"] = "sectionHeading_ASC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SectionHeadingDesc"] = "sectionHeading_DESC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder2;
})(TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder || {});
var TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder = /* @__PURE__ */ ((TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2) => {
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["ColumnsNumberAsc"] = "columnsNumber_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["ColumnsNumberDesc"] = "columnsNumber_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["HideDescriptionOnIconItemsAsc"] = "hideDescriptionOnIconItems_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["HideDescriptionOnIconItemsDesc"] = "hideDescriptionOnIconItems_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder2;
})(TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder || {});
var TextAndIconItemOrder = /* @__PURE__ */ ((TextAndIconItemOrder2) => {
  TextAndIconItemOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndIconItemOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndIconItemOrder2["IconAsc"] = "icon_ASC";
  TextAndIconItemOrder2["IconDesc"] = "icon_DESC";
  TextAndIconItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndIconItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndIconItemOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndIconItemOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndIconItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndIconItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndIconItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndIconItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TextAndIconItemOrder2["TitleAsc"] = "title_ASC";
  TextAndIconItemOrder2["TitleDesc"] = "title_DESC";
  return TextAndIconItemOrder2;
})(TextAndIconItemOrder || {});
var TextAndIconSectionIconItemsCollectionOrder = /* @__PURE__ */ ((TextAndIconSectionIconItemsCollectionOrder2) => {
  TextAndIconSectionIconItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndIconSectionIconItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndIconSectionIconItemsCollectionOrder2["IconAsc"] = "icon_ASC";
  TextAndIconSectionIconItemsCollectionOrder2["IconDesc"] = "icon_DESC";
  TextAndIconSectionIconItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndIconSectionIconItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndIconSectionIconItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndIconSectionIconItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndIconSectionIconItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndIconSectionIconItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndIconSectionIconItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndIconSectionIconItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TextAndIconSectionIconItemsCollectionOrder2["TitleAsc"] = "title_ASC";
  TextAndIconSectionIconItemsCollectionOrder2["TitleDesc"] = "title_DESC";
  return TextAndIconSectionIconItemsCollectionOrder2;
})(TextAndIconSectionIconItemsCollectionOrder || {});
var TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder2;
})(TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder || {});
var TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder2;
})(TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder || {});
var TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var TextAndIconSectionOrder = /* @__PURE__ */ ((TextAndIconSectionOrder2) => {
  TextAndIconSectionOrder2["ColumnsNumberAsc"] = "columnsNumber_ASC";
  TextAndIconSectionOrder2["ColumnsNumberDesc"] = "columnsNumber_DESC";
  TextAndIconSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndIconSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndIconSectionOrder2["HideDescriptionOnIconItemsAsc"] = "hideDescriptionOnIconItems_ASC";
  TextAndIconSectionOrder2["HideDescriptionOnIconItemsDesc"] = "hideDescriptionOnIconItems_DESC";
  TextAndIconSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  TextAndIconSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  TextAndIconSectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  TextAndIconSectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  TextAndIconSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  TextAndIconSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  TextAndIconSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndIconSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndIconSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndIconSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndIconSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndIconSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndIconSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndIconSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndIconSectionOrder2;
})(TextAndIconSectionOrder || {});
var TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder2;
})(TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder || {});
var TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder2;
})(TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder || {});
var TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var TextAndMediaSectionOrder = /* @__PURE__ */ ((TextAndMediaSectionOrder2) => {
  TextAndMediaSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextAndMediaSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextAndMediaSectionOrder2["HeaderAsc"] = "header_ASC";
  TextAndMediaSectionOrder2["HeaderDesc"] = "header_DESC";
  TextAndMediaSectionOrder2["MediaLayoutAsc"] = "mediaLayout_ASC";
  TextAndMediaSectionOrder2["MediaLayoutDesc"] = "mediaLayout_DESC";
  TextAndMediaSectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  TextAndMediaSectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  TextAndMediaSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextAndMediaSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextAndMediaSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextAndMediaSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextAndMediaSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextAndMediaSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextAndMediaSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextAndMediaSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TextAndMediaSectionOrder2["VariantAsc"] = "variant_ASC";
  TextAndMediaSectionOrder2["VariantDesc"] = "variant_DESC";
  TextAndMediaSectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  TextAndMediaSectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return TextAndMediaSectionOrder2;
})(TextAndMediaSectionOrder || {});
var TextCardLinkingCollectionsTextCardSectionCollectionOrder = /* @__PURE__ */ ((TextCardLinkingCollectionsTextCardSectionCollectionOrder2) => {
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardLinkingCollectionsTextCardSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardLinkingCollectionsTextCardSectionCollectionOrder2;
})(TextCardLinkingCollectionsTextCardSectionCollectionOrder || {});
var TextCardOrder = /* @__PURE__ */ ((TextCardOrder2) => {
  TextCardOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardOrder2["HeaderAsc"] = "header_ASC";
  TextCardOrder2["HeaderDesc"] = "header_DESC";
  TextCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardOrder2;
})(TextCardOrder || {});
var TextCardSectionCardsCollectionOrder = /* @__PURE__ */ ((TextCardSectionCardsCollectionOrder2) => {
  TextCardSectionCardsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardSectionCardsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardSectionCardsCollectionOrder2["HeaderAsc"] = "header_ASC";
  TextCardSectionCardsCollectionOrder2["HeaderDesc"] = "header_DESC";
  TextCardSectionCardsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardSectionCardsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardSectionCardsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardSectionCardsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardSectionCardsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardSectionCardsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardSectionCardsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardSectionCardsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardSectionCardsCollectionOrder2;
})(TextCardSectionCardsCollectionOrder || {});
var TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder2;
})(TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder || {});
var TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder2;
})(TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder || {});
var TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder2;
})(TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder || {});
var TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var TextCardSectionOrder = /* @__PURE__ */ ((TextCardSectionOrder2) => {
  TextCardSectionOrder2["ColumnsAsc"] = "columns_ASC";
  TextCardSectionOrder2["ColumnsDesc"] = "columns_DESC";
  TextCardSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  TextCardSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  TextCardSectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  TextCardSectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  TextCardSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardSectionOrder2;
})(TextCardSectionOrder || {});
var TextCardSectionSectionButtonsCollectionOrder = /* @__PURE__ */ ((TextCardSectionSectionButtonsCollectionOrder2) => {
  TextCardSectionSectionButtonsCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  TextCardSectionSectionButtonsCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  TextCardSectionSectionButtonsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TextCardSectionSectionButtonsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TextCardSectionSectionButtonsCollectionOrder2["IconAsc"] = "icon_ASC";
  TextCardSectionSectionButtonsCollectionOrder2["IconDesc"] = "icon_DESC";
  TextCardSectionSectionButtonsCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  TextCardSectionSectionButtonsCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  TextCardSectionSectionButtonsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TextCardSectionSectionButtonsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TextCardSectionSectionButtonsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TextCardSectionSectionButtonsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TextCardSectionSectionButtonsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TextCardSectionSectionButtonsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TextCardSectionSectionButtonsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TextCardSectionSectionButtonsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TextCardSectionSectionButtonsCollectionOrder2;
})(TextCardSectionSectionButtonsCollectionOrder || {});
var ThemeLinkingCollectionsAppSectionCollectionOrder = /* @__PURE__ */ ((ThemeLinkingCollectionsAppSectionCollectionOrder2) => {
  ThemeLinkingCollectionsAppSectionCollectionOrder2["AppTypeAsc"] = "appType_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["AppTypeDesc"] = "appType_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ThemeLinkingCollectionsAppSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ThemeLinkingCollectionsAppSectionCollectionOrder2;
})(ThemeLinkingCollectionsAppSectionCollectionOrder || {});
var ThemeLinkingCollectionsPageSectionCollectionOrder = /* @__PURE__ */ ((ThemeLinkingCollectionsPageSectionCollectionOrder2) => {
  ThemeLinkingCollectionsPageSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionAsc"] = "displayOption_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["DisplayOptionDesc"] = "displayOption_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileAsc"] = "hideBackgroundImageOnMobile_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["HideBackgroundImageOnMobileDesc"] = "hideBackgroundImageOnMobile_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionAsc"] = "sectionDescription_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SectionDescriptionDesc"] = "sectionDescription_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ThemeLinkingCollectionsPageSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ThemeLinkingCollectionsPageSectionCollectionOrder2;
})(ThemeLinkingCollectionsPageSectionCollectionOrder || {});
var ThemeOrder = /* @__PURE__ */ ((ThemeOrder2) => {
  ThemeOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  ThemeOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  ThemeOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ThemeOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ThemeOrder2["SysIdAsc"] = "sys_id_ASC";
  ThemeOrder2["SysIdDesc"] = "sys_id_DESC";
  ThemeOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ThemeOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ThemeOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ThemeOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ThemeOrder2["ThemeBackgroundColorAsc"] = "themeBackgroundColor_ASC";
  ThemeOrder2["ThemeBackgroundColorDesc"] = "themeBackgroundColor_DESC";
  ThemeOrder2["ThemeNameAsc"] = "themeName_ASC";
  ThemeOrder2["ThemeNameDesc"] = "themeName_DESC";
  ThemeOrder2["ThemeTextColorAsc"] = "themeTextColor_ASC";
  ThemeOrder2["ThemeTextColorDesc"] = "themeTextColor_DESC";
  return ThemeOrder2;
})(ThemeOrder || {});
var TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var TimeTableSectionOrder = /* @__PURE__ */ ((TimeTableSectionOrder2) => {
  TimeTableSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TimeTableSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TimeTableSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  TimeTableSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  TimeTableSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TimeTableSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TimeTableSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TimeTableSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TimeTableSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TimeTableSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TimeTableSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TimeTableSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TimeTableSectionOrder2;
})(TimeTableSectionOrder || {});
var TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder2;
})(TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder || {});
var TitleAndLinkOrder = /* @__PURE__ */ ((TitleAndLinkOrder2) => {
  TitleAndLinkOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TitleAndLinkOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TitleAndLinkOrder2["LinkAsc"] = "link_ASC";
  TitleAndLinkOrder2["LinkDesc"] = "link_DESC";
  TitleAndLinkOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TitleAndLinkOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TitleAndLinkOrder2["SysIdAsc"] = "sys_id_ASC";
  TitleAndLinkOrder2["SysIdDesc"] = "sys_id_DESC";
  TitleAndLinkOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TitleAndLinkOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TitleAndLinkOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TitleAndLinkOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TitleAndLinkOrder2["TitleAsc"] = "title_ASC";
  TitleAndLinkOrder2["TitleDesc"] = "title_DESC";
  return TitleAndLinkOrder2;
})(TitleAndLinkOrder || {});
var TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder = /* @__PURE__ */ ((TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2) => {
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder2;
})(TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder || {});
var TitleAndMediaOrder = /* @__PURE__ */ ((TitleAndMediaOrder2) => {
  TitleAndMediaOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TitleAndMediaOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TitleAndMediaOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TitleAndMediaOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TitleAndMediaOrder2["SysIdAsc"] = "sys_id_ASC";
  TitleAndMediaOrder2["SysIdDesc"] = "sys_id_DESC";
  TitleAndMediaOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TitleAndMediaOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TitleAndMediaOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TitleAndMediaOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TitleAndMediaOrder2["TitleAsc"] = "title_ASC";
  TitleAndMediaOrder2["TitleDesc"] = "title_DESC";
  return TitleAndMediaOrder2;
})(TitleAndMediaOrder || {});
var TrackingAndActivationLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2) => {
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TrackingAndActivationLinkingCollectionsModularPageCollectionOrder2;
})(TrackingAndActivationLinkingCollectionsModularPageCollectionOrder || {});
var TrackingAndActivationOrder = /* @__PURE__ */ ((TrackingAndActivationOrder2) => {
  TrackingAndActivationOrder2["CommercialOwnerAsc"] = "commercialOwner_ASC";
  TrackingAndActivationOrder2["CommercialOwnerDesc"] = "commercialOwner_DESC";
  TrackingAndActivationOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TrackingAndActivationOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TrackingAndActivationOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TrackingAndActivationOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TrackingAndActivationOrder2["SysIdAsc"] = "sys_id_ASC";
  TrackingAndActivationOrder2["SysIdDesc"] = "sys_id_DESC";
  TrackingAndActivationOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TrackingAndActivationOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TrackingAndActivationOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TrackingAndActivationOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  TrackingAndActivationOrder2["TrackingConversionPointAsc"] = "trackingConversionPoint_ASC";
  TrackingAndActivationOrder2["TrackingConversionPointDesc"] = "trackingConversionPoint_DESC";
  TrackingAndActivationOrder2["TrackingNameAsc"] = "trackingName_ASC";
  TrackingAndActivationOrder2["TrackingNameDesc"] = "trackingName_DESC";
  TrackingAndActivationOrder2["TrackingStageAsc"] = "trackingStage_ASC";
  TrackingAndActivationOrder2["TrackingStageDesc"] = "trackingStage_DESC";
  return TrackingAndActivationOrder2;
})(TrackingAndActivationOrder || {});
var TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var TravelSearchSectionOrder = /* @__PURE__ */ ((TravelSearchSectionOrder2) => {
  TravelSearchSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TravelSearchSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TravelSearchSectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  TravelSearchSectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  TravelSearchSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TravelSearchSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TravelSearchSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TravelSearchSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TravelSearchSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TravelSearchSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TravelSearchSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TravelSearchSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TravelSearchSectionOrder2;
})(TravelSearchSectionOrder || {});
var TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder2;
})(TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder || {});
var TrustpilotSectionOrder = /* @__PURE__ */ ((TrustpilotSectionOrder2) => {
  TrustpilotSectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  TrustpilotSectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  TrustpilotSectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TrustpilotSectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TrustpilotSectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TrustpilotSectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TrustpilotSectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TrustpilotSectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TrustpilotSectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TrustpilotSectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TrustpilotSectionOrder2;
})(TrustpilotSectionOrder || {});
var UrlLinkingCollectionsAboutCompositePageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsAboutCompositePageCollectionOrder2) => {
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsAboutCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsAboutCompositePageCollectionOrder2;
})(UrlLinkingCollectionsAboutCompositePageCollectionOrder || {});
var UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2) => {
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryAsc"] = "category_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["CategoryDesc"] = "category_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder2;
})(UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder || {});
var UrlLinkingCollectionsArticleCompositePageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsArticleCompositePageCollectionOrder2) => {
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsArticleCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsArticleCompositePageCollectionOrder2;
})(UrlLinkingCollectionsArticleCompositePageCollectionOrder || {});
var UrlLinkingCollectionsArticlePageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsArticlePageCollectionOrder2) => {
  UrlLinkingCollectionsArticlePageCollectionOrder2["CategoryAsc"] = "category_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["CategoryDesc"] = "category_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["PublishedDateAsc"] = "publishedDate_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["PublishedDateDesc"] = "publishedDate_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsArticlePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsArticlePageCollectionOrder2;
})(UrlLinkingCollectionsArticlePageCollectionOrder || {});
var UrlLinkingCollectionsB2BCompositePageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsB2BCompositePageCollectionOrder2) => {
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsB2BCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsB2BCompositePageCollectionOrder2;
})(UrlLinkingCollectionsB2BCompositePageCollectionOrder || {});
var UrlLinkingCollectionsB2CCompositePageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsB2CCompositePageCollectionOrder2) => {
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsB2CCompositePageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsB2CCompositePageCollectionOrder2;
})(UrlLinkingCollectionsB2CCompositePageCollectionOrder || {});
var UrlLinkingCollectionsLinkCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsLinkCollectionOrder2) => {
  UrlLinkingCollectionsLinkCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["LinkTypeAsc"] = "linkType_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["LinkTypeDesc"] = "linkType_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  UrlLinkingCollectionsLinkCollectionOrder2["TooltipAsc"] = "tooltip_ASC";
  UrlLinkingCollectionsLinkCollectionOrder2["TooltipDesc"] = "tooltip_DESC";
  return UrlLinkingCollectionsLinkCollectionOrder2;
})(UrlLinkingCollectionsLinkCollectionOrder || {});
var UrlLinkingCollectionsModularPageCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsModularPageCollectionOrder2) => {
  UrlLinkingCollectionsModularPageCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsModularPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsModularPageCollectionOrder2;
})(UrlLinkingCollectionsModularPageCollectionOrder || {});
var UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2) => {
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchAsc"] = "search_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SearchDesc"] = "search_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextAsc"] = "showResultsText_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["ShowResultsTextDesc"] = "showResultsText_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder2;
})(UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder || {});
var UrlLinkingCollectionsUrlRedirectCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsUrlRedirectCollectionOrder2) => {
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["PermanentAsc"] = "permanent_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["PermanentDesc"] = "permanent_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsUrlRedirectCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsUrlRedirectCollectionOrder2;
})(UrlLinkingCollectionsUrlRedirectCollectionOrder || {});
var UrlLinkingCollectionsWebLinkCollectionOrder = /* @__PURE__ */ ((UrlLinkingCollectionsWebLinkCollectionOrder2) => {
  UrlLinkingCollectionsWebLinkCollectionOrder2["DisplayTextAsc"] = "displayText_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["DisplayTextDesc"] = "displayText_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["IconAsc"] = "icon_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["IconDesc"] = "icon_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlLinkingCollectionsWebLinkCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlLinkingCollectionsWebLinkCollectionOrder2;
})(UrlLinkingCollectionsWebLinkCollectionOrder || {});
var UrlOrder = /* @__PURE__ */ ((UrlOrder2) => {
  UrlOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  UrlOrder2["UrlTypeAsc"] = "urlType_ASC";
  UrlOrder2["UrlTypeDesc"] = "urlType_DESC";
  UrlOrder2["UrlAsc"] = "url_ASC";
  UrlOrder2["UrlDesc"] = "url_DESC";
  return UrlOrder2;
})(UrlOrder || {});
var UrlRedirectOrder = /* @__PURE__ */ ((UrlRedirectOrder2) => {
  UrlRedirectOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  UrlRedirectOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  UrlRedirectOrder2["PermanentAsc"] = "permanent_ASC";
  UrlRedirectOrder2["PermanentDesc"] = "permanent_DESC";
  UrlRedirectOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlRedirectOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlRedirectOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlRedirectOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlRedirectOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlRedirectOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlRedirectOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlRedirectOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return UrlRedirectOrder2;
})(UrlRedirectOrder || {});
var WebLinkLinkingCollectionsActionCardCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsActionCardCollectionOrder2) => {
  WebLinkLinkingCollectionsActionCardCollectionOrder2["BadgeAsc"] = "badge_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["BadgeDesc"] = "badge_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["CurrencyAsc"] = "currency_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["CurrencyDesc"] = "currency_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["DiscountAsc"] = "discount_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["DiscountDesc"] = "discount_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["HeaderAsc"] = "header_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["HeaderDesc"] = "header_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["PriceAsc"] = "price_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["PriceDesc"] = "price_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SuffixAsc"] = "suffix_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SuffixDesc"] = "suffix_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsActionCardCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsActionCardCollectionOrder2;
})(WebLinkLinkingCollectionsActionCardCollectionOrder || {});
var WebLinkLinkingCollectionsCardsSectionCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsCardsSectionCollectionOrder2) => {
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeAsc"] = "displayType_ASC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["DisplayTypeDesc"] = "displayType_DESC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorAsc"] = "sectionBackgroundAndCardColor_ASC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SectionBackgroundAndCardColorDesc"] = "sectionBackgroundAndCardColor_DESC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsCardsSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsCardsSectionCollectionOrder2;
})(WebLinkLinkingCollectionsCardsSectionCollectionOrder || {});
var WebLinkLinkingCollectionsFeatureListSectionCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2) => {
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsFeatureListSectionCollectionOrder2;
})(WebLinkLinkingCollectionsFeatureListSectionCollectionOrder || {});
var WebLinkLinkingCollectionsHeroSectionCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsHeroSectionCollectionOrder2) => {
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["EyebrowAsc"] = "eyebrow_ASC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["EyebrowDesc"] = "eyebrow_DESC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["TitleAsc"] = "title_ASC";
  WebLinkLinkingCollectionsHeroSectionCollectionOrder2["TitleDesc"] = "title_DESC";
  return WebLinkLinkingCollectionsHeroSectionCollectionOrder2;
})(WebLinkLinkingCollectionsHeroSectionCollectionOrder || {});
var WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2) => {
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["HeadingAsc"] = "heading_ASC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["HeadingDesc"] = "heading_DESC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder2;
})(WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder || {});
var WebLinkLinkingCollectionsMapSectionCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsMapSectionCollectionOrder2) => {
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["MapImageAltTextAsc"] = "mapImageAltText_ASC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["MapImageAltTextDesc"] = "mapImageAltText_DESC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SectionHeadingAsc"] = "sectionHeading_ASC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SectionHeadingDesc"] = "sectionHeading_DESC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsMapSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsMapSectionCollectionOrder2;
})(WebLinkLinkingCollectionsMapSectionCollectionOrder || {});
var WebLinkLinkingCollectionsMediaCardCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsMediaCardCollectionOrder2) => {
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["BadgeAsc"] = "badge_ASC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["BadgeDesc"] = "badge_DESC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["HeaderAsc"] = "header_ASC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["HeaderDesc"] = "header_DESC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsMediaCardCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsMediaCardCollectionOrder2;
})(WebLinkLinkingCollectionsMediaCardCollectionOrder || {});
var WebLinkLinkingCollectionsRichTextItemCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsRichTextItemCollectionOrder2) => {
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["TitleAsc"] = "title_ASC";
  WebLinkLinkingCollectionsRichTextItemCollectionOrder2["TitleDesc"] = "title_DESC";
  return WebLinkLinkingCollectionsRichTextItemCollectionOrder2;
})(WebLinkLinkingCollectionsRichTextItemCollectionOrder || {});
var WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2) => {
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["HeaderAsc"] = "header_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["HeaderDesc"] = "header_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["MediaLayoutAsc"] = "mediaLayout_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["MediaLayoutDesc"] = "mediaLayout_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SectionBackgroundColorAsc"] = "sectionBackgroundColor_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SectionBackgroundColorDesc"] = "sectionBackgroundColor_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VariantAsc"] = "variant_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VariantDesc"] = "variant_DESC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VideoLinkAsc"] = "videoLink_ASC";
  WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2["VideoLinkDesc"] = "videoLink_DESC";
  return WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder2;
})(WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder || {});
var WebLinkLinkingCollectionsTextCardCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsTextCardCollectionOrder2) => {
  WebLinkLinkingCollectionsTextCardCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["HeaderAsc"] = "header_ASC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["HeaderDesc"] = "header_DESC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsTextCardCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsTextCardCollectionOrder2;
})(WebLinkLinkingCollectionsTextCardCollectionOrder || {});
var WebLinkLinkingCollectionsTextCardSectionCollectionOrder = /* @__PURE__ */ ((WebLinkLinkingCollectionsTextCardSectionCollectionOrder2) => {
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["ColumnsAsc"] = "columns_ASC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["ColumnsDesc"] = "columns_DESC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SectionBackgroundAsc"] = "sectionBackground_ASC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SectionBackgroundDesc"] = "sectionBackground_DESC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SectionHeaderAsc"] = "sectionHeader_ASC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SectionHeaderDesc"] = "sectionHeader_DESC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkLinkingCollectionsTextCardSectionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkLinkingCollectionsTextCardSectionCollectionOrder2;
})(WebLinkLinkingCollectionsTextCardSectionCollectionOrder || {});
var WebLinkOrder = /* @__PURE__ */ ((WebLinkOrder2) => {
  WebLinkOrder2["DisplayTextAsc"] = "displayText_ASC";
  WebLinkOrder2["DisplayTextDesc"] = "displayText_DESC";
  WebLinkOrder2["EntryTitleAsc"] = "entryTitle_ASC";
  WebLinkOrder2["EntryTitleDesc"] = "entryTitle_DESC";
  WebLinkOrder2["IconAsc"] = "icon_ASC";
  WebLinkOrder2["IconDesc"] = "icon_DESC";
  WebLinkOrder2["OpenInNewWindowAsc"] = "openInNewWindow_ASC";
  WebLinkOrder2["OpenInNewWindowDesc"] = "openInNewWindow_DESC";
  WebLinkOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WebLinkOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WebLinkOrder2["SysIdAsc"] = "sys_id_ASC";
  WebLinkOrder2["SysIdDesc"] = "sys_id_DESC";
  WebLinkOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WebLinkOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WebLinkOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WebLinkOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return WebLinkOrder2;
})(WebLinkOrder || {});
var FieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    }
  ]
};
var FieldControllerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    }
  ]
};
var FormRowFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormRow" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "columnsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FieldController" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    }
  ]
};
var FormMarkdownFieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMarkdownField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMarkdownField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    }
  ]
};
var FormConsentCheckboxFieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var FormOptionalConsentCheckboxFieldFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormOptionalConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormOptionalConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var FormMessageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMessage" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    }
  ]
};
var FormSubmitButtonFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormSubmitButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormSubmitButton" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }]
      }
    }
  ]
};
var DynamicFormFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DynamicForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Form" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "commercialOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackingName" } },
          { kind: "Field", name: { kind: "Name", value: "trackingStage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trackingConversionPoint" }
          },
          { kind: "Field", name: { kind: "Name", value: "configuration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rowsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "40" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormRow" }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormMarkdownField" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentFieldsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormConsentCheckboxField"
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormOptionalConsentCheckboxField"
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitSuccessMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitFailureMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormSubmitButton" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormRow" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "columnsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FieldController" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMarkdownField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMarkdownField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormOptionalConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormOptionalConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMessage" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormSubmitButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormSubmitButton" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }]
      }
    }
  ]
};
var AssetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var LinkFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var ContentBlockFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var MetaDataAndSeoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MetaDataAndSeo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MetaDataAndSeo" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadataContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageMetaDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "robotsMeta" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var SectionThemeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    }
  ]
};
var AppSectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AppSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "appType" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalContentBlock" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var AccordionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var AccordionGroupItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var PageSectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "displayOption" } },
          { kind: "Field", name: { kind: "Name", value: "columns" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sectionType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionCodeId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariantId" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionLink" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Link" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contentBlocksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Accordion" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Accordion" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccordionGroup" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accordionItemCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "AccordionGroupItem"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "LinksList" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksListTitle" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linksListItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContentBlock" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBackgroundImageOnMobile" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var AssetLinkFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssetLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssetLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "linkText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "asset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var TextAndIconItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TextAndIconItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TextAndIconItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } }
        ]
      }
    }
  ]
};
var WebLinkFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    }
  ]
};
var TextCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TextCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TextCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "checkList" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    }
  ]
};
var AccordionGroupFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroup" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accordionItemCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccordionGroupItem" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var EntryReferenceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EntryReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Entry" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var FreightTerminalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FreightTerminal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FreightTerminal" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EntryReference" }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "terminalId" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EntryReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Entry" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "tooltipText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CheckmarkListSectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckmarkListSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ListItem" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "tooltipText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CheckmarkListGroupFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckmarkListGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListGroup" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "listSectionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CheckmarkListSection" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "EntryReference"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "EntryReference"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "tooltipText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckmarkListSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ListItem" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EntryReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Entry" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var RouteContentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RouteContent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "B2BTimetableSectionContent" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "sailingTime" } },
          { kind: "Field", name: { kind: "Name", value: "vesselName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "manualTable" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "inlineNotification" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EntryReference" }
                },
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "variant" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkmarkListSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CheckmarkListGroup" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accordionGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accordionItemCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AccordionGroupItem"
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "tooltipText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckmarkListSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ListItem" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EntryReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Entry" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckmarkListGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListGroup" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "listSectionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CheckmarkListSection" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "EntryReference"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "EntryReference"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var MediaCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MediaCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MediaCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Asset" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "badge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    }
  ]
};
var ActionCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActionCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ActionCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Asset" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "link" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "badge" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "discount" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    }
  ]
};
var FeatureListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeatureListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FeatureListItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "title" } }
        ]
      }
    }
  ]
};
var LinkListSubsectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkListSubsection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LinkListSubsection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "linkItemsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "WebLink" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "WebLink" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    }
  ]
};
var AboutPageDocument = {
  __meta__: { hash: "88e989c8c2b2c8f473d605d468d8e2eef16223f0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AboutPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "aboutCompositePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AccordionSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "HeroSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndMediaSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "CardsSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndIconSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextCardSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FeatureListSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "MetaDataAndSeo" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MetaDataAndSeo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MetaDataAndSeo" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadataContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageMetaDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "robotsMeta" } }
        ]
      }
    }
  ]
};
var ArticlePageDocument = {
  __meta__: { hash: "ce3ed002e8150896f09923621051ff0d15d8c22f" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArticlePage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articlePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PageSection" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "featuresSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PageSection" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedDate" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "articleRichText" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "links" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entries" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "block" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "__typename"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "inline" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "__typename"
                                          }
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Link"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "linkType"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "hyperlink" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "__typename"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "assets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "block" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "articleSidebar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ContentBlock" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalSectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AppSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AppSection" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "PageSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "PageSection"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "relatedArticlesSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PageSection" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "author" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authorImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadataContent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageMetaDescription" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "socialImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "width" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "height" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "robotsMeta" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "displayOption" } },
          { kind: "Field", name: { kind: "Name", value: "columns" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sectionType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionCodeId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariantId" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionLink" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Link" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contentBlocksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Accordion" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Accordion" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccordionGroup" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accordionItemCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "AccordionGroupItem"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "LinksList" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksListTitle" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linksListItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContentBlock" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBackgroundImageOnMobile" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AppSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "appType" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalContentBlock" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ArticleCategoryOverviewPageByIdDocument = {
  __meta__: { hash: "09554d83d9c84e5ce4275ad938586c717db2d105" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "articleCategoryOverviewPageById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articleCategoryOverviewPage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentfulMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concepts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroSection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PageSection" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadataContent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageMetaDescription" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "socialImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "width" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "height" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "robotsMeta" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "displayOption" } },
          { kind: "Field", name: { kind: "Name", value: "columns" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sectionType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionCodeId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariantId" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionLink" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Link" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contentBlocksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Accordion" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Accordion" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccordionGroup" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accordionItemCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "AccordionGroupItem"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "LinksList" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksListTitle" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linksListItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContentBlock" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBackgroundImageOnMobile" }
          }
        ]
      }
    }
  ]
};
var ArticleCompositePageDocument = {
  __meta__: { hash: "f561262df88bd123aad96cd849b43ded57466eaa" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArticleCompositePage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articleCompositePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ArticleSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "ArticleHeroSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AccordionSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndMediaSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "CardsSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndIconSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextCardSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FeatureListSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "MetaDataAndSeo" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MetaDataAndSeo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MetaDataAndSeo" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadataContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageMetaDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "robotsMeta" } }
        ]
      }
    }
  ]
};
var ArticlesByCategoryDocument = {
  __meta__: { hash: "667690a9c3b7354f739b476772cf402ef2dd13a8" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArticlesByCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "taxonomyConcepts" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articlePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category" }
                      }
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contentfulMetadata" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "concepts" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "descendants" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "id_contains_all"
                                        },
                                        value: {
                                          kind: "Variable",
                                          name: {
                                            kind: "Name",
                                            value: "taxonomyConcepts"
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url_exists" },
                            value: { kind: "BooleanValue", value: true }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "70" }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "EnumValue", value: "publishedDate_DESC" }]
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentfulMetadata" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "concepts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "urlSlug" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heroSection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "contentBlocksCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "ContentBlock"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "primaryText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "richText"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "json"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "assetsCollection"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "items"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "title"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "icon"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "title"
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var B2BPageDocument = {
  __meta__: { hash: "6f8332ab6aecc2b74b8833a81fae1783be76186c" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "B2BPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "b2BCompositePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AccordionSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "HeroSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndMediaSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "CardsSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndIconSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextCardSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "RichTextSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FeatureListSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FormSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "MapSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "B2BTimetableSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "LinkListSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "MetaDataAndSeo" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentfulMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concepts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MetaDataAndSeo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MetaDataAndSeo" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadataContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageMetaDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "robotsMeta" } }
        ]
      }
    }
  ]
};
var B2CPageDocument = {
  __meta__: { hash: "fc675bed6da0e2d1d2673fc95361c96d295f8680" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "B2CPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "b2CCompositePage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AccordionSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "HeroPromotionalSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "HeroSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TimeTableSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "NewsletterSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "ProductCardSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndMediaSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "CardsSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TravelSearchSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TrustpilotSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextCardSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "RichTextSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FeatureListSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FormSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "MapSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "MetaDataAndSeo" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentfulMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concepts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MetaDataAndSeo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MetaDataAndSeo" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metadataContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageMetaDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "pageTitle" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "width" } },
                { kind: "Field", name: { kind: "Name", value: "height" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "robotsMeta" } }
        ]
      }
    }
  ]
};
var BannerCollectionDocument = {
  __meta__: { hash: "3c5117f75653850bd72577e71569d20793324cb2" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "bannerCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "businessArea" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "bannerCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "businessArea_contains_all"
                      },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "businessArea" }
                      }
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "enabled" },
                      value: { kind: "BooleanValue", value: true }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "infoLink" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Link" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Link" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GenericAppSectionDocument = {
  __meta__: { hash: "823f1f2bd5ee176aa4214d71a26b6a87ab1eb1a5" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GenericAppSection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "appSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AppSection" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AppSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AppSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "appType" } },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reference" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "additionalContentBlock" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ContentBlock" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GenericPageSectionDocument = {
  __meta__: { hash: "96d51bef0e1356bef872cec087a8b6c0bca743da" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GenericPageSection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "pageSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageSection" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionTheme" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Theme" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "themeName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "themeBackgroundColor" }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Accordion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Accordion" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "sectionHeader" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionDescription" }
          },
          { kind: "Field", name: { kind: "Name", value: "displayOption" } },
          { kind: "Field", name: { kind: "Name", value: "columns" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionType" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sectionType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionCodeId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionVariantId" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionTheme" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionTheme" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionLink" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Link" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionBackgroundAsset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contentBlocksCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Accordion" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Accordion" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccordionGroup" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "accordionItemCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "AccordionGroupItem"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "LinksList" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksListTitle" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linksListItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "ContentBlock" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "hideBackgroundImageOnMobile" }
          }
        ]
      }
    }
  ]
};
var DynamicFormDocument = {
  __meta__: { hash: "f2be2fccc6676dc3eead206392fd575f20f4778a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DYNAMIC_FORM" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          defaultValue: { kind: "StringValue", value: "en", block: false }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "form" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "DynamicForm" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormRow" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "columnsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FieldController" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMarkdownField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMarkdownField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormOptionalConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormOptionalConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMessage" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormSubmitButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormSubmitButton" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DynamicForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Form" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "commercialOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackingName" } },
          { kind: "Field", name: { kind: "Name", value: "trackingStage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trackingConversionPoint" }
          },
          { kind: "Field", name: { kind: "Name", value: "configuration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rowsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "40" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormRow" }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormMarkdownField" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentFieldsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormConsentCheckboxField"
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormOptionalConsentCheckboxField"
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitSuccessMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitFailureMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormSubmitButton" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ModularPageSectionByIdDocument = {
  __meta__: { hash: "356236737edbdacf1cb5ee78deddf7fe3c6630a1" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ModularPageSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "modularPage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "urlSlug" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "PageSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "sectionType"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "sectionCodeId"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AppSection" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "metaDataAndSeo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "metadataContent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContentBlock" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageMetaDescription" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "socialImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "width" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "height" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "robotsMeta" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Link" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Link" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          { kind: "Field", name: { kind: "Name", value: "linkType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "tooltip" } },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContentBlock" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ContentBlock" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "primaryText" } },
          { kind: "Field", name: { kind: "Name", value: "secondaryText" } },
          { kind: "Field", name: { kind: "Name", value: "tertiaryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Link" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "listOfShortText" } },
          { kind: "Field", name: { kind: "Name", value: "mediaType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "assetsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageDisplayOptions" }
          },
          { kind: "Field", name: { kind: "Name", value: "videoLink" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "icon" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ctasCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Link" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "location" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lon" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var NavigationDocument = {
  __meta__: { hash: "2da19f2ff8bb97ceabd973ad43cd71c67294931d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Navigation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "navigationCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "3" }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayText" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessArea" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "order" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discoverSection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "NavigationDiscoverSection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "search" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "showResultsText"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "searchUrl" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Url"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "contactPagesSection"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "NavigationItem"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sectionItemsCollection"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "items"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value: "Link"
                                                              }
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "sys"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "id"
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "displayText"
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "url"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "url"
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "sys"
                                                                        },
                                                                        selectionSet: {
                                                                          kind: "SelectionSet",
                                                                          selections: [
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "id"
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "customerPortalsSection"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "NavigationItem"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sectionItemsCollection"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "items"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value: "Link"
                                                              }
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "sys"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "id"
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "displayText"
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "url"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "url"
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "sys"
                                                                        },
                                                                        selectionSet: {
                                                                          kind: "SelectionSet",
                                                                          selections: [
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "id"
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "urlType"
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "openInNewWindow"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "localeSelectorHeader"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "key" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "landingPage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Link" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "urlType"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "navigationSectionsCollection"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "NavigationItem"
                                      }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "entryTitle"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "link" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: {
                                                    kind: "Name",
                                                    value: "Link"
                                                  }
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "entryTitle"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "urlType"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "sectionItemsCollection"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "items"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Link"
                                                        }
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "displayText"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "url"
                                                                  }
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "sys"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "id"
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "NavigationItem"
                                                        }
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "entryTitle"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "displayText"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sectionItemsCollection"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "items"
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "InlineFragment",
                                                                        typeCondition: {
                                                                          kind: "NamedType",
                                                                          name: {
                                                                            kind: "Name",
                                                                            value: "Link"
                                                                          }
                                                                        },
                                                                        selectionSet: {
                                                                          kind: "SelectionSet",
                                                                          selections: [
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "sys"
                                                                              },
                                                                              selectionSet: {
                                                                                kind: "SelectionSet",
                                                                                selections: [
                                                                                  {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                      kind: "Name",
                                                                                      value: "id"
                                                                                    }
                                                                                  }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "displayText"
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: "Field",
                                                                              name: {
                                                                                kind: "Name",
                                                                                value: "url"
                                                                              },
                                                                              selectionSet: {
                                                                                kind: "SelectionSet",
                                                                                selections: [
                                                                                  {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                      kind: "Name",
                                                                                      value: "sys"
                                                                                    },
                                                                                    selectionSet: {
                                                                                      kind: "SelectionSet",
                                                                                      selections: [
                                                                                        {
                                                                                          kind: "Field",
                                                                                          name: {
                                                                                            kind: "Name",
                                                                                            value: "id"
                                                                                          }
                                                                                        }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                      kind: "Name",
                                                                                      value: "url"
                                                                                    }
                                                                                  }
                                                                                ]
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Link" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "entryTitle"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "displayText"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "urlType"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "promotionsCollection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ContentBlock"
                                      }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "primaryText"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "secondaryText"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "richText"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "json"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "ctasCollection"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "items"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "linkType"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "displayText"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "assetsCollection"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "items"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Asset"
                                                        }
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "title"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "description"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "size"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "width"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "height"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var FooterNavigationDocument = {
  __meta__: { hash: "80bb3b4b00fe48ca8397b57445b77289b619b2a5" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FooterNavigation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "footerCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "3" }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessUnit" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columnsCollection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "displayText"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "sectionItemsCollection"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "items"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: {
                                                    kind: "Name",
                                                    value: "Link"
                                                  }
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "entryTitle"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "displayText"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "sys"
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id"
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "urlType"
                                                            }
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "url"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "openInNewWindow"
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appLink" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayText" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "urlType" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "socialSection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayText" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "sectionItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Link"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "entryTitle"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "urlType"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "icon"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "title"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "description"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "width"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "height"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "size"
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "legalSection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "sectionItemsCollection"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Link"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "entryTitle"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayText"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sys"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "sys"
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "urlType"
                                                      }
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "url"
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "openInNewWindow"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "siteSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "entryTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "logo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "size" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var PageIdBySlugDocument = {
  __meta__: { hash: "060a71b17eb218e3156508325923f0c579e678eb" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PageIdBySlug" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "urlSlug" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aboutCompositePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "articleCompositePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "b2BCompositePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "b2CCompositePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "modularPageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "articlePageCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "articleCategoryOverviewPageCollection"
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlSlug" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "url" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "urlSlug" }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entryTitle" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var AccordionSectionByIdDocument = {
  __meta__: { hash: "3ac87cf4ab735530dbdc8e7831a9021a40f625eb" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccordionSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "accordionSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionTitle" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionDescription" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                { kind: "Field", name: { kind: "Name", value: "isFaq" } },
                { kind: "Field", name: { kind: "Name", value: "columns" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accordionGroupCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AccordionGroup" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroup" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accordionItemCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccordionGroupItem" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ArticleHeroSectionByIdDocument = {
  __meta__: { hash: "d4ac8aac4a7992b29b95b4774bd6e7e664863eff" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArticleHeroSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articleHeroSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroVideo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Asset" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "quote" } },
                { kind: "Field", name: { kind: "Name", value: "quoteAuthor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Asset" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heroImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Asset" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var ArticleSectionByIdDocument = {
  __meta__: { hash: "22f091c95bb54ba7efa9146103fc9d6d743b758a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArticleSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "articleSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "articleRichText" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "links" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "assets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "hyperlink" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Asset"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "Asset"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "articleSidebar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contentBlock" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "heading" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "richText" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "json" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "links" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "assets"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "hyperlink"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Asset"
                                                        }
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                              kind: "Name",
                                                              value: "Asset"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "author" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "jobTitle" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "authorImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Asset" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedDate" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var B2bTimetableSectionByIdDocument = {
  __meta__: { hash: "669fd51dacadaf7e0222dfdb08a59e2f38eaf267" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "B2bTimetableSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "b2BTimetableSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tableVariant" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "route" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "portOfLoading" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "FreightTerminal" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "portOfDischarge" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "FreightTerminal" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listOfPorts" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tableFooter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "links" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "assets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "hyperlink" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Asset"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "Asset"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundContent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "RouteContent" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inboundContent" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "RouteContent" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EntryReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Entry" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "tooltipText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckmarkListSection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListSection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "itemsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ListItem" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CheckmarkListGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CheckmarkListGroup" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "listSectionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CheckmarkListSection" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "richText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "EntryReference"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "EntryReference"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FreightTerminal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FreightTerminal" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "EntryReference" }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "terminalId" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RouteContent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "B2BTimetableSectionContent" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "sailingTime" } },
          { kind: "Field", name: { kind: "Name", value: "vesselName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "manualTable" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "inlineNotification" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "EntryReference" }
                },
                { kind: "Field", name: { kind: "Name", value: "heading" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "variant" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "checkmarkListSection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CheckmarkListGroup" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accordionGroup" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accordionItemCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AccordionGroupItem"
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CardsSectionByIdDocument = {
  __meta__: { hash: "bc01bdcbdd58a12fbabbd57bbebb47f4aeb723fd" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CardsSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "cardsSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeader" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionDescription" }
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "sectionBackgroundAndCardColor"
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "displayType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "MediaCard" }
                            },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ActionCard" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionButtonsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "WebLink" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "WebLink" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MediaCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MediaCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Asset" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "badge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActionCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ActionCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Asset" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "Asset" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "link" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "badge" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "discount" } },
          { kind: "Field", name: { kind: "Name", value: "suffix" } }
        ]
      }
    }
  ]
};
var FeatureListSectionByIdDocument = {
  __meta__: { hash: "48b486f02d84b3e8f1b28eec0e666d42205d2913" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FeatureListSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "featureListSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeader" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionDescription" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionButtonsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "WebLink" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "WebLink" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionItemsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "FeatureListItem"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "FeatureListItem"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FeatureListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FeatureListItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "icon" } },
          { kind: "Field", name: { kind: "Name", value: "title" } }
        ]
      }
    }
  ]
};
var FormSectionByIdDocument = {
  __meta__: { hash: "7a0a44d138c7cdbb50c669b1733f9a5a940c1a9a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FormSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "formSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeader" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionDescription" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "form" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "DynamicForm" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Field" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Field" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "inputType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "optionsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayValue" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "assistiveText" } },
          { kind: "Field", name: { kind: "Name", value: "placeholder" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          { kind: "Field", name: { kind: "Name", value: "counter" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FieldController" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FieldController" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "field" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Field" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "required" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormRow" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormRow" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "columnsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "2" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FieldController" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMarkdownField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMarkdownField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormOptionalConsentCheckboxField" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormOptionalConsentCheckboxField" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "spaceId" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedVersion" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstPublishedAt" }
                }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "errorMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentText" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "spaceId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "publishedVersion" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstPublishedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "urlSlug" } },
                { kind: "Field", name: { kind: "Name", value: "textBody" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormMessage" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormMessage" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "text" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FormSubmitButton" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FormSubmitButton" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DynamicForm" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Form" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "commercialOwner" } },
          { kind: "Field", name: { kind: "Name", value: "trackingName" } },
          { kind: "Field", name: { kind: "Name", value: "trackingStage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trackingConversionPoint" }
          },
          { kind: "Field", name: { kind: "Name", value: "configuration" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rowsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "40" }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormRow" }
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FormMarkdownField" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentFieldsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Entry" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormConsentCheckboxField"
                        }
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "FormOptionalConsentCheckboxField"
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitSuccessMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitFailureMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormMessage" }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "submitButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FormSubmitButton" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var HeroPromotionalSectionByIdDocument = {
  __meta__: { hash: "23febbc071174ae01692c728dea3af8412fffdf2" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "HeroPromotionalSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "heroPromotionalSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "eyebrow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Asset" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "badge" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "discount" } },
                { kind: "Field", name: { kind: "Name", value: "suffix" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var HeroSectionByIdDocument = {
  __meta__: { hash: "d9f566e9399d0eac7c28d4cfb499afcf61267c5a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "HeroSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "heroSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "eyebrow" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Asset" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linksCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "WebLink" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "WebLink" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    }
  ]
};
var LinkListSectionByIdDocument = {
  __meta__: { hash: "5e94cdb202e13de9e0e58133b895e0ebeeae1361" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LinkListSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "linkListSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeading" }
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "columns" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subsectionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "LinkListSubsection"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "LinkListSubsection"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LinkListSubsection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LinkListSubsection" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "linkItemsCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "WebLink" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "WebLink" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var MapSectionByIdDocument = {
  __meta__: { hash: "bca0f1d931ccc8ad08d4279752787f012a66a46b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MapSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "mapSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeading" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "description" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackgroundColor" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "lat" } },
                      { kind: "Field", name: { kind: "Name", value: "lon" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mapImageAltText" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accordionsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "AccordionGroupItem"
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linksCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "WebLink" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "WebLink" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AssetLink" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AssetLink" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccordionGroupItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccordionGroupItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "entryTitle" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "details" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "json" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entries" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "block" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hyperlink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "Asset" }
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "Asset"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssetLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssetLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "linkText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "asset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var NewsletterSectionByIdDocument = {
  __meta__: { hash: "b73ce0ba47c0dbc10cc0b66be1e3760368027f84" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "NewsletterSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "newsletterSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackgroundColor" }
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Asset" }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Asset" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "textContent" } },
                { kind: "Field", name: { kind: "Name", value: "cdmSourceId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "postUnsubscribeRichText" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preConsentRichText" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    }
  ]
};
var ProductCardSectionByIdDocument = {
  __meta__: { hash: "c16f272795608efc2e5a840e6fc7167043651ee0" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProductCardSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "productCardSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeading" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionDescription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iconItemsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndIconItem"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "TextAndIconItem"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "checkList" } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TextAndIconItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TextAndIconItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } }
        ]
      }
    }
  ]
};
var RichTextSectionByIdDocument = {
  __meta__: { hash: "813e96e977db469b8a30f5c19e73bb4934fe7f83" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RichTextSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "richTextSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeader" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                { kind: "Field", name: { kind: "Name", value: "columns" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "itemsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sys" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "richText" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "json" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "links" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "assets"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "hyperlink"
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Asset"
                                                        }
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                              kind: "Name",
                                                              value: "Asset"
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linksCollection" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "items" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "WebLink"
                                            }
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "FragmentSpread",
                                                name: {
                                                  kind: "Name",
                                                  value: "WebLink"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    }
  ]
};
var TextAndIconSectionByIdDocument = {
  __meta__: { hash: "307512c980378505d8a8085f57903af6b3a48200" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TextAndIconSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "textAndIconSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeader" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionDescription" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hideDescriptionOnIconItems" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "columnsNumber" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "iconItemsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "TextAndIconItem"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "TextAndIconItem"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TextAndIconItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TextAndIconItem" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "icon" } }
        ]
      }
    }
  ]
};
var TextAndMediaSectionByIdDocument = {
  __meta__: { hash: "1fbd18cb0cfefcbc31ae4ab33262ffdccd24122d" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TextAndMediaSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "textAndMediaSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "header" } },
                { kind: "Field", name: { kind: "Name", value: "variant" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackgroundColor" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "description" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "json" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "links" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "assets" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "hyperlink" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "sys" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id"
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "contentType"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "fileName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "size" }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mediaCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Asset" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Asset" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linksCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "WebLink" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "WebLink" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AssetLink" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AssetLink" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "videoLink" } },
                { kind: "Field", name: { kind: "Name", value: "mediaLayout" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "checkmarkList" }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Asset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Asset" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "size" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "width" } },
          { kind: "Field", name: { kind: "Name", value: "height" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AssetLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AssetLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "linkText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "asset" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Asset" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var TextCardSectionByIdDocument = {
  __meta__: { hash: "bca8c84c5afd21ce0ee1771bf1f25e1413922a15" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TextCardSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "textCardSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionHeader" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionDescription" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionButtonsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "WebLink" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "WebLink" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "columns" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "TextCard" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "TextCard" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebLink" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WebLink" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "displayText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "url" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "urlType" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "openInNewWindow" } }
        ]
      }
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TextCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TextCard" }
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sys" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          },
          { kind: "Field", name: { kind: "Name", value: "header" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "checkList" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryButton" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WebLink" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebLink" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var TimeTableSectionByIdDocument = {
  __meta__: { hash: "f546b1647c296eaa3fa7676e9bd4981445d0a65a" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TimeTableSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "timeTableSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "route" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "preview" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "preview" }
                      }
                    }
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "urn" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linkType" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "Route_mivicpf5zews_Master"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                    arguments: [
                                      {
                                        kind: "Argument",
                                        name: { kind: "Name", value: "locale" },
                                        value: {
                                          kind: "Variable",
                                          name: {
                                            kind: "Name",
                                            value: "locale"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "routeCode" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var TravelSearchSectionByIdDocument = {
  __meta__: { hash: "1e7a15953a803e03a1e2a6674a458cdc81aeed7b" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TravelSearchSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "travelSearchSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionBackground" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentRef" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "preview" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "preview" }
                      }
                    }
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "urn" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linkType" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "MiniBook_mivicpf5zews_Master"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "MinibookProductList_mivicpf5zews_Master"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sys" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var TrustpilotSectionByIdDocument = {
  __meta__: { hash: "403f97accb1299e97acf03517b52b30f46d508de" },
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TrustpilotSectionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "preview" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "result" },
            name: { kind: "Name", value: "trustpilotSection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "preview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "preview" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sys" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contentRef" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "preview" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "preview" }
                      }
                    }
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sys" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "urn" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "linkType" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "Trustpilot_mivicpf5zews_Master"
                                }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "linkToTrustpilot"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "templateId" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "theme" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "stars" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tag" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};

// src/api-calls/graphql/forms.ts
function useGetDynamicFormsData({
  client,
  id,
  locale,
  preview
}) {
  const { loading, error, data } = useQuery(DynamicFormDocument, {
    variables: { id, preview, locale },
    fetchPolicy: "network-only",
    client
  });
  return {
    loading,
    form: (data == null ? void 0 : data.form) || void 0,
    error: error == null ? void 0 : error.message
  };
}

// src/utils/locales.ts
var locales = [
  { countryName: "Belgique - Fran\xE7ais", locale: "fr-BE" },
  { countryName: "Belgi\xEB - Nederlands", locale: "nl-BE" },
  { countryName: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F", locale: "bg-BG" },
  { countryName: "\u010Cesk\xE1 republika", locale: "cs-CZ" },
  { countryName: "Deutschland", locale: "de-DE" },
  { countryName: "Danmark", locale: "da-DK" },
  { countryName: "Eesti", locale: "et-EE" },
  { countryName: "Espa\xF1a", locale: "es-ES" },
  { countryName: "France", locale: "fr-FR" },
  { countryName: "Italia", locale: "it-IT" },
  { countryName: "Lietuva", locale: "lt-LT" },
  { countryName: "Latvija", locale: "lv-LV" },
  { countryName: "Maroc - Fran\xE7ais", locale: "fr-MA" },
  { countryName: "Nederland", locale: "nl-NL" },
  { countryName: "Norge", locale: "nb-NO" },
  { countryName: "Polska", locale: "pl-PL" },
  { countryName: "Rom\xE2nia", locale: "ro-RO" },
  { countryName: "\u0420\u043E\u0441\u0441\u0438\u044F", locale: "ru-RU" },
  { countryName: "Slovensko", locale: "sk-SK" },
  { countryName: "Suomi", locale: "fi-FI" },
  { countryName: "Sverige", locale: "sv-SE" },
  { countryName: "United Kingdom", locale: "en-GB" },
  { countryName: "T\xFCrkiye", locale: "tr-TR" },
  { countryName: "International", locale: "en" }
];
var availableLocales = new Set(
  locales.map((loc) => loc.locale.toLocaleLowerCase())
);

// src/cms/__generated__/strings.json
var strings_exports = {};
__export(strings_exports, {
  B2B_TIMETABLE_ARRIVAL_DATE: () => B2B_TIMETABLE_ARRIVAL_DATE,
  B2B_TIMETABLE_ARRIVAL_TIME: () => B2B_TIMETABLE_ARRIVAL_TIME,
  B2B_TIMETABLE_DEPARTURE_DATE: () => B2B_TIMETABLE_DEPARTURE_DATE,
  B2B_TIMETABLE_DEPARTURE_TIME: () => B2B_TIMETABLE_DEPARTURE_TIME,
  B2B_TIMETABLE_ERROR_BODY: () => B2B_TIMETABLE_ERROR_BODY,
  B2B_TIMETABLE_ERROR_HEADING: () => B2B_TIMETABLE_ERROR_HEADING,
  B2B_TIMETABLE_NEXT_DAY_ARRIVAL: () => B2B_TIMETABLE_NEXT_DAY_ARRIVAL,
  B2B_TIMETABLE_NO_SAILINGS_BODY: () => B2B_TIMETABLE_NO_SAILINGS_BODY,
  B2B_TIMETABLE_NO_SAILINGS_HEADING: () => B2B_TIMETABLE_NO_SAILINGS_HEADING,
  B2B_TIMETABLE_RELOAD_PAGE: () => B2B_TIMETABLE_RELOAD_PAGE,
  B2B_TIMETABLE_SAILING_TIME: () => B2B_TIMETABLE_SAILING_TIME,
  B2B_TIMETABLE_SWITCH_DIRECTION: () => B2B_TIMETABLE_SWITCH_DIRECTION,
  B2B_TIMETABLE_UNKNOWN_VESSEL: () => B2B_TIMETABLE_UNKNOWN_VESSEL,
  B2B_TIMETABLE_VESSEL: () => B2B_TIMETABLE_VESSEL,
  B2B_TIMETABLE_WEEK_PICKER_LABEL: () => B2B_TIMETABLE_WEEK_PICKER_LABEL,
  "UNIFIED-WEB-AND": () => UNIFIED_WEB_AND,
  "UNIFIED-WEB-ARRIVAL": () => UNIFIED_WEB_ARRIVAL,
  "UNIFIED-WEB-ARTICLE-CATEGORY-ARTICLES": () => UNIFIED_WEB_ARTICLE_CATEGORY_ARTICLES,
  "UNIFIED-WEB-ARTICLE-CATEGORY-BLOG-POSTS": () => UNIFIED_WEB_ARTICLE_CATEGORY_BLOG_POSTS,
  "UNIFIED-WEB-ARTICLE-CATEGORY-CASE-STUDIES": () => UNIFIED_WEB_ARTICLE_CATEGORY_CASE_STUDIES,
  "UNIFIED-WEB-ARTICLE-CATEGORY-EVENTS": () => UNIFIED_WEB_ARTICLE_CATEGORY_EVENTS,
  "UNIFIED-WEB-ARTICLE-CATEGORY-EXPERT-OPINIONS": () => UNIFIED_WEB_ARTICLE_CATEGORY_EXPERT_OPINIONS,
  "UNIFIED-WEB-ARTICLE-CATEGORY-NEWS": () => UNIFIED_WEB_ARTICLE_CATEGORY_NEWS,
  "UNIFIED-WEB-ARTICLE-CATEGORY-UNDERSTANDING-DECARBONISATION": () => UNIFIED_WEB_ARTICLE_CATEGORY_UNDERSTANDING_DECARBONISATION,
  "UNIFIED-WEB-ARTICLE-CATEGORY-WEBINARS": () => UNIFIED_WEB_ARTICLE_CATEGORY_WEBINARS,
  "UNIFIED-WEB-BLOG-MIN-READ": () => UNIFIED_WEB_BLOG_MIN_READ,
  "UNIFIED-WEB-BLOG-PUBLISHED": () => UNIFIED_WEB_BLOG_PUBLISHED,
  "UNIFIED-WEB-BLOG-SHARE": () => UNIFIED_WEB_BLOG_SHARE,
  "UNIFIED-WEB-CHECK-IN-CLOSES": () => UNIFIED_WEB_CHECK_IN_CLOSES,
  "UNIFIED-WEB-CLOSE": () => UNIFIED_WEB_CLOSE,
  "UNIFIED-WEB-DEPARTURE": () => UNIFIED_WEB_DEPARTURE,
  "UNIFIED-WEB-DEPARTURE-DATE": () => UNIFIED_WEB_DEPARTURE_DATE,
  "UNIFIED-WEB-DURATION": () => UNIFIED_WEB_DURATION,
  "UNIFIED-WEB-EMAIL-ADDRESS": () => UNIFIED_WEB_EMAIL_ADDRESS,
  "UNIFIED-WEB-EMAIL-IS-MISSING-FOR-UNSUBSCRIBE": () => UNIFIED_WEB_EMAIL_IS_MISSING_FOR_UNSUBSCRIBE,
  "UNIFIED-WEB-FERRY-CROSSING-PRICE-DISCLAIMER": () => UNIFIED_WEB_FERRY_CROSSING_PRICE_DISCLAIMER,
  "UNIFIED-WEB-FIELD-INVALID-EMAIL": () => UNIFIED_WEB_FIELD_INVALID_EMAIL,
  "UNIFIED-WEB-FIELD-REQUIRED": () => UNIFIED_WEB_FIELD_REQUIRED,
  "UNIFIED-WEB-FROM": () => UNIFIED_WEB_FROM,
  "UNIFIED-WEB-HOUR": () => UNIFIED_WEB_HOUR,
  "UNIFIED-WEB-HOURS": () => UNIFIED_WEB_HOURS,
  "UNIFIED-WEB-JUST-ONE-MORE-CLICK": () => UNIFIED_WEB_JUST_ONE_MORE_CLICK,
  "UNIFIED-WEB-LANGUAGE-SELECTOR-HEADER": () => UNIFIED_WEB_LANGUAGE_SELECTOR_HEADER,
  "UNIFIED-WEB-MINUTES": () => UNIFIED_WEB_MINUTES,
  "UNIFIED-WEB-NEXT-AVAILABLE-DATE": () => UNIFIED_WEB_NEXT_AVAILABLE_DATE,
  "UNIFIED-WEB-NO-SAILINGS": () => UNIFIED_WEB_NO_SAILINGS,
  "UNIFIED-WEB-PLEASE-TRY-DIFFERENT-DATE": () => UNIFIED_WEB_PLEASE_TRY_DIFFERENT_DATE,
  "UNIFIED-WEB-PLEASE-WAIT": () => UNIFIED_WEB_PLEASE_WAIT,
  "UNIFIED-WEB-PROMOTION-FROM": () => UNIFIED_WEB_PROMOTION_FROM,
  "UNIFIED-WEB-SAILINGS-IN-LOCAL-TIME": () => UNIFIED_WEB_SAILINGS_IN_LOCAL_TIME,
  "UNIFIED-WEB-SCHEDULE-SUBJECT-TO-WEATHER-CONDITIONS": () => UNIFIED_WEB_SCHEDULE_SUBJECT_TO_WEATHER_CONDITIONS,
  "UNIFIED-WEB-SELECT-A-DATE": () => UNIFIED_WEB_SELECT_A_DATE,
  "UNIFIED-WEB-SIGN-ME-UP": () => UNIFIED_WEB_SIGN_ME_UP,
  "UNIFIED-WEB-SOMETHING-WENT-WRONG-WITH-UNSUBSCRIBE": () => UNIFIED_WEB_SOMETHING_WENT_WRONG_WITH_UNSUBSCRIBE,
  "UNIFIED-WEB-TO": () => UNIFIED_WEB_TO,
  "UNIFIED-WEB-TO-ACTIVATE-YOUR-SUBSCRIPTION": () => UNIFIED_WEB_TO_ACTIVATE_YOUR_SUBSCRIPTION,
  "UNIFIED-WEB-UNSUBSCRIBE": () => UNIFIED_WEB_UNSUBSCRIBE,
  "UNIFIED-WEB-UNSUBSCRIBE-FROM-THE-NEWSLETTER-AT": () => UNIFIED_WEB_UNSUBSCRIBE_FROM_THE_NEWSLETTER_AT,
  default: () => strings_default
});
var UNIFIED_WEB_SCHEDULE_SUBJECT_TO_WEATHER_CONDITIONS = {
  "bg-BG": "\u041C\u043E\u043B\u044F, \u0438\u043C\u0430\u0439\u0442\u0435 \u043F\u0440\u0435\u0434\u0432\u0438\u0434, \u0447\u0435 \u0440\u0430\u0437\u043F\u0438\u0441\u0430\u043D\u0438\u044F\u0442\u0430 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0441\u0435 \u043F\u0440\u043E\u043C\u0435\u043D\u044F\u0442 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442 \u043E\u0442 \u043C\u0435\u0442\u0435\u043E\u0440\u043E\u043B\u043E\u0433\u0438\u0447\u043D\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F.",
  "cs-CZ": "Upozor\u0148ujeme, \u017Ee j\xEDzdn\xED \u0159\xE1dy se mohou zm\u011Bnit v z\xE1vislosti na pov\u011Btrnostn\xEDch podm\xEDnk\xE1ch.",
  "da-DK": "Tidsplanen kan \xE6ndre sig, alt efter vejrforholdene.",
  "de-DE": "Bitte beachten Sie, dass sich die Fahrpl\xE4ne je nach Wetterlage \xE4ndern k\xF6nnen.",
  en: "Please note that timetables may change subject to weather conditions.",
  "es-ES": "Tenga en cuenta que los horarios pueden cambiar seg\xFAn las condiciones meteorol\xF3gicas.",
  "et-EE": "Pange t\xE4hele, s\xF5idugraafikud v\xF5ivad ilmastikutingimuste t\xF5ttu muutuda.",
  "fi-FI": "Huomioithan, ett\xE4 aikataulut voivat muuttua s\xE4\xE4olosuhteiden vuoksi.",
  "fr-FR": "Veuillez noter que les horaires peuvent changer en raison des conditions m\xE9t\xE9orologiques.",
  "fr-BE": "Veuillez noter que les horaires peuvent changer en raison des conditions m\xE9t\xE9orologiques.",
  "it-IT": "Si prega di notare che gli orari possono variare in base alle condizioni meteorologiche.",
  "ja-JP": "\u5929\u5019\u72B6\u6CC1\u306B\u3088\u308A\u3001\u6642\u523B\u8868\u304C\u5909\u66F4\u3055\u308C\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002",
  "ko-KR": "\uB0A0\uC528 \uC870\uAC74\uC5D0 \uB530\uB77C \uC2DC\uAC04\uD45C\uAC00 \uBCC0\uACBD\uB420 \uC218 \uC788\uC73C\uB2C8 \uCC38\uACE0\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.",
  "lt-LT": "Atkreipkite d\u0117mes\u012F, kad tvarkara\u0161\u010Diai gali keistis, priklausomai nuo oro s\u0105lyg\u0173.",
  "lv-LV": "L\u016Bdzam \u0146emt v\u0113r\u0101, ka kurs\u0113\u0161anas grafiks var main\u012Bties atkar\u012Bb\u0101 no laika apst\u0101k\u013Ciem.",
  "nl-NL": "Houd er rekening mee dat de dienstregeling kan veranderen afhankelijk van de weersomstandigheden.",
  "nl-BE": "Houd er rekening mee dat de dienstregeling kan veranderen afhankelijk van de weersomstandigheden.",
  "nb-NO": "Merk at seilplanen kan variere grunnet v\xE6rforhold.",
  "pl-PL": "Nale\u017Cy pami\u0119ta\u0107, \u017Ce rozk\u0142ady jazdy mog\u0105 ulec zmianie w zale\u017Cno\u015Bci od warunk\xF3w pogodowych.",
  "pt-BR": "Por favor, note que os hor\xE1rios podem mudar devido \xE0s condi\xE7\xF5es meteorol\xF3gicas.",
  "ro-RO": "V\u0103 rug\u0103m s\u0103 re\u021Bine\u021Bi c\u0103 orarele pot fi modificate \xEEn func\u021Bie de condi\u021Biile meteorologice.",
  "ru-RU": "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435, \u0447\u0442\u043E \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043C\u043E\u0433\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C\u0441\u044F \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u043F\u043E\u0433\u043E\u0434\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u0439.",
  "sk-SK": "Upozor\u0148ujeme, \u017Ee cestovn\xE9 poriadky sa m\xF4\u017Eu zmeni\u0165 v z\xE1vislosti od poveternostn\xFDch podmienok.",
  "sv-SE": "Tidsplanen kan \xE4ndras beroende p\xE5 v\xE4derf\xF6rh\xE5llanden.",
  "tr-TR": "L\xFCtfen, hava ko\u015Fullar\u0131na ba\u011Fl\u0131 olarak tarifelerin de\u011Fi\u015Febilece\u011Fini unutmay\u0131n.",
  "zh-CN": "\u8BF7\u6CE8\u610F\uFF0C\u65F6\u95F4\u8868\u53EF\u80FD\u4F1A\u56E0\u5929\u6C14\u72B6\u51B5\u800C\u66F4\u6539\u3002",
  "en-GB": "Please note that timetables may change subject to weather conditions.",
  "fr-MA": "Veuillez noter que les horaires peuvent changer en raison des conditions m\xE9t\xE9orologiques."
};
var B2B_TIMETABLE_ARRIVAL_DATE = {
  "da-DK": "Ankomstdato",
  "de-DE": "Datum der Ankunft",
  en: "Arrival date",
  "es-ES": "Fecha de llegada",
  "fr-FR": "Date d'arriv\xE9e",
  "it-IT": "Data di arrivo",
  "nl-NL": "Aankomstdatum",
  "pl-PL": "Data przybycia",
  "sv-SE": "Ankomstdatum",
  "tr-TR": "Var\u0131\u015F tarihi"
};
var B2B_TIMETABLE_VESSEL = {
  "da-DK": "Fart\xF8j",
  "de-DE": "Schiff",
  en: "Vessel",
  "es-ES": "Buque",
  "fr-FR": "Navire",
  "it-IT": "Nave",
  "nl-NL": "Schip",
  "pl-PL": "Statek",
  "sv-SE": "Fartyg",
  "tr-TR": "Gemi"
};
var B2B_TIMETABLE_RELOAD_PAGE = {
  "da-DK": "Genindl\xE6s siden",
  "de-DE": "Seite neu laden",
  en: "Reload page",
  "es-ES": "Recargar p\xE1gina",
  "fr-FR": "Recharger la page",
  "it-IT": "Ricarica la pagina",
  "nl-NL": "Pagina opnieuw laden",
  "pl-PL": "Od\u015Bwie\u017C stron\u0119",
  "sv-SE": "Ladda om sidan",
  "tr-TR": "Sayfay\u0131 yeniden y\xFCkle"
};
var B2B_TIMETABLE_SAILING_TIME = {
  "da-DK": "Sejltid",
  "de-DE": "Fahrtzeit",
  en: "Sailing time",
  "es-ES": "Tiempo de navegaci\xF3n",
  "fr-FR": "Temps de navigation",
  "it-IT": "Tempo di navigazione",
  "nl-NL": "Vaartijd",
  "pl-PL": "Czas trwania przeprawy",
  "sv-SE": "Restid",
  "tr-TR": "Sefer s\xFCresi"
};
var B2B_TIMETABLE_NEXT_DAY_ARRIVAL = {
  "da-DK": "Ankomst n\xE6ste dag",
  "de-DE": "Ankunft am n\xE4chsten Tag",
  en: "Next day arrival",
  "es-ES": "Llegada al d\xEDa siguiente",
  "fr-FR": "Arriv\xE9e le lendemain",
  "it-IT": "Arrivo il giorno successivo",
  "nl-NL": "Aankomst op volgende dag",
  "pl-PL": "Przyjazd nast\u0119pnego dnia",
  "sv-SE": "Ankomst n\xE4sta dag",
  "tr-TR": "Ertesi g\xFCn var\u0131\u015F"
};
var B2B_TIMETABLE_DEPARTURE_TIME = {
  "da-DK": "Afgangstid",
  "de-DE": "Abfahrtszeit",
  en: "Departure time",
  "es-ES": "Hora de salida",
  "fr-FR": "Heure de d\xE9part",
  "it-IT": "Orario di partenza",
  "nl-NL": "Vertrektijd",
  "pl-PL": "Godzina wyp\u0142yni\u0119cia",
  "sv-SE": "Avg\xE5ngstid",
  "tr-TR": "Kalk\u0131\u015F saati"
};
var B2B_TIMETABLE_ARRIVAL_TIME = {
  "da-DK": "Ankomsttid",
  "de-DE": "Ankunftszeit",
  en: "Arrival time",
  "es-ES": "Hora de llegada",
  "fr-FR": "Heure d'arriv\xE9e",
  "it-IT": "Orario di arrivo",
  "nl-NL": "Aankomsttijd",
  "pl-PL": "Godzina przybycia",
  "sv-SE": "Ankomsttid",
  "tr-TR": "Var\u0131\u015F saati"
};
var B2B_TIMETABLE_SWITCH_DIRECTION = {
  "da-DK": "Skift retning",
  "de-DE": "Fahrtrichtung wechseln",
  en: "Switch direction",
  "es-ES": "Invertir direcci\xF3n",
  "fr-FR": "Sens inverse",
  "it-IT": "Inverti direzione",
  "nl-NL": "Omgekeerde richting",
  "pl-PL": "Zmie\u0144 kierunek",
  "sv-SE": "Byt riktning",
  "tr-TR": "Y\xF6n de\u011Fi\u015Ftirin"
};
var B2B_TIMETABLE_WEEK_PICKER_LABEL = {
  "da-DK": "V\xE6lg en dato",
  "de-DE": "Datum ausw\xE4hlen",
  en: "Select a date",
  "es-ES": "Seleccionar una fecha",
  "fr-FR": "S\xE9lectionner une date",
  "it-IT": "Seleziona una data",
  "nl-NL": "Een datum selecteren",
  "pl-PL": "Wybierz dat\u0119",
  "sv-SE": "V\xE4lj ett datum",
  "tr-TR": "Bir tarih se\xE7in"
};
var B2B_TIMETABLE_ERROR_BODY = {
  "da-DK": "Afgangene kunne ikke indl\xE6ses. Genindl\xE6s siden eller pr\xF8v igen senere.",
  "de-DE": "Die Abfahrten konnten nicht geladen werden. Bitte laden Sie die Seite neu oder versuchen Sie es sp\xE4ter erneut.",
  en: "The sailings couldn't be loaded. Please reload the page or try again later.",
  "es-ES": "No se pudieron cargar las salidas. Vuelva a cargar la p\xE1gina o int\xE9ntelo de nuevo m\xE1s tarde.",
  "fr-FR": "Les d\xE9parts n'ont pas pu \xEAtre charg\xE9s. Veuillez rafra\xEEchir la page ou r\xE9essayer plus tard.",
  "it-IT": "Non \xE8 stato possibile caricare le partenze. Ricarica la pagina o riprova pi\xF9 tardi.",
  "nl-NL": "De vertrekken konden niet worden geladen. Laad de pagina opnieuw of probeer het later nogmaals.",
  "pl-PL": "Nie uda\u0142o si\u0119 za\u0142adowa\u0107 wyp\u0142yni\u0119\u0107. Od\u015Bwie\u017C stron\u0119 lub spr\xF3buj ponownie p\xF3\u017Aniej.",
  "sv-SE": "Avg\xE5ngarna kunde inte laddas. Ladda om sidan eller f\xF6rs\xF6k igen senare.",
  "tr-TR": "Seferler y\xFCklenemedi. L\xFCtfen sayfay\u0131 yeniden y\xFCkleyin veya daha sonra tekrar deneyin."
};
var B2B_TIMETABLE_NO_SAILINGS_HEADING = {
  "da-DK": "Ingen afgange fundet",
  "de-DE": "Keine Abfahrten gefunden",
  en: "No sailings found",
  "es-ES": "No se han encontrado salidas",
  "fr-FR": "Aucun d\xE9part trouv\xE9",
  "it-IT": "Nessuna partenza trovata",
  "nl-NL": "Geen vertrekken gevonden",
  "pl-PL": "Nie znaleziono wyp\u0142yni\u0119\u0107",
  "sv-SE": "Inga avg\xE5ngar hittades",
  "tr-TR": "Sefer bulunamad\u0131"
};
var B2B_TIMETABLE_ERROR_HEADING = {
  "da-DK": "Der opstod en fejl",
  "de-DE": "Ein Fehler ist aufgetreten",
  en: "Something went wrong",
  "es-ES": "Algo ha ido mal",
  "fr-FR": "Une erreur est survenue",
  "it-IT": "Si \xE8 verificato un problema",
  "nl-NL": "Er is iets verkeerd gegaan",
  "pl-PL": "Wyst\u0105pi\u0142 b\u0142\u0105d",
  "sv-SE": "N\xE5got gick fel",
  "tr-TR": "Bir sorun olu\u015Ftu"
};
var B2B_TIMETABLE_DEPARTURE_DATE = {
  "da-DK": "Afgangsdato",
  "de-DE": "Datum der Abfahrt",
  en: "Departure date",
  "es-ES": "Fecha de salida",
  "fr-FR": "Date de d\xE9part",
  "it-IT": "Data di partenza",
  "nl-NL": "Vertrekdatum",
  "pl-PL": "Data wyp\u0142yni\u0119cia",
  "sv-SE": "Avg\xE5ngsdatum",
  "tr-TR": "Kalk\u0131\u015F tarihi"
};
var B2B_TIMETABLE_NO_SAILINGS_BODY = {
  "da-DK": "Pr\xF8v at v\xE6lge en anden uge eller download PDF-skemaet for at se afgangene.",
  "de-DE": "W\xE4hlen Sie eine andere Woche aus oder laden Sie den PDF-Fahrplan herunter, um die Abfahrtszeiten zu sehen.",
  en: "Try selecting a different week or download the PDF schedule to see the sailing times.",
  "es-ES": "Pruebe a seleccionar otra semana o descargue el horario en PDF para ver las salidas.",
  "fr-FR": "Essayez de s\xE9lectionner une autre semaine ou t\xE9l\xE9chargez le planning PDF pour consulter les d\xE9parts.",
  "it-IT": "Prova a selezionare una settimana diversa o scarica il programma in PDF per vedere le partenze.",
  "nl-NL": "Probeer een andere week te selecteren of download het PDF-schema om de vertrekken te bekijken.",
  "pl-PL": "Spr\xF3buj wybra\u0107 inny tydzie\u0144 lub pobierz rozk\u0142ad PDF, aby sprawdzi\u0107 godziny wyp\u0142yni\u0119\u0107.",
  "sv-SE": "Prova att v\xE4lja en annan vecka eller ladda ner tidtabellen i PDF-format f\xF6r att se avg\xE5ngarna.",
  "tr-TR": "Farkl\u0131 bir hafta se\xE7meyi deneyin veya sefer saatlerini g\xF6rmek i\xE7in PDF'i indirin."
};
var B2B_TIMETABLE_UNKNOWN_VESSEL = {
  "da-DK": "Ukendt",
  "de-DE": "Unbekannt",
  en: "Unknown",
  "es-ES": "No consta",
  "fr-FR": "Inconnu",
  "it-IT": "Non disponibile",
  "nl-NL": "Onbekend",
  "pl-PL": "Nieznany",
  "sv-SE": "Ok\xE4nt",
  "tr-TR": "Bilinmiyor"
};
var UNIFIED_WEB_FERRY_CROSSING_PRICE_DISCLAIMER = {
  "bg-BG": "\u0426\u0435\u043D\u0438\u0442\u0435 \u0441\u0430 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442 \u043E\u0442 \u043D\u0430\u043B\u0438\u0447\u043D\u043E\u0441\u0442\u0442\u0430. \u041F\u0440\u0438\u043B\u0430\u0433\u0430\u0442 \u0441\u0435 \u0442\u0430\u043A\u0441\u0438 \u0437\u0430 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u044F \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430. \u041F\u0440\u0438\u043B\u0430\u0433\u0430\u0442 \u0441\u0435 \u041E\u0431\u0449\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F.",
  "cs-CZ": "Ceny jsou z\xE1visl\xE9 na dostupnosti. Telefonick\xE9 rezerva\u010Dn\xED poplatky plat\xED. Plat\xED podm\xEDnky a podm\xEDnky.",
  "da-DK": "Prisen afh\xE6nger af ledig kapacitet med forbehold for udsolgte dage. Till\xE6g ved bestilling online, pr. telefon og personlig henvendelse. Vilk\xE5r og betingelser er g\xE6ldende.",
  "de-DE": "Preise je nach Verf\xFCgbarkeit. Es gelten telefonische Buchungsgeb\xFChren.\xA0Es gelten die Allgemeinen Gesch\xE4ftsbedingungen.",
  en: "Prices are subject to availability. Telephone booking fees apply. Terms and conditions apply.",
  "es-ES": "Los precios est\xE1n sujetos a disponibilidad. Se aplican tarifas sobre reserva telef\xF3nica. Se aplican t\xE9rminos y Condiciones.",
  "et-EE": "Laevapiletite hinnad v\xF5ivad varieeruda vastavalt laeva mahutavusele. ",
  "fi-FI": "Hinnat riippuvat saatavuudesta. Puhelinvarausmaksuja sovelletaan. Ehdot ovat voimassa.",
  "fr-FR": "Les prix sont soumis \xE0 disponibilit\xE9. Des frais s\u2019appliquent pour les r\xE9servations faites par t\xE9l\xE9phone. Les conditions g\xE9n\xE9rales de vente s\u2019appliquent.",
  "fr-BE": "Les prix sont soumis \xE0 disponibilit\xE9. Des frais s\u2019appliquent pour les r\xE9servations faites par t\xE9l\xE9phone. Les conditions g\xE9n\xE9rales de vente s\u2019appliquent.",
  "it-IT": "I prezzi sono soggetti a disponibilit\xE0. Si applica una spesa su prenotazioni telefoniche. Si applicano i termini e condizioni.",
  "ja-JP": "\u4FA1\u683C\u306F\u7A7A\u5BA4\u72B6\u6CC1\u306B\u3088\u308A\u307E\u3059\u3002 \u96FB\u8A71\u4E88\u7D04\u6599\u304C\u304B\u304B\u308A\u307E\u3059\u3002 \u898F\u7D04\u304C\u9069\u7528\u3055\u308C\u307E\u3059\u3002",
  "ko-KR": "\uAC00\uACA9\uC740 \uC774\uC6A9 \uAC00\uB2A5 \uC5EC\uBD80\uC5D0 \uB530\uB77C \uB2EC\uB77C\uC9C8 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC804\uD654 \uC608\uC57D \uC218\uC218\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4. \uC774\uC6A9 \uC57D\uAD00\uC5D0 \uB3D9\uC758.",
  "lt-LT": "Biliet\u0173 kainos priklauso nuo likusi\u0173 laisv\u0173 viet\u0173 skai\u010Diaus. Taikomi mokes\u010Diai u\u017Esakant telefonu. Taikomos s\u0105lygos. Taikoma kuro priemoka.",
  "lv-LV": "Cenas ir atkar\u012Bgas no pieejam\u012Bbas. Veicot rezerv\u0101ciju pa t\u0101lruni, tiek piem\u0113rota papildus maksa. Tiek piem\u0113roti noteikumi un nosac\u012Bjumi.",
  "nl-NL": "Prijzen zijn afhankelijk van beschikbaarheid. Telefonische reserveringskosten zijn van toepassing. Algemene voorwaarden zijn van toepassing.",
  "nl-BE": "Prijzen zijn afhankelijk van beschikbaarheid. Telefonische reserveringskosten zijn van toepassing. Algemene voorwaarden zijn van toepassing.",
  "nb-NO": "Prisen er avhengig av ledig kapasitet, og det tas forbehold om utsolgte avganger. Administrasjonstillegg p\xE5 kr 150,- per bestilling per telefon. V\xE5re reisebestemmelser er gjeldende.",
  "pl-PL": "Ceny uzale\u017Cnione  od dost\u0119pno\u015Bci. Op\u0142ata dodatkowa za rezerwacj\u0119 telefoniczn\u0105. Obowi\u0105zuje regulamin.",
  "pt-BR": "Pre\xE7os sujeitos a disponibilidade. Aplicam-se taxas de reserva por telefone. Aplicam-se termos e condi\xE7\xF5es.",
  "ro-RO": "Pre\u021Burile sunt \xEEn func\u021Bie de disponibilitate. Se aplic\u0103 taxele de rezervare telefonic\u0103. Termenii \u0219i condi\u021Biile se aplic\u0103.",
  "ru-RU": "\u0426\u0435\u043D\u044B \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u043D\u0430\u043B\u0438\u0447\u0438\u044F. \u0417\u0430 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u043F\u043B\u0430\u0442\u0430. \u041F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F.",
  "sk-SK": "Ceny z\xE1visia od dostupnosti. Platia telef\xF3nne poplatky. Plat\xED zmluvn\xE9 podmienky.",
  "sv-SE": "V\xE5ra priser \xE4r dynamiska och styrs av utbud och efterfr\xE5gan. Priset p\xE5 din resa kan d\xE4rf\xF6r variera och vi reserverar oss f\xF6r uts\xE5lda hytter och resedatum. Vid nya bokningar till\xE4ggs en bokningsavgift.\xA0 ",
  "tr-TR": "Fiyatlar, m\xFCsaitli\u011Fe g\xF6re de\u011Fi\u015Fir. Telefonla rezervasyon i\xE7in \xFCcret al\u0131n\u0131r. H\xFCk\xFCm ve ko\u015Fullar ge\xE7erlidir.",
  "zh-CN": "\u4EF7\u683C\u89C6\u4F9B\u5E94\u60C5\u51B5\u800C\u5B9A\u3002 \u7535\u8BDD\u9884\u8BA2\u8D39\u7528\u9002\u7528\u3002 \u6761\u6B3E\u548C\u6761\u4EF6\u9002\u7528\u3002",
  "en-GB": "Prices are subject to availability. Telephone booking fees apply. Terms and conditions apply."
};
var UNIFIED_WEB_PROMOTION_FROM = {
  "bg-BG": "\u043E\u0442",
  "cs-CZ": "Z",
  "da-DK": "Fra",
  "de-DE": "Ab",
  en: "From",
  "es-ES": "Desde",
  "et-EE": "Hind alates",
  "fi-FI": "Alkaen",
  "fr-FR": "D\xE8s",
  "fr-BE": "D\xE8s",
  "it-IT": "Da",
  "ja-JP": "\u304B\u3089",
  "ko-KR": "\uC5D0\uC11C",
  "lt-LT": "Nuo",
  "lv-LV": "No",
  "nl-NL": "Vanaf",
  "nl-BE": "Vanaf",
  "nb-NO": "Fra",
  "pl-PL": "Od",
  "pt-BR": "De",
  "ro-RO": "De la",
  "ru-RU": "\u043E\u0442",
  "sk-SK": "z",
  "sv-SE": "Fr\xE5n",
  "tr-TR": "\xC7\u0131k\u0131\u015F yeri",
  "zh-CN": "\u4ECE",
  "en-GB": "From"
};
var UNIFIED_WEB_FROM = {
  "bg-BG": "\u043E\u0442",
  "cs-CZ": "Z",
  "da-DK": "Fra",
  "de-DE": "Ab",
  en: "From",
  "es-ES": "Desde",
  "et-EE": "Hind alates",
  "fi-FI": "Alkaen",
  "fr-FR": "D\xE8s",
  "fr-BE": "D\xE8s",
  "it-IT": "Da",
  "ja-JP": "\u304B\u3089",
  "ko-KR": "\uC5D0\uC11C",
  "lt-LT": "Nuo",
  "lv-LV": "No",
  "nl-NL": "Vanaf",
  "nl-BE": "Vanaf",
  "nb-NO": "Fra",
  "pl-PL": "Od",
  "pt-BR": "De",
  "ro-RO": "De la",
  "ru-RU": "\u043E\u0442",
  "sk-SK": "z",
  "sv-SE": "Fr\xE5n",
  "tr-TR": "\xC7\u0131k\u0131\u015F yeri",
  "zh-CN": "\u4ECE",
  "en-GB": "From"
};
var UNIFIED_WEB_MINUTES = {
  "bg-BG": "\u043C\u0438\u043D\u0443\u0442\u0438",
  "cs-CZ": "minut",
  "da-DK": "minutter",
  "de-DE": "Minuten",
  en: "minutes",
  "es-ES": "minutos",
  "et-EE": "minutit",
  "fi-FI": "minuuttia",
  "fr-FR": "minutes",
  "fr-BE": "minutes",
  "it-IT": "minuti",
  "ja-JP": "\u5206",
  "ko-KR": "\uBD84",
  "lt-LT": "minut\u0117s",
  "lv-LV": "min\u016Btes",
  "nl-NL": "minuten",
  "nl-BE": "minuten",
  "nb-NO": "minutter",
  "pl-PL": "minut",
  "pt-BR": "minutos",
  "ro-RO": "minute",
  "ru-RU": "\u043C\u0438\u043D\u0443\u0442",
  "sk-SK": "min\xFAt",
  "sv-SE": "minuter",
  "tr-TR": "dakika",
  "zh-CN": "\u5206\u949F",
  "en-GB": "minutes",
  "fr-MA": "minutes"
};
var UNIFIED_WEB_AND = {
  "bg-BG": "\u0438",
  "cs-CZ": "a",
  "da-DK": "og",
  "de-DE": "und",
  en: "and",
  "es-ES": "y",
  "et-EE": "ja",
  "fi-FI": "ja",
  "fr-FR": "et",
  "fr-BE": "et",
  "it-IT": "e",
  "ja-JP": "\u3068",
  "ko-KR": "\uADF8\uB9AC\uACE0",
  "lt-LT": "ir",
  "lv-LV": "un",
  "nl-NL": "en",
  "nl-BE": "en",
  "nb-NO": "og",
  "pl-PL": "i",
  "pt-BR": "e",
  "ro-RO": "\u0219i",
  "ru-RU": "\u0438",
  "sk-SK": "a",
  "sv-SE": "och",
  "tr-TR": "ve",
  "zh-CN": "\u548C",
  "en-GB": "and",
  "fr-MA": "et"
};
var UNIFIED_WEB_ARTICLE_CATEGORY_BLOG_POSTS = {
  "da-DK": "Blogindl\xE6g",
  "de-DE": "Blog-Beitr\xE4ge",
  en: "Blog posts",
  "es-ES": "Entradas de blog",
  "et-EE": "Blogipostitused",
  "fi-FI": "Blogikirjoitukset",
  "fr-FR": "Billets de blog",
  "it-IT": "Post del blog",
  "lt-LT": "Tinklara\u0161tis",
  "lv-LV": "Emu\u0101ra ieraksti",
  "nl-NL": "Blogberichten",
  "nb-NO": "Blogginnlegg",
  "pl-PL": "Wpisy na blogu",
  "ro-RO": "Post\u0103ri blog",
  "ru-RU": "\u0411\u043B\u043E\u0433: \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438",
  "sv-SE": "Blogginl\xE4gg",
  "tr-TR": "Blog g\xF6nderileri"
};
var UNIFIED_WEB_ARTICLE_CATEGORY_ARTICLES = {
  "da-DK": "Artikler",
  "de-DE": "Artikel",
  en: "Articles",
  "es-ES": "Art\xEDculos",
  "et-EE": "Artiklid",
  "fi-FI": "Artikkelit",
  "fr-FR": "Articles",
  "it-IT": "Articoli",
  "lt-LT": "Straipsniai",
  "lv-LV": "Raksti",
  "nl-NL": "Artikels",
  "nb-NO": "Artikler",
  "pl-PL": "Artyku\u0142y",
  "ro-RO": "Articole",
  "ru-RU": "\u0421\u0442\u0430\u0442\u044C\u0438",
  "sv-SE": "Artiklar",
  "tr-TR": "Makaleler",
  "en-GB": "Articles"
};
var UNIFIED_WEB_ARTICLE_CATEGORY_NEWS = {
  "da-DK": "Nyheder",
  "de-DE": "Aktuelles",
  en: "News",
  "es-ES": "Noticias",
  "et-EE": "Uudised",
  "fi-FI": "Uutiset",
  "fr-FR": "Actualit\xE9",
  "it-IT": "Notizie",
  "lt-LT": "Naujienos",
  "lv-LV": "Zi\u0146as",
  "nl-NL": "Nieuws",
  "nb-NO": "Nyheter",
  "pl-PL": "Aktualno\u015Bci",
  "ro-RO": "\u0218tiri",
  "ru-RU": "\u041D\u043E\u0432\u043E\u0441\u0442\u0438",
  "sv-SE": "Nyheter",
  "tr-TR": "Haberler",
  "en-GB": "News"
};
var UNIFIED_WEB_ARTICLE_CATEGORY_CASE_STUDIES = {
  "da-DK": "Case-studier",
  "de-DE": "Fallstudien",
  en: "Case studies",
  "es-ES": "Casos pr\xE1cticos",
  "et-EE": "Juhtumianal\xFC\xFCsid",
  "fi-FI": "Tapaustutkimukset",
  "fr-FR": "\xC9tudes de cas",
  "it-IT": "Casi di studio",
  "lt-LT": "Atveju analiz\u0117s",
  "lv-LV": "Piem\u0113ra anal\u012Bze",
  "nl-NL": "Casestudies",
  "nb-NO": "Case-studier",
  "pl-PL": "Analizy przypadk\xF3w",
  "ro-RO": "Studii de caz",
  "ru-RU": "\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043A\u0435\u0439\u0441\u044B",
  "sv-SE": "Fallstudier",
  "tr-TR": "Vaka \xE7al\u0131\u015Fmalar\u0131",
  "en-GB": "Case studies"
};
var UNIFIED_WEB_ARTICLE_CATEGORY_WEBINARS = {
  "da-DK": "Webinarer",
  "de-DE": "Webinare",
  en: "Webinars",
  "es-ES": "Seminarios web",
  "et-EE": "Veebiseminarid",
  "fi-FI": "Webinaarit",
  "fr-FR": "Webinaires",
  "it-IT": "Webinar",
  "lt-LT": "Internetiniai seminarai",
  "lv-LV": "T\u012Bmek\u013Csemin\u0101ri",
  "nl-NL": "Webinars",
  "nb-NO": "Webinarer",
  "pl-PL": "Seminaria internetowe",
  "ro-RO": "Webinarii",
  "ru-RU": "\u0412\u0435\u0431\u0438\u043D\u0430\u0440\u044B",
  "sv-SE": "Webbseminarier",
  "tr-TR": "Web seminerleri",
  "en-GB": "Webinars"
};
var UNIFIED_WEB_ARTICLE_CATEGORY_UNDERSTANDING_DECARBONISATION = {
  en: "Understanding Decarbonisation"
};
var UNIFIED_WEB_ARTICLE_CATEGORY_EXPERT_OPINIONS = {
  "da-DK": "Ekspertudtalelser",
  "de-DE": "Expertenmeinungen",
  en: "Expert opinions",
  "es-ES": "Opiniones de expertos",
  "et-EE": "Ekspertarvamused",
  "fi-FI": "Asiantuntijalausunnot",
  "fr-FR": "Avis d'experts",
  "it-IT": "Opinioni degli esperti",
  "lt-LT": "Ekspert\u0173 nuomon\u0117s",
  "lv-LV": "Ekspertu viedok\u013Ci",
  "nl-NL": "Meningen van experts",
  "nb-NO": "Ekspertuttalelser",
  "pl-PL": "Opinie ekspert\xF3w",
  "ro-RO": "Opiniile exper\u021Bilor",
  "ru-RU": "\u041C\u043D\u0435\u043D\u0438\u044F \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u043E\u0432",
  "sv-SE": "Expertutl\xE5tanden",
  "tr-TR": "Uzman g\xF6r\xFC\u015Fleri",
  "en-GB": "Expert opinions"
};
var UNIFIED_WEB_ARTICLE_CATEGORY_EVENTS = {
  "da-DK": "Events",
  "de-DE": "Veranstaltungen",
  en: "Events",
  "es-ES": "Eventos",
  "et-EE": "S\xFCndmused",
  "fi-FI": "Tapahtumat",
  "fr-FR": "\xC9v\xE9nements",
  "it-IT": "Eventi",
  "lt-LT": "Renginiai",
  "lv-LV": "Pas\u0101kumi",
  "nl-NL": "Evenementen",
  "nb-NO": "Arrangementer",
  "pl-PL": "Wydarzenia",
  "ro-RO": "Evenimente",
  "ru-RU": "\u0421\u043E\u0431\u044B\u0442\u0438\u044F",
  "sv-SE": "Evenemang",
  "tr-TR": "Etkinlikler",
  "en-GB": "Events"
};
var UNIFIED_WEB_SOMETHING_WENT_WRONG_WITH_UNSUBSCRIBE = {
  "bg-BG": "\u0421\u044A\u0436\u0430\u043B\u044F\u0432\u0430\u043C\u0435, \u0432\u044A\u0437\u043D\u0438\u043A\u043D\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C. \u0410\u043A\u043E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044A\u0442 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438, \u043C\u043E\u043B\u044F, \u0441\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0441\u0435 \u0441 \u043D\u0430\u0441.",
  "cs-CZ": "Omlouv\xE1me se, n\u011Bco se pokazilo. Pokud probl\xE9m p\u0159etrv\xE1v\xE1, kontaktujte n\xE1s.",
  "da-DK": "Vi beklager, der opstod en fejl. Hvis problemet forts\xE6tter, bedes du kontakte os.",
  "de-DE": "Es tut uns leid, etwas ist schiefgelaufen. Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte.",
  en: "We're sorry, something went wrong. If the issue persists, please get in touch.",
  "es-ES": "Lo sentimos, algo sali\xF3 mal. Si el problema persiste, p\xF3ngase en contacto con nosotros.",
  "et-EE": "Vabandame, midagi l\xE4ks valesti. Kui probleem p\xFCsib, v\xF5tke meiega \xFChendust.",
  "fi-FI": "Pahoittelemme, jokin meni pieleen. Jos ongelma jatkuu, ota yhteytt\xE4.",
  "fr-FR": "Nous sommes d\xE9sol\xE9s, une erreur s'est produite. Si le probl\xE8me persiste, veuillez nous contacter.",
  "fr-BE": "Nous sommes d\xE9sol\xE9s, une erreur s'est produite. Si le probl\xE8me persiste, veuillez nous contacter.",
  "it-IT": "Ci dispiace, si \xE8 verificato un errore. Se il problema persiste, contattaci.",
  "ja-JP": "\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u304C\u3001\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
  "ko-KR": "\uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uBB38\uC81C\uAC00 \uC9C0\uC18D\uB418\uBA74 \uC800\uD76C\uC5D0\uAC8C \uC5F0\uB77D\uD574 \uC8FC\uC138\uC694.",
  "lt-LT": "Atsipra\u0161ome, \u012Fvyko klaida. Jei problema i\u0161lieka, susisiekite su mumis.",
  "lv-LV": "Atvainojiet, rad\u0101s probl\u0113ma. Ja probl\u0113ma saglab\u0101jas, l\u016Bdzu, sazinieties ar mums.",
  "nl-NL": "Onze excuses, er is iets misgegaan. Als het probleem aanhoudt, neem dan contact met ons op.",
  "nl-BE": "Onze excuses, er is iets misgegaan. Als het probleem aanhoudt, neem dan contact met ons op.",
  "nb-NO": "Beklager, noe gikk galt. Hvis problemet vedvarer, vennligst kontakt oss.",
  "pl-PL": "Przepraszamy, wyst\u0105pi\u0142 b\u0142\u0105d. Je\u015Bli problem b\u0119dzie si\u0119 powtarza\u0142, prosimy o kontakt.",
  "pt-BR": "Lamentamos, algo deu errado. Se o problema persistir, entre em contato conosco.",
  "ro-RO": "Ne pare r\u0103u, a ap\u0103rut o problem\u0103. Dac\u0103 problema persist\u0103, v\u0103 rug\u0103m s\u0103 ne contacta\u021Bi.",
  "ru-RU": "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u0415\u0441\u043B\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F, \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438.",
  "sk-SK": "Ospravedl\u0148ujeme sa, nie\u010Do sa pokazilo. Ak probl\xE9m pretrv\xE1va, kontaktujte n\xE1s.",
  "sv-SE": "Vi beklagar, n\xE5got gick fel. Om problemet kvarst\xE5r, v\xE4nligen kontakta oss.",
  "tr-TR": "\xDCzg\xFCn\xFCz, bir \u015Feyler ters gitti. Sorun devam ederse l\xFCtfen bizimle ileti\u015Fime ge\xE7in.",
  "zh-CN": "\u5F88\u62B1\u6B49\uFF0C\u51FA\u73B0\u4E86\u95EE\u9898\u3002\u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u6211\u4EEC\u3002",
  "en-GB": "We're sorry, something went wrong. If the issue persists, please get in touch.",
  "fr-MA": "Nous sommes d\xE9sol\xE9s, une erreur s'est produite. Si le probl\xE8me persiste, veuillez nous contacter."
};
var UNIFIED_WEB_HOURS = {
  "bg-BG": "\u0427\u0430\u0441\u0430",
  "cs-CZ": "Hodiny",
  "da-DK": "Timer",
  "de-DE": "Stunden",
  en: "hours",
  "es-ES": "Horas",
  "et-EE": "Tundi",
  "fi-FI": "Tuntia",
  "fr-FR": "Heures",
  "fr-BE": "Heures",
  "it-IT": "Ore",
  "ja-JP": "\u6642\u9593",
  "ko-KR": "\uC2DC\uAC04",
  "lt-LT": "Valandos",
  "lv-LV": "Stundas",
  "nl-NL": "Uren",
  "nl-BE": "Uren",
  "nb-NO": "Timer",
  "pl-PL": "Godziny",
  "pt-BR": "Horas",
  "ro-RO": "Ore",
  "ru-RU": "\u0427\u0430\u0441\u0430",
  "sk-SK": "Hodiny",
  "sv-SE": "Timmar",
  "tr-TR": "Saatler",
  "zh-CN": "\u5C0F\u65F6",
  "en-GB": "hour",
  "fr-MA": "Heures"
};
var UNIFIED_WEB_HOUR = {
  "bg-BG": "\u0427\u0430\u0441",
  "cs-CZ": "Hodina",
  "da-DK": "Time",
  "de-DE": "Stunde",
  en: "hour",
  "es-ES": "Hora",
  "et-EE": "Tund",
  "fi-FI": "Tunti",
  "fr-FR": "Heure",
  "fr-BE": "Heure",
  "it-IT": "Ora",
  "ja-JP": "\u6642\u9593",
  "ko-KR": "\uC2DC\uAC04",
  "lt-LT": "Valanda",
  "lv-LV": "Stunda",
  "nl-NL": "Uur",
  "nl-BE": "Uur",
  "nb-NO": "Time",
  "pl-PL": "Godzina",
  "pt-BR": "Hora",
  "ro-RO": "Or\u0103",
  "ru-RU": "\u0427\u0430\u0441",
  "sk-SK": "Hodina",
  "sv-SE": "Timme",
  "tr-TR": "Saat",
  "zh-CN": "\u5C0F\u65F6",
  "en-GB": "hour",
  "fr-MA": "Heure"
};
var UNIFIED_WEB_BLOG_SHARE = {
  "da-DK": "Del",
  "de-DE": "Teilen",
  en: "Share",
  "es-ES": "Compartir",
  "et-EE": "Jaga",
  "fr-FR": "Partager",
  "lt-LT": "Dalintis",
  "lv-LV": "Dal\u012Bties",
  "nl-NL": "Delen",
  "nb-NO": "Del",
  "pl-PL": "Udost\u0119pnij",
  "sv-SE": "Dela",
  "en-GB": "Share"
};
var UNIFIED_WEB_BLOG_PUBLISHED = {
  "da-DK": "Udgivet",
  "de-DE": "Ver\xF6ffentlicht",
  en: "Published",
  "es-ES": "Publicado",
  "et-EE": "Avaldatud",
  "fr-FR": "Publi\xE9",
  "lt-LT": "Paskelbta",
  "lv-LV": "Public\u0113ts",
  "nl-NL": "Gepubliceerd",
  "nb-NO": "Publisert",
  "pl-PL": "Opublikowano",
  "sv-SE": "Publicerad",
  "en-GB": "Published"
};
var UNIFIED_WEB_BLOG_MIN_READ = {
  "da-DK": "min l\xE6sning",
  "de-DE": "Min. Lesezeit",
  en: "min read",
  "es-ES": "min de lectura",
  "et-EE": "min lugemist",
  "fr-FR": "min de lecture",
  "lt-LT": "min skaitymo",
  "lv-LV": "min las\u012B\u0161anas",
  "nl-NL": "min lezen",
  "nb-NO": "min lesing",
  "pl-PL": "min czytania",
  "sv-SE": "min l\xE4sning",
  "en-GB": "min read"
};
var UNIFIED_WEB_LANGUAGE_SELECTOR_HEADER = {
  "bg-BG": "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0435\u0437\u0438\u043A",
  "cs-CZ": "Vyberte jazyk",
  "da-DK": "V\xE6lg sprog",
  "de-DE": "Sprache ausw\xE4hlen",
  en: "Select Language",
  "es-ES": "Seleccionar idioma",
  "et-EE": "Vali keel",
  "fi-FI": "Valitse kieli",
  "fr-FR": "S\xE9lectionner la langue",
  "fr-BE": "S\xE9lectionner la langue",
  "it-IT": "Seleziona lingua",
  "ja-JP": "\u8A00\u8A9E\u3092\u9078\u629E",
  "ko-KR": "\uC5B8\uC5B4 \uC120\uD0DD",
  "lt-LT": "Pasirinkite kalb\u0105",
  "lv-LV": "Izv\u0113lieties valodu",
  "nl-NL": "Selecteer taal",
  "nl-BE": "Selecteer taal",
  "nb-NO": "Velg spr\xE5k",
  "pl-PL": "Wybierz j\u0119zyk",
  "pt-BR": "Selecionar idioma",
  "ro-RO": "Selecta\u021Bi limba",
  "ru-RU": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044F\u0437\u044B\u043A",
  "sk-SK": "Vyberte jazyk",
  "sv-SE": "V\xE4lj spr\xE5k",
  "tr-TR": "Dil Se\xE7in",
  "zh-CN": "\u9009\u62E9\u8BED\u8A00",
  "en-GB": "Select Language",
  "fr-MA": "S\xE9lectionner la langue"
};
var UNIFIED_WEB_EMAIL_IS_MISSING_FOR_UNSUBSCRIBE = {
  "da-DK": "E-mail mangler. Hvis du har brug for hj\xE6lp til at afmelde, kan du kontakte os p\xE5 privacy@dfds.com.",
  "de-DE": "E-Mail-Adresse fehlt. Wenn Sie Hilfe beim Abmelden ben\xF6tigen, k\xF6nnen Sie uns unter privacy@dfds.com kontaktieren.",
  en: "Email is missing. If you need help unsubscribing you can contact us at privacy@dfds.com.",
  "es-ES": "Falta el correo electr\xF3nico. Si necesitas ayuda para darte de baja, puedes contactarnos en privacy@dfds.com.",
  "et-EE": "E-posti aadress puudub. Kui vajate abi tellimuse t\xFChistamisel, v\xF5tke meiega \xFChendust aadressil privacy@dfds.com.",
  "fi-FI": "S\xE4hk\xF6postiosoite puuttuu. Jos tarvitset apua tilauksen perumisessa, voit ottaa meihin yhteytt\xE4 osoitteessa privacy@dfds.com.",
  "fr-FR": "L'adresse e-mail est manquante. Si vous avez besoin d'aide pour vous d\xE9sabonner, vous pouvez nous contacter \xE0 privacy@dfds.com.",
  "lt-LT": "Tr\u016Bksta el. pa\u0161to adreso. Jei jums reikia pagalbos atsisakant prenumeratos, galite susisiekti su mumis adresu privacy@dfds.com.",
  "lv-LV": "E-pasta adrese nav nor\u0101d\u012Bta. Ja jums nepiecie\u0161ama pal\u012Bdz\u012Bba atteik\u0161an\u0101s proces\u0101, varat sazin\u0101ties ar mums pa e-pastu privacy@dfds.com.",
  "nl-NL": "E-mailadres ontbreekt. Als u hulp nodig heeft bij het uitschrijven, kunt u contact met ons opnemen via privacy@dfds.com.",
  "nb-NO": "E-post mangler. Hvis du trenger hjelp med \xE5 avslutte abonnementet, kan du kontakte oss p\xE5 privacy@dfds.com.",
  "pl-PL": "Brakuje adresu e-mail. Je\u015Bli potrzebujesz pomocy przy wypisaniu si\u0119, mo\u017Cesz skontaktowa\u0107 si\u0119 z nami pod adresem privacy@dfds.com.",
  "ru-RU": "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442. \u0415\u0441\u043B\u0438 \u0432\u0430\u043C \u043D\u0443\u0436\u043D\u0430 \u043F\u043E\u043C\u043E\u0449\u044C \u0441 \u043E\u0442\u043F\u0438\u0441\u043A\u043E\u0439, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F \u0441 \u043D\u0430\u043C\u0438 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 privacy@dfds.com.",
  "sv-SE": "E-postadress saknas. Om du beh\xF6ver hj\xE4lp med att avsluta prenumerationen kan du kontakta oss p\xE5 privacy@dfds.com.",
  "en-GB": "Email is missing. If you need help unsubscribing you can contact us at privacy@dfds.com."
};
var UNIFIED_WEB_UNSUBSCRIBE_FROM_THE_NEWSLETTER_AT = {
  "da-DK": "Afmeld for at stoppe nyhedsbreve p\xE5",
  "de-DE": "Abmelden, um keine Newsletter mehr zu erhalten unter",
  en: "Unsubscribe to stop receiving newsletters at",
  "es-ES": "Darse de baja para dejar de recibir boletines en",
  "et-EE": "Loobu uudiskirjadest, et l\xF5petada nende saamine aadressil",
  "fi-FI": "Peruuta tilaus lopettaaksesi uutiskirjeiden vastaanottamisen osoitteessa",
  "fr-FR": "D\xE9sabonnez-vous pour ne plus recevoir de newsletters \xE0",
  "lt-LT": "Atsisakykite, kad nebegautum\u0117te naujienlai\u0161ki\u0173 adresu",
  "lv-LV": "Atteikties, lai p\u0101rtrauktu sa\u0146emt jaunumus uz",
  "nl-NL": "Uitschrijven om geen nieuwsbrieven meer te ontvangen op",
  "nb-NO": "Avslutt abonnementet for \xE5 slutte \xE5 motta nyhetsbrev p\xE5",
  "pl-PL": "Wypisz si\u0119, aby przesta\u0107 otrzymywa\u0107 newslettery na",
  "ru-RU": "\u041E\u0442\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0441\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430",
  "sv-SE": "Avsluta prenumerationen f\xF6r att sluta f\xE5 nyhetsbrev p\xE5",
  "en-GB": "Unsubscribe to stop receiving newsletters at"
};
var UNIFIED_WEB_JUST_ONE_MORE_CLICK = {
  "da-DK": "Kun \xE9t klik mere...",
  "de-DE": "Nur noch ein Klick...",
  en: "Just one more click...",
  "es-ES": "Solo un clic m\xE1s...",
  "et-EE": "Ainult \xFCks kl\xF5ps veel...",
  "fi-FI": "Vain yksi klikkaus j\xE4ljell\xE4...",
  "fr-FR": "Plus qu'un clic...",
  "lt-LT": "Dar tik vienas paspaudimas...",
  "lv-LV": "Tikai v\u0113l viens klik\u0161\u0137is...",
  "nl-NL": "Nog maar \xE9\xE9n klik...",
  "nb-NO": "Bare ett klikk til...",
  "pl-PL": "Jeszcze tylko jedno klikni\u0119cie...",
  "ru-RU": "\u041E\u0441\u0442\u0430\u043B\u0441\u044F \u0432\u0441\u0435\u0433\u043E \u043E\u0434\u0438\u043D \u043A\u043B\u0438\u043A...",
  "sv-SE": "Bara ett klick till...",
  "en-GB": "Just one more click..."
};
var UNIFIED_WEB_FIELD_INVALID_EMAIL = {
  "da-DK": "E-mailen er ugyldig",
  "de-DE": "E-Mail ist ung\xFCltig",
  en: "Email is invalid",
  "es-ES": "El correo electr\xF3nico no es v\xE1lido",
  "et-EE": "E-post on vigane",
  "fi-FI": "S\xE4hk\xF6posti on virheellinen",
  "fr-FR": "L'adresse e-mail est invalide",
  "lt-LT": "El. pa\u0161tas yra neteisingas",
  "lv-LV": "E-pasts ir neder\u012Bgs",
  "nl-NL": "E-mailadres is ongeldig",
  "nb-NO": "E-posten er ugyldig",
  "pl-PL": "E-mail jest nieprawid\u0142owy",
  "ru-RU": "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430",
  "sv-SE": "E-postadressen \xE4r ogiltig",
  "en-GB": "Email is invalid"
};
var UNIFIED_WEB_PLEASE_TRY_DIFFERENT_DATE = {
  "da-DK": "Pr\xF8v venligst en anden dato",
  "de-DE": "Bitte versuchen Sie ein anderes Datum",
  en: "Please try a different date",
  "es-ES": "Por favor, intente con otra fecha",
  "et-EE": "Palun proovige teist kuup\xE4eva",
  "fi-FI": "Yrit\xE4th\xE4n toista p\xE4iv\xE4m\xE4\xE4r\xE4\xE4",
  "fr-FR": "Veuillez essayer une autre date",
  "lt-LT": "Pra\u0161ome pabandyti kit\u0105 dat\u0105",
  "lv-LV": "L\u016Bdzu, m\u0113\u0123iniet citu datumu",
  "nl-NL": "Probeer een andere datum",
  "nb-NO": "Vennligst pr\xF8v en annen dato.",
  "pl-PL": "Prosz\u0119 spr\xF3bowa\u0107 innej daty",
  "ru-RU": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u0443\u044E \u0434\u0430\u0442\u0443",
  "sv-SE": "V\xE4nligen f\xF6rs\xF6k med ett annat datum",
  "en-GB": "Please try a different date"
};
var UNIFIED_WEB_DEPARTURE_DATE = {
  "da-DK": "Afgangsdato",
  "de-DE": "Abfahrtsdatum",
  en: "Departure date",
  "es-ES": "Fecha de salida",
  "et-EE": "V\xE4ljumiskuup\xE4ev",
  "fi-FI": "L\xE4ht\xF6p\xE4iv\xE4",
  "fr-FR": "Date de d\xE9part",
  "lt-LT": "I\u0161vykimo data",
  "lv-LV": "Izbrauk\u0161anas datums",
  "nl-NL": "Vertrekdatum",
  "nb-NO": "Avreisedato",
  "pl-PL": "Data wyjazdu",
  "ru-RU": "\u0414\u0430\u0442\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
  "sv-SE": "Avresedatum",
  "en-GB": "Departure date"
};
var UNIFIED_WEB_TO = {
  "da-DK": "Til",
  "de-DE": "Nach",
  en: "To",
  "es-ES": "A",
  "et-EE": "Suunas",
  "fi-FI": "Kohti",
  "fr-FR": "Vers",
  "lt-LT": "\u012E",
  "lv-LV": "Uz",
  "nl-NL": "Naar",
  "nb-NO": "Til",
  "pl-PL": "Do",
  "ru-RU": "\u0412 (V)",
  "sv-SE": "Till",
  "en-GB": "To"
};
var UNIFIED_WEB_DURATION = {
  "da-DK": "Varighed",
  "de-DE": "Dauer",
  en: "Duration",
  "es-ES": "Duraci\xF3n",
  "et-EE": "Kestus",
  "fi-FI": "Kesto",
  "fr-FR": "Dur\xE9e",
  "lt-LT": "Trukm\u0117",
  "lv-LV": "Ilgums",
  "nl-NL": "Duur",
  "nb-NO": "Varighet",
  "pl-PL": "Czas trwania",
  "ru-RU": "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
  "sv-SE": "Varaktighet",
  "en-GB": "Duration"
};
var UNIFIED_WEB_NEXT_AVAILABLE_DATE = {
  "da-DK": "Se den n\xE6ste planlagte tur",
  "de-DE": "Siehe n\xE4chste geplante Fahrt.",
  en: "See next scheduled sailing",
  "et-EE": "J\xE4rgmine graafikuj\xE4rgne laevareis",
  "fr-FR": "Consultez le prochain d\xE9part pr\xE9vu.",
  "lt-LT": "Kitas planuojamas i\u0161vykimas.",
  "lv-LV": "Skat. n\u0101kamo pl\u0101noto atie\u0161anu",
  "nl-NL": "Zie volgende geplande afvaart",
  "nb-NO": "Se neste planlagte seiling.",
  "pl-PL": "Zobacz nast\u0119pny zaplanowany rejs",
  "ru-RU": "\u0421\u043C. \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
  "sv-SE": "Se n\xE4sta planerade tur"
};
var UNIFIED_WEB_NO_SAILINGS = {
  "da-DK": "Der findes ingen afgange p\xE5 den dato, du har valgt.",
  "de-DE": "Am von Ihnen gew\xE4hlten Datum gibt es keine Abfahrten.",
  en: "There are no sailings on your chosen date.",
  "et-EE": "Valitud kuup\xE4eval v\xE4ljumised puuduvad.",
  "fr-FR": "Il n'y a aucun voyage \xE0 la date que vous avez choisie.",
  "lt-LT": "J\u016Bs\u0173 pasirinktu metu i\u0161vykim\u0173 n\u0117ra.",
  "lv-LV": "J\u016Bsu izv\u0113l\u0113taj\u0101 datum\u0101 neviens pr\u0101mis nekurs\u0113.",
  "nl-NL": "Er zijn geen afvaarten op de door jouw gekozen datum.",
  "nb-NO": "Det er ingen seilinger p\xE5 din valgte dato.",
  "pl-PL": "Nie ma rejs\xF3w w wybranym terminie.",
  "ru-RU": "\u041D\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u0443\u044E \u0432\u0430\u043C\u0438 \u0434\u0430\u0442\u0443 \u043D\u0435\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0439.",
  "sv-SE": "Det finns inga turer f\xF6r det datum du valt.",
  "tr-TR": "Bu g\xFCnde sefer yok",
  "en-GB": "No sailings this day"
};
var UNIFIED_WEB_SAILINGS_IN_LOCAL_TIME = {
  "bg-BG": "\u0420\u0435\u0434\u043E\u0432\u043D\u0438\u0442\u0435 \u043F\u043B\u0430\u0432\u0430\u043D\u0438\u044F \u0437\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u0442\u0430 \u0441\u0435\u0434\u043C\u0438\u0446\u0430 \u0441\u0430 \u043F\u043E\u0441\u043E\u0447\u0435\u043D\u0438 \u0432 \u043C\u0435\u0441\u0442\u043D\u043E \u0432\u0440\u0435\u043C\u0435",
  "cs-CZ": "Pravideln\xE9 cesty pro aktu\xE1ln\xED t\xFDden uveden\xE9 v m\xEDstn\xEDm \u010Dase",
  "da-DK": "Alle viste tider er lokal tid.",
  "de-DE": "Alle angegebenen Zeiten sind in Ortszeit",
  en: "All times shown are in local time.",
  "es-ES": "Salidas regulares para la semana actual enumeradas en hora local ",
  "et-EE": "K\xF5ik v\xE4ljumised on kohaliku aja j\xE4rgi.",
  "fi-FI": "Paikallinen aika koskee t\xE4m\xE4n viikon s\xE4\xE4nn\xF6llist\xE4 l\xE4ht\xF6\xE4",
  "fr-FR": " Les horaires sont donn\xE9s en heure locale",
  "fr-BE": "L'heure locale s'applique aux d\xE9parts r\xE9guliers pour cette semaine",
  "it-IT": "Traversate regolari per la settimana corrente elencate in ora locale ",
  "ja-JP": "\u73FE\u5730\u6642\u9593\u306F\u3001\u4ECA\u9031\u306E\u5B9A\u671F\u51FA\u767A\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002",
  "ko-KR": "\uC774\uBC88 \uC8FC\uC5D0\uB294 \uC815\uADDC \uCD9C\uBC1C \uC2DC\uAC04\uC5D0 \uD604\uC9C0 \uC2DC\uAC04\uC774 \uC801\uC6A9\uB429\uB2C8\uB2E4.",
  "lt-LT": "Tvarkara\u0161tyje laikas rodomas vietiniu laiku.",
  "lv-LV": "Visi laiki ir nor\u0101d\u012Bti p\u0113c viet\u0113j\u0101 laika.",
  "nl-NL": "Alle getoonde tijden zijn in lokale tijd.",
  "nl-BE": "Voor de reguliere afvaarten voor deze week geldt de lokale tijd",
  "nb-NO": "Alle klokkeslett er vist i lokal tid.",
  "pl-PL": "Wszystkie podane godziny s\u0105 w czasie lokalnym.",
  "pt-BR": "Viagens regulares para a semana atual listadas na hora local",
  "ro-RO": "Curse regulate pentru aceasta s\u0103pt\u0103m\xE2n\u0103 sunt afi\u0219ate \xEEn ora local\u0103 ",
  "ru-RU": "\u0412\u0441\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u043E \u043F\u043E \u043C\u0435\u0441\u0442\u043D\u043E\u043C\u0443 \u0432\u0440\u0435\u043C\u0435\u043D\u0438.",
  "sk-SK": "Pravideln\xE9 odchody pre aktu\xE1lny t\xFD\u017Ede\u0148 uveden\xE9 v miestnom \u010Dase",
  "sv-SE": "Alla tider som visas \xE4r i lokal tid.",
  "tr-TR": "Mevcut hafta i\xE7in d\xFCzenli seferler, yerel saate g\xF6re listelenir",
  "zh-CN": "\u5F53\u5730\u65F6\u95F4\u9002\u7528\u4E8E\u672C\u5468\u7684\u5E38\u89C4\u73ED\u6B21",
  "en-GB": "Regular sailings for the current week listed in local time"
};
var UNIFIED_WEB_ARRIVAL = {
  "bg-BG": "\u041F\u0440\u0438\u0441\u0442\u0438\u043D\u0430\u0433\u0435",
  "da-DK": "Ankomst",
  "de-DE": "Ankunft ",
  en: "Arrival",
  "es-ES": "llegada ",
  "et-EE": "Saabumine",
  "fi-FI": "Saapuminen",
  "fr-FR": "Arriv\xE9e",
  "it-IT": "Arrivo",
  "lt-LT": "Atvykimas",
  "lv-LV": "Atgrie\u0161an\u0101s",
  "nl-NL": "Aankomst",
  "nb-NO": "Ankomst",
  "pl-PL": "Przypyni\u0119cie",
  "ru-RU": "\u043F\u0440\u0438\u0431\u044B\u0442\u0438\u0435",
  "sv-SE": "Ankomst",
  "tr-TR": "Var\u0131\u015F",
  "en-GB": "Arrival"
};
var UNIFIED_WEB_DEPARTURE = {
  "bg-BG": "\u0422\u0440\u044A\u0433\u0432\u0430\u043D\u0435",
  "da-DK": "Afrejse",
  "de-DE": "Abfahrt ",
  en: "Departure",
  "es-ES": "Salida ",
  "et-EE": "V\xE4ljumine",
  "fi-FI": "L\xE4ht\xF6",
  "fr-FR": "D\xE9part",
  "fr-BE": "D\xE9part",
  "it-IT": "Partenza",
  "lt-LT": "I\u0161vykimas",
  "lv-LV": "Izbrauk\u0161ana",
  "nl-NL": "Vertrek",
  "nb-NO": "Avreise",
  "pl-PL": "Wyp\u0142yni\u0119cie",
  "ru-RU": "\u0414\u0430\u0442\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
  "sv-SE": "Avresa",
  "tr-TR": "Kalk\u0131\u015F",
  "en-GB": "Departure"
};
var UNIFIED_WEB_CHECK_IN_CLOSES = {
  "bg-BG": "\u0427\u0435\u043A\u0438\u0440\u0430\u043D\u0435\u0442\u043E \u0437\u0430\u0442\u0432\u0430\u0440\u044F",
  "da-DK": "Check-in lukker",
  "de-DE": "Check-In schlie\xDFt",
  en: "Check-in closes",
  "es-ES": "Cierra el check-in ",
  "et-EE": "Check-in suletakse",
  "fi-FI": "Sulkeutuu",
  "fr-FR": "Fin de l'enregistrement",
  "it-IT": "Chiude il check-in ",
  "lt-LT": "Registracija baigiasi",
  "lv-LV": "Re\u0123istr\u0101cija beidzas",
  "nl-NL": "Check in sluit",
  "nb-NO": "Innsjekk stenger",
  "pl-PL": "Koniec odprawy",
  "ru-RU": "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0435\u0442\u0441\u044F",
  "sv-SE": "Check-in st\xE4nger",
  "tr-TR": "Giri\u015F i\xE7in kapan\u0131\u015F saati",
  "en-GB": "Check-in closes"
};
var UNIFIED_WEB_UNSUBSCRIBE = {
  "da-DK": "Afmeld",
  "de-DE": "Abmelden",
  en: "Unsubscribe",
  "es-ES": "Cancelar suscripci\xF3n",
  "et-EE": "Uudiskirjast loobumine",
  "fi-FI": "Uutiskirjeen peruutus",
  "fr-FR": "Se d\xE9sabonner",
  "fr-BE": "Se d\xE9sabonner",
  "it-IT": "Annulla iscrizione ",
  "lt-LT": "Atsisakyti",
  "lv-LV": "Atcelt abonementu",
  "nl-NL": "Uitschrijven",
  "nb-NO": "Avmeld",
  "pl-PL": "Wypisz si\u0119",
  "ru-RU": "\u041E\u0442\u043A\u0430\u0437 \u043E\u0442 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438",
  "sv-SE": "\u200BAvsluta prenumeration",
  "tr-TR": "Abonelikten \xE7\u0131k",
  "en-GB": "Unsubscribe"
};
var UNIFIED_WEB_TO_ACTIVATE_YOUR_SUBSCRIPTION = {
  "bg-BG": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "cs-CZ": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "da-DK": "For at aktivere din tilmelding skal du blot klikke p\xE5 linket i den e-mail, som vi har sendt til dig. Hold \xF8je med en e-mail fra email@dfds.info.",
  "de-DE": "Um Ihre Anmeldung vollst\xE4ndig\xA0abzuschlie\xDFen, klicken Sie bitte auf den Link in der E-Mail, die wir an Ihr Postfach gesendet haben. Schauen Sie nach einer E-Mail von email@dfds.info. ",
  en: "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "es-ES": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "et-EE": "Tellimuse aktiveerimiseks kliki palun oma e-posti aadressile saadetud lingil. Leia postkastist e-kiri saatjalt email@dfds.info.",
  "fi-FI": "Aktivoi tilauksesi napsauttamalla linkki\xE4 s\xE4hk\xF6postista, jonka olemme l\xE4hett\xE4neet sinulle. Tarkkaile s\xE4hk\xF6postia osoitteesta email@dfds.info.\xA0",
  "fr-FR": "Afin de confirmer votre abonnement, veuillez cliquer sur le lien se trouvant dans le mail que nous venons de vous envoyer depuis cette adresse :  email@dfds.info. ",
  "fr-BE": "Afin de confirmer votre abonnement, veuillez cliquer sur le lien se trouvant dans le mail que nous venons de vous envoyer depuis cette adresse :  email@dfds.info. ",
  "it-IT": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "ja-JP": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "ko-KR": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "lt-LT": "\u012E j\u016Bs\u0173 el. pa\u0161to d\u0117\u017Eut\u0119 i\u0161siunt\u0117me nuorod\u0105\xA0(siunt\u0117jas\xA0email@dfds.info),\xA0paspauskite j\u0105, kad\xA0patvirtintum\u0117te\xA0prenumerat\u0105.",
  "lv-LV": "Lai aktiviz\u0113tu savu re\u0123istr\u0101ciju, l\u016Bdzu, noklik\u0161\u0137iniet uz m\u016Bsu e-pasta zi\u0146ojum\u0101 iek\u013Caut\u0101s saites. Mekl\u0113jiet e-pasta zi\u0146ojumu no email@dfds.info.",
  "nl-NL": "Om je inschrijving te activeren! Klik op de link die je in je inbox hebt ontvangen. Kijk uit naar een e-mail van email@dfds.info",
  "nl-BE": "Wat leuk dat je je hebt aangemeld voor onze nieuwsbrief! Nog \xE9\xE9n stap en dan is je aanmelding voltooid: Klik op de button in de bevestigingsmail die je nu van ons ontvangt.",
  "nb-NO": "For \xE5 aktivere din p\xE5melding m\xE5 du klikke p\xE5 linken vi har sendt til din e-postadresse. Se etter e-posten fra email@dfds.info. \u200B",
  "pl-PL": "Aby aktywowa\u0107 swoj\u0105 subskrypcj\u0119 kliknij w link, kt\xF3ry wys\u0142ali\u015Bmy Ci w wiadomo\u015Bci na Twoj\u0105 skrzynk\u0119 pocztow\u0105. Wypatruj maila od email@dfds.info.\xA0",
  "pt-BR": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "ro-RO": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "ru-RU": "\u0427\u0442\u043E\u0431\u044B \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0443, \u043F\u0440\u043E\u0439\u0434\u0438\u0442\u0435 \u043F\u043E \u0441\u0441\u044B\u043B\u043A\u0435, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0439 \u0432\xA0\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u043C \u043F\u0438\u0441\u044C\u043C\u0435, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043D\u0430 \u0432\u0430\u0448 \u0430\u0434\u0440\u0435\u0441. \u0418\u0449\u0438\u0442\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u043E\u0442 email@dfds.info.",
  "sk-SK": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "sv-SE": "F\xF6r att aktivera din prenumeration ska du bara klicka p\xE5 l\xE4nken som vi har skickat till din inkorg. H\xE5ll ett \xF6ga efter en mail fr\xE5n\xA0email@dfds.info.\xA0",
  "tr-TR": "Abone oldu\u011Funuz i\xE7in te\u015Fekk\xFCr ederiz! K\u0131sa s\xFCre i\xE7inde aboneli\u011Finizi onaylayabilece\u011Finiz bir e-posta alacaks\u0131n\u0131z.",
  "zh-CN": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0",
  "en-GB": "To activate your subscription, please click on the link in the email that we have sent to your inbox. Look out for an email from email@dfds.info.\xA0"
};
var UNIFIED_WEB_FIELD_REQUIRED = {
  "da-DK": "Feltet er obligatorisk",
  "de-DE": "Pflichtfeld",
  en: "The field is required",
  "es-ES": "Este campo es obligatorio",
  "et-EE": "See v\xE4li on kohustuslik",
  "fi-FI": "T\xE4m\xE4 kentt\xE4 on pakollinen",
  "fr-FR": "Ce champ est obligatoire",
  "fr-BE": "Ce champ est obligatoire",
  "it-IT": "Campo obbligatorio",
  "lt-LT": "\u0160is laukas b\u016Btinas",
  "lv-LV": "\u0160is lauks j\u0101aizpilda oblig\u0101ti",
  "nl-NL": "Het veld is verplicht",
  "nl-BE": "Het veld is verplicht",
  "nb-NO": "Feltet er p\xE5krevet",
  "pl-PL": "Pole wymagane",
  "ru-RU": "\u042D\u0442\u043E \u043F\u043E\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F",
  "sv-SE": "Det h\xE4r f\xE4ltet kr\xE4vs",
  "tr-TR": "Bu alan\u0131n doldurulmas\u0131 zorunludur",
  "en-GB": "The field is required"
};
var UNIFIED_WEB_EMAIL_ADDRESS = {
  "da-DK": "E-mail",
  "de-DE": "E-Mail-Adresse",
  en: "Email address",
  "es-ES": "Su correo electr\xF3nico",
  "et-EE": "Sinu e-posti aadress",
  "fi-FI": "s\xE4hk\xF6postiosoite",
  "fr-FR": "adresse \xE9lectronique",
  "fr-BE": "adresse \xE9lectronique",
  "it-IT": "La tua email ",
  "lt-LT": "J\u016Bs\u0173 elektronino pa\u0161to adresas",
  "lv-LV": "epasta adrese",
  "nl-NL": "E-mail adres",
  "nb-NO": "E-postadresse",
  "ru-RU": "\u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B",
  "sv-SE": "E-postadress",
  "tr-TR": "E-posta adresi",
  "en-GB": "Email address"
};
var UNIFIED_WEB_SIGN_ME_UP = {
  "da-DK": "Tilmeld mig!\u200B",
  "de-DE": "Jetzt anmelden!\xA0",
  en: "Sign me up!",
  "es-ES": "Reg\xEDstrese",
  "et-EE": "Tellin!",
  "fi-FI": "Tilaa!",
  "fr-FR": "Je souhaite m'abonner !",
  "fr-BE": "Je souhaite m'abonner !",
  "it-IT": "Iscriviti ",
  "lt-LT": "U\u017Esiregistruoti!",
  "lv-LV": "Re\u0123istr\u0113jiet mani!",
  "nl-NL": "AANMELDEN!",
  "nl-BE": "AANMELDEN!",
  "nb-NO": "Meld meg p\xE5! \u200B",
  "pl-PL": "Zapisz mnie!",
  "ru-RU": "\u041F\u043E\u0434\u043F\u0438\u0448\u0438\u0442\u0435 \u043C\u0435\u043D\u044F!",
  "sv-SE": "Prenumerera",
  "tr-TR": "Beni kaydet!",
  "en-GB": "Sign me up!"
};
var UNIFIED_WEB_CLOSE = {
  "da-DK": "Luk",
  "de-DE": "Schlie\xDFen",
  en: "Close",
  "et-EE": "Sulge",
  "lt-LT": "U\u017Edaryti",
  "lv-LV": "Aizv\u0113rt",
  "nl-NL": "Sluiten",
  "nb-NO": "Steng",
  "ru-RU": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
  "sv-SE": "St\xE4ng",
  "tr-TR": "Kapat",
  "en-GB": "Close"
};
var UNIFIED_WEB_PLEASE_WAIT = {
  en: "Please wait",
  "en-GB": "Please wait"
};
var UNIFIED_WEB_SELECT_A_DATE = {
  en: "Select a date",
  "en-GB": "Select a date"
};
var strings_default = {
  "UNIFIED-WEB-SCHEDULE-SUBJECT-TO-WEATHER-CONDITIONS": UNIFIED_WEB_SCHEDULE_SUBJECT_TO_WEATHER_CONDITIONS,
  B2B_TIMETABLE_ARRIVAL_DATE,
  B2B_TIMETABLE_VESSEL,
  B2B_TIMETABLE_RELOAD_PAGE,
  B2B_TIMETABLE_SAILING_TIME,
  B2B_TIMETABLE_NEXT_DAY_ARRIVAL,
  B2B_TIMETABLE_DEPARTURE_TIME,
  B2B_TIMETABLE_ARRIVAL_TIME,
  B2B_TIMETABLE_SWITCH_DIRECTION,
  B2B_TIMETABLE_WEEK_PICKER_LABEL,
  B2B_TIMETABLE_ERROR_BODY,
  B2B_TIMETABLE_NO_SAILINGS_HEADING,
  B2B_TIMETABLE_ERROR_HEADING,
  B2B_TIMETABLE_DEPARTURE_DATE,
  B2B_TIMETABLE_NO_SAILINGS_BODY,
  B2B_TIMETABLE_UNKNOWN_VESSEL,
  "UNIFIED-WEB-FERRY-CROSSING-PRICE-DISCLAIMER": UNIFIED_WEB_FERRY_CROSSING_PRICE_DISCLAIMER,
  "UNIFIED-WEB-PROMOTION-FROM": UNIFIED_WEB_PROMOTION_FROM,
  "UNIFIED-WEB-FROM": UNIFIED_WEB_FROM,
  "UNIFIED-WEB-MINUTES": UNIFIED_WEB_MINUTES,
  "UNIFIED-WEB-AND": UNIFIED_WEB_AND,
  "UNIFIED-WEB-ARTICLE-CATEGORY-BLOG-POSTS": UNIFIED_WEB_ARTICLE_CATEGORY_BLOG_POSTS,
  "UNIFIED-WEB-ARTICLE-CATEGORY-ARTICLES": UNIFIED_WEB_ARTICLE_CATEGORY_ARTICLES,
  "UNIFIED-WEB-ARTICLE-CATEGORY-NEWS": UNIFIED_WEB_ARTICLE_CATEGORY_NEWS,
  "UNIFIED-WEB-ARTICLE-CATEGORY-CASE-STUDIES": UNIFIED_WEB_ARTICLE_CATEGORY_CASE_STUDIES,
  "UNIFIED-WEB-ARTICLE-CATEGORY-WEBINARS": UNIFIED_WEB_ARTICLE_CATEGORY_WEBINARS,
  "UNIFIED-WEB-ARTICLE-CATEGORY-UNDERSTANDING-DECARBONISATION": UNIFIED_WEB_ARTICLE_CATEGORY_UNDERSTANDING_DECARBONISATION,
  "UNIFIED-WEB-ARTICLE-CATEGORY-EXPERT-OPINIONS": UNIFIED_WEB_ARTICLE_CATEGORY_EXPERT_OPINIONS,
  "UNIFIED-WEB-ARTICLE-CATEGORY-EVENTS": UNIFIED_WEB_ARTICLE_CATEGORY_EVENTS,
  "UNIFIED-WEB-SOMETHING-WENT-WRONG-WITH-UNSUBSCRIBE": UNIFIED_WEB_SOMETHING_WENT_WRONG_WITH_UNSUBSCRIBE,
  "UNIFIED-WEB-HOURS": UNIFIED_WEB_HOURS,
  "UNIFIED-WEB-HOUR": UNIFIED_WEB_HOUR,
  "UNIFIED-WEB-BLOG-SHARE": UNIFIED_WEB_BLOG_SHARE,
  "UNIFIED-WEB-BLOG-PUBLISHED": UNIFIED_WEB_BLOG_PUBLISHED,
  "UNIFIED-WEB-BLOG-MIN-READ": UNIFIED_WEB_BLOG_MIN_READ,
  "UNIFIED-WEB-LANGUAGE-SELECTOR-HEADER": UNIFIED_WEB_LANGUAGE_SELECTOR_HEADER,
  "UNIFIED-WEB-EMAIL-IS-MISSING-FOR-UNSUBSCRIBE": UNIFIED_WEB_EMAIL_IS_MISSING_FOR_UNSUBSCRIBE,
  "UNIFIED-WEB-UNSUBSCRIBE-FROM-THE-NEWSLETTER-AT": UNIFIED_WEB_UNSUBSCRIBE_FROM_THE_NEWSLETTER_AT,
  "UNIFIED-WEB-JUST-ONE-MORE-CLICK": UNIFIED_WEB_JUST_ONE_MORE_CLICK,
  "UNIFIED-WEB-FIELD-INVALID-EMAIL": UNIFIED_WEB_FIELD_INVALID_EMAIL,
  "UNIFIED-WEB-PLEASE-TRY-DIFFERENT-DATE": UNIFIED_WEB_PLEASE_TRY_DIFFERENT_DATE,
  "UNIFIED-WEB-DEPARTURE-DATE": UNIFIED_WEB_DEPARTURE_DATE,
  "UNIFIED-WEB-TO": UNIFIED_WEB_TO,
  "UNIFIED-WEB-DURATION": UNIFIED_WEB_DURATION,
  "UNIFIED-WEB-NEXT-AVAILABLE-DATE": UNIFIED_WEB_NEXT_AVAILABLE_DATE,
  "UNIFIED-WEB-NO-SAILINGS": UNIFIED_WEB_NO_SAILINGS,
  "UNIFIED-WEB-SAILINGS-IN-LOCAL-TIME": UNIFIED_WEB_SAILINGS_IN_LOCAL_TIME,
  "UNIFIED-WEB-ARRIVAL": UNIFIED_WEB_ARRIVAL,
  "UNIFIED-WEB-DEPARTURE": UNIFIED_WEB_DEPARTURE,
  "UNIFIED-WEB-CHECK-IN-CLOSES": UNIFIED_WEB_CHECK_IN_CLOSES,
  "UNIFIED-WEB-UNSUBSCRIBE": UNIFIED_WEB_UNSUBSCRIBE,
  "UNIFIED-WEB-TO-ACTIVATE-YOUR-SUBSCRIPTION": UNIFIED_WEB_TO_ACTIVATE_YOUR_SUBSCRIPTION,
  "UNIFIED-WEB-FIELD-REQUIRED": UNIFIED_WEB_FIELD_REQUIRED,
  "UNIFIED-WEB-EMAIL-ADDRESS": UNIFIED_WEB_EMAIL_ADDRESS,
  "UNIFIED-WEB-SIGN-ME-UP": UNIFIED_WEB_SIGN_ME_UP,
  "UNIFIED-WEB-CLOSE": UNIFIED_WEB_CLOSE,
  "UNIFIED-WEB-PLEASE-WAIT": UNIFIED_WEB_PLEASE_WAIT,
  "UNIFIED-WEB-SELECT-A-DATE": UNIFIED_WEB_SELECT_A_DATE
};

// src/utils/simpleStrings.ts
var normalizeLocale = (locale) => locale.replace(
  /([a-z]{2})-([a-z]{2})/i,
  (_, lang, region) => `${lang.toLowerCase()}-${region.toUpperCase()}`
);
var getSimpleString = (locale, resourceId, fallback) => {
  if (!strings_exports) {
    console.warn("Simple strings map is not initialized");
    return fallback || resourceId;
  }
  const normalizedLocale = normalizeLocale(locale);
  const resourceMap = strings_exports[resourceId];
  if (!resourceMap) {
    console.warn(`No resource map found for resourceId: ${resourceId}`);
    return fallback || resourceId;
  }
  const value = resourceMap[normalizedLocale];
  const englishValue = resourceMap["en"];
  const fallbackValue = fallback || englishValue || resourceId;
  if (!value) {
    console.warn(
      `No translation found for simple string: ${resourceId} & locale: ${normalizedLocale}. Returns fallback: ${fallbackValue}`
    );
    return fallbackValue;
  }
  return value;
};
var getResourcesTranslated = (locale, resourceIds) => {
  return resourceIds.reduce(
    (acc, resourceId) => {
      acc[resourceId] = getSimpleString(locale, `UNIFIED-WEB-${resourceId}`);
      return acc;
    },
    {}
  );
};

// src/api-calls/helpers.ts
function transformLocaleToContententfulsLocale(locale) {
  if (locale === "_next" || locale === ".well-known" || locale.includes("favicon") || !locale) {
    return locale;
  }
  if (!availableLocales.has(locale.toLowerCase())) {
    console.warn(`Invalid locale: ${locale}`);
  }
  const tmp = locale.split("-");
  if (tmp.length > 1) {
    tmp[1] = tmp[1].toUpperCase();
  }
  return tmp.join("-");
}

// src/api-calls/graphql/navigation.ts
async function fetchTopNavigations(client, locale) {
  const { data, error } = await client.query({
    variables: {
      locale: transformLocaleToContententfulsLocale(locale)
    },
    fetchPolicy: "cache-first",
    query: NavigationDocument
  });
  if (error) throw error;
  return data == null ? void 0 : data.navigationCollection;
}
async function fetchFooterNavigation(client, locale) {
  const { data, error } = await client.query({
    variables: {
      locale: transformLocaleToContententfulsLocale(locale)
    },
    fetchPolicy: "cache-first",
    query: FooterNavigationDocument
  });
  if (error) throw error;
  return data == null ? void 0 : data.footerCollection;
}

// src/api-calls/graphql/pages.ts
async function getPageQueryByUrl({
  template,
  client,
  id,
  locale,
  preview
}) {
  const templateToQuery = {
    articlePage: ArticlePageDocument,
    articleCategoryOverviewPage: ArticleCategoryOverviewPageByIdDocument
    // TODO: Add more templates and queries as needed
  };
  const { data, error } = await client.query({
    variables: {
      id,
      locale: transformLocaleToContententfulsLocale(locale),
      preview: !!preview
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
    query: templateToQuery[template]
    // Use the dynamically selected query
  });
  if (error) throw error;
  if ((data == null ? void 0 : data.page.__typename) === "ArticleCategoryOverviewPage") {
    return getAndMergeArticles({ client, locale, preview, page: data.page });
  }
  return data == null ? void 0 : data.page;
}
var getAndMergeArticles = async ({
  client,
  preview,
  locale,
  page
}) => {
  var _a;
  const { data, error } = await client.query({
    variables: {
      category: page.category,
      preview: !!preview,
      locale: transformLocaleToContententfulsLocale(locale)
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
    query: ArticlesByCategoryDocument
  });
  if (error) throw error;
  return __spreadProps(__spreadValues({}, page), {
    articleCollection: (_a = data.result) == null ? void 0 : _a.items
  });
};

// src/api-calls/rest/getAllEntries.ts
async function getAllEntries(contentfulClient, contentType, limit = 1e3, additionalParams = {}) {
  let entries = [];
  let skip = 0;
  let total = 0;
  do {
    const nextResult = await contentfulClient.withAllLocales.getEntries(__spreadValues({
      content_type: contentType,
      limit,
      skip
    }, additionalParams));
    total = nextResult.total;
    entries = [...entries, ...nextResult.items];
    skip += limit;
  } while (entries.length < total);
  return entries;
}

// src/api-calls/rest/navigation.ts
async function getUrls(contentfulClient, locale, slug) {
  if (!slug) return {};
  const url = await contentfulClient.getEntries({
    content_type: "url",
    "fields.url": slug,
    locale: transformLocaleToContententfulsLocale(locale)
  });
  if (!url || url.items.length < 1) {
    console.error(
      `failed to get current url for locale ${locale} slug ${slug}`,
      url.errors
    );
    return {};
  }
  if (url.items.length > 1) {
    console.error("got multiple matches for the url");
  }
  const entry = await contentfulClient.withAllLocales.getEntry(
    url.items[0].sys.id
  );
  return entry.fields.url;
}

// src/api-calls/rest/pages.ts
async function getAllLocalizedPathsForAllPages(contentfulClient, contentType) {
  var _a, _b, _c;
  const pages = await contentfulClient.withAllLocales.getEntries({
    content_type: contentType,
    "fields.urlSlug.sys.contentType.sys.id": "url",
    "fields.urlSlug.fields.url[exists]": true,
    "fields.urlSlug.fields.urlType[match]": "Slug",
    include: 1
  });
  const localizedPaths = [];
  for (const page of pages.items) {
    const defaultLocale = "en";
    const localizedUrl = (_c = (_b = (_a = page == null ? void 0 : page.fields) == null ? void 0 : _a.urlSlug[defaultLocale]) == null ? void 0 : _b.fields) == null ? void 0 : _c.url;
    localizedPaths.push(localizedUrl);
  }
  return localizedPaths;
}
async function getAllLocalizedLandingPaths(contentfulClient, url) {
  const landingPages = await contentfulClient.withAllLocales.getEntries({
    content_type: "url",
    "fields.url": url,
    include: 1
  });
  const paths = landingPages.items[0].fields.url;
  return new Array(paths);
}

// src/api-calls/rest/redirects/validateUrls.ts
var sanitizeUrl = (url) => {
  url = (url == null ? void 0 : url.startsWith("/")) ? url.substring(1) : url;
  if (!url || !startsWithValidLocale(url)) return url;
  const [locale, ...rest] = (url == null ? void 0 : url.split("/")) || [];
  return `${locale.toLowerCase()}/${rest.join("/")}`;
};
var startsWithValidLocale = (url) => {
  if (!url) return;
  const locale = url == null ? void 0 : url.split("/")[0].toLowerCase();
  return availableLocales.has(locale);
};
var appendLocaleToUrl = (url, localeItem) => {
  if (!url) return;
  return startsWithValidLocale(url) ? `/${url}` : `/${[localeItem == null ? void 0 : localeItem.toLowerCase(), url].join("/")}`;
};

// src/api-calls/rest/redirects/mapRedirects.ts
var redirectsAreEqual = (a, b) => {
  return a.source === b.source && a.destination === b.destination && a.permanent === b.permanent;
};
var addRedirectIfDoesNotExist = (newRedirect, redirects) => {
  const redirectAlreadyExists = redirects.some((existingRedirect) => {
    return redirectsAreEqual(existingRedirect, newRedirect);
  });
  if (!redirectAlreadyExists) redirects.push(newRedirect);
};
function mapRedirect({
  sourceUrls,
  destinationUrls,
  selectedLocale,
  permanent
}) {
  if (!selectedLocale) return;
  let source = sanitizeUrl(sourceUrls[selectedLocale]);
  if (!source || startsWithValidLocale(source)) return;
  source = appendLocaleToUrl(source, selectedLocale);
  let destination = sanitizeUrl(destinationUrls[selectedLocale]);
  destination = appendLocaleToUrl(
    destination || sanitizeUrl(destinationUrls.en),
    destination ? selectedLocale : "en"
  );
  return { source, destination, permanent };
}
function mapRedirects({
  sourceUrls,
  destinationUrls,
  selectedLocales,
  permanent
}) {
  const mappedRedirects = [];
  selectedLocales.forEach((selectedLocale) => {
    const newRedirect = mapRedirect({
      sourceUrls,
      destinationUrls,
      selectedLocale,
      permanent
    });
    if (!newRedirect || !newRedirect.source || !newRedirect.destination) return;
    return addRedirectIfDoesNotExist(newRedirect, mappedRedirects);
  });
  return mappedRedirects;
}

// src/api-calls/rest/redirects/redirects.ts
async function getRedirects(contentfulClient) {
  let currentEntryId;
  try {
    const { items } = await contentfulClient.withAllLocales.getEntries(
      {
        content_type: "urlRedirect"
      }
    );
    return items.flatMap(({ fields, sys }) => {
      const { id } = sys || {};
      const { source, destination, sourceLocale } = fields || {};
      currentEntryId = id;
      const sourceUrls = source["en"] && source["en"]["fields"]["url"];
      const destinationUrls = destination["en"] && destination["en"]["fields"]["url"];
      const selectedLocales = sourceLocale["en"];
      if (!sourceUrls || !destinationUrls || !selectedLocales) return;
      return mapRedirects({
        sourceUrls,
        destinationUrls,
        selectedLocales,
        permanent: fields.permanent.en
      });
    });
  } catch (e) {
    throw new Error(
      `[Content error]: Broken Url Redirect configuration with id: ${currentEntryId}`
    );
  }
}

// src/api-calls/rest/simpleString.ts
var UnifiedWebTeamId = "5pGb1RlgI7MB76wCJb7W0l";
async function getAllLocalizedSimpleStrings(contentfulClient) {
  return getAllEntries(contentfulClient, "simpleString", 1e3, {
    "fields.teamReference.sys.contentType.sys.id": "teamName",
    "fields.teamReference.sys.id": UnifiedWebTeamId
  });
}

// src/clients/cache.ts
function createContentfulClientCache(clientCreation) {
  const clientLookup = {};
  return (contentfulSpace, env, accessToken, preview = false) => {
    const key = `${contentfulSpace}${env}${preview}`;
    if (!clientLookup[key]) {
      clientLookup[key] = clientCreation(
        contentfulSpace,
        env,
        accessToken,
        preview
      );
    }
    return clientLookup[key];
  };
}
function createContentfulClientCacheWithParams(clientCreation) {
  const clientLookup = {};
  return (params) => {
    const { contentfulSpace, env, preview = false } = params;
    const key = `${contentfulSpace}${env}${preview}`;
    if (!clientLookup[key]) {
      clientLookup[key] = clientCreation(params);
    }
    return clientLookup[key];
  };
}
var apolloLinks = ({
  contentfulSpace,
  env,
  accessToken,
  extraTokens
}) => {
  const httpLink = () => createHttpLink({
    fetch,
    uri: `https://graphql.contentful.com/content/v1/spaces/${contentfulSpace}/environments/${env}`,
    headers: __spreadValues({
      authorization: `Bearer ${accessToken}`
    }, extraTokens ? {
      "x-contentful-resource-resolution": btoa(
        JSON.stringify(extraTokens)
      )
    } : {})
  });
  const retryLink = () => new RetryLink({
    /* eslint-disable @typescript-eslint/no-unused-vars */
    attempts: (count, operation, error) => {
      const rateLimitReset = getRateLimitReset(error);
      return !!rateLimitReset;
    },
    delay: (count, _, error) => {
      const rateLimitReset = getRateLimitReset(error);
      if (!rateLimitReset) {
        return count * 1e3 * Math.random();
      }
      return Number.parseFloat(rateLimitReset) || 5;
    }
  });
  const loggerLink = () => new ApolloLink((operation, forward) => {
    return forward(operation);
  });
  return {
    httpLink,
    retryLink,
    loggerLink
  };
};
var getRateLimitReset = (error) => {
  if (error && "response" in error && error.response.headers.has("X-Contentful-RateLimit-Reset")) {
    const rateLimitReset = error.response.headers.get(
      "X-Contentful-RateLimit-Reset"
    );
    console.log("Rate limit reset", rateLimitReset);
    return rateLimitReset;
  }
};

// src/clients/graphqlContentfulClient.ts
var createContentfulGraphQLClient = createContentfulClientCache(
  (contentfulSpace, env, accessToken) => {
    return new ApolloClient({
      link: createLink({ contentfulSpace, env, accessToken }),
      cache: new InMemoryCache()
    });
  }
);
var createContentfulGraphQLClientWithParams = createContentfulClientCacheWithParams(
  ({ contentfulSpace, env, accessToken, extraTokens }) => {
    if (extraTokens === void 0) {
      extraTokens = getExtraTokens();
    }
    for (const [key, value] of Object.entries({
      contentfulSpace,
      env,
      accessToken
    })) {
      if (value === "") {
        throw new Error(`${key} must be provided!`);
      }
    }
    return new ApolloClient({
      link: createLink({ contentfulSpace, env, accessToken, extraTokens }),
      cache: new InMemoryCache()
    });
  }
);
var createLink = ({
  contentfulSpace,
  env,
  accessToken,
  extraTokens
}) => {
  const { httpLink, loggerLink, retryLink } = apolloLinks({
    contentfulSpace,
    env,
    accessToken,
    extraTokens
  });
  let link = from([retryLink(), httpLink()]);
  if (process.env.APOLLO_DEBUG_MODE === "true") {
    link = from([loggerLink(), link]);
  }
  return link;
};
function getExtraTokens() {
  const dotcomSpace = process.env.CONTENTFUL_DOTCOM_CONTENT_SPACE || "";
  const dotcomSpaceAccessToken = process.env.CONTENTFUL_DOTCOM_CONTENT_ACCESS_TOKEN || "";
  if (dotcomSpace && dotcomSpaceAccessToken) {
    return {
      spaces: {
        [dotcomSpace]: dotcomSpaceAccessToken
      }
    };
  }
  return void 0;
}
var createContentfulRestClient = createContentfulClientCache(
  (contentfulSpace, environment, accessToken, preview) => createClient({
    space: contentfulSpace,
    accessToken,
    environment,
    host: preview ? "preview.contentful.com" : void 0
  })
);

// src/data-management/exceptions.ts
var DataFetchingError = class extends Error {
  constructor(innerErrors) {
    super();
    __publicField(this, "innerErrors");
    this.message = "Error fetching data";
    this.name = "DataFetchingError";
    this.innerErrors = innerErrors;
  }
};
var ensureError = (value) => {
  if (value instanceof Error) {
    return value;
  }
  return new Error(
    `Converted to the instance of Error: ${JSON.stringify(value)}`
  );
};

// src/data-management/repository/repository.ts
var Repository = class {
  constructor(graphQLClient) {
    this.graphQLClient = graphQLClient;
  }
  get client() {
    return this.graphQLClient;
  }
  async getByQueryAsync(query, variables) {
    const { data, error, errors } = await this.graphQLClient.query({
      variables,
      fetchPolicy: "no-cache",
      errorPolicy: "all",
      query
    });
    if (error || errors) {
      this.checkOrThrow(error, errors);
    }
    return data;
  }
  collectAndLogError(error, innerErrors) {
    console.error(`${error.name}: ${error.message}`);
    console.error("Stacktrace :", error.stack);
    innerErrors.push(error);
  }
  checkOrThrow(error, errors) {
    var _a;
    const innerErrors = [];
    if (error == null ? void 0 : error.networkError) {
      this.collectAndLogError(error.networkError, innerErrors);
    }
    (_a = error == null ? void 0 : error.graphQLErrors) == null ? void 0 : _a.forEach(
      (error2) => this.collectAndLogError(error2, innerErrors)
    );
    if (errors) {
      this.filteredErrors(errors).forEach((error2) => {
        this.collectAndLogError(error2, innerErrors);
      });
    }
    if (innerErrors.length) {
      throw new DataFetchingError(innerErrors);
    }
  }
  filteredErrors(errors) {
    const ignoredErrorsCodes = ["UNRESOLVABLE_LINK"];
    return errors.filter((error) => {
      const contentful = error.extensions && typeof error.extensions.contentful === "object" && error.extensions.contentful !== null ? error.extensions.contentful : void 0;
      return (contentful == null ? void 0 : contentful.code) ? !ignoredErrorsCodes.includes(contentful.code) : true;
    });
  }
};

// src/data-management/services/content-service.ts
var ContentService = class {
  constructor() {
    __publicField(this, "providers", []);
    __publicField(this, "content", []);
    __publicField(this, "errors", []);
    __publicField(this, "isRejected", (data) => data.status === "rejected");
    __publicField(this, "isFulfilled", (data) => data.status === "fulfilled");
  }
  registerProvider(provider) {
    this.providers.push(provider);
    return this;
  }
  async resolveAsync() {
    const data = await Promise.all(
      this.providers.map((p) => p.getContentAsync())
    );
    this.content = [...this.content, ...data];
    this.providers = [];
    return this;
  }
  async settleAsync(contentKey) {
    const data = await Promise.allSettled(
      this.providers.map((p) => p.getContentAsync())
    );
    const content = data.filter(this.isFulfilled).map((p) => p.value);
    const errors = data.filter(this.isRejected).map((p) => p.reason);
    this.content = contentKey ? [...this.content, { [contentKey]: content }] : [...this.content, ...content];
    this.errors = [...this.errors, ...errors];
    this.providers = [];
    return this;
  }
};

// src/data-management/types/index.ts
var LegacyPageTypes = /* @__PURE__ */ ((LegacyPageTypes2) => {
  LegacyPageTypes2["ModularPage"] = "ModularPage";
  LegacyPageTypes2["ArticlePage"] = "ArticlePage";
  LegacyPageTypes2["ArticleCategoryOverviewPage"] = "ArticleCategoryOverviewPage";
  return LegacyPageTypes2;
})(LegacyPageTypes || {});
var DXPPageTypes = /* @__PURE__ */ ((DXPPageTypes2) => {
  DXPPageTypes2["AboutCompositePage"] = "AboutCompositePage";
  DXPPageTypes2["ArticleCompositePage"] = "ArticleCompositePage";
  DXPPageTypes2["B2BCompositePage"] = "B2BCompositePage";
  DXPPageTypes2["B2CCompositePage"] = "B2CCompositePage";
  return DXPPageTypes2;
})(DXPPageTypes || {});

export { AboutCompositePageOrder, AboutPageDocument, AccordionFragmentDoc, AccordionGroupAccordionItemCollectionOrder, AccordionGroupFragmentDoc, AccordionGroupItemFragmentDoc, AccordionGroupItemLinkingCollectionsAccordionGroupCollectionOrder, AccordionGroupItemLinkingCollectionsMapSectionCollectionOrder, AccordionGroupItemOrder, AccordionGroupLinkingCollectionsAccordionSectionCollectionOrder, AccordionGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder, AccordionGroupLinkingCollectionsPageSectionCollectionOrder, AccordionGroupOrder, AccordionLinkingCollectionsPageSectionCollectionOrder, AccordionOrder, AccordionSectionAccordionGroupCollectionOrder, AccordionSectionByIdDocument, AccordionSectionLinkingCollectionsAboutCompositePageCollectionOrder, AccordionSectionLinkingCollectionsArticleCompositePageCollectionOrder, AccordionSectionLinkingCollectionsB2BCompositePageCollectionOrder, AccordionSectionLinkingCollectionsB2CCompositePageCollectionOrder, AccordionSectionOrder, ActionCardFragmentDoc, ActionCardLinkingCollectionsCardsSectionCollectionOrder, ActionCardOrder, AmendmentBookingOrder, AmendmentCabinOrder, AmendmentFaresOrder, AppOrder, AppSectionFragmentDoc, AppSectionLinkingCollectionsArticlePageCollectionOrder, AppSectionLinkingCollectionsModularPageCollectionOrder, AppSectionOrder, ArrayOfItemsOrder, ArticleCategoryOverviewPageByIdDocument, ArticleCategoryOverviewPageOrder, ArticleCompositePageDocument, ArticleCompositePageOrder, ArticleHeroSectionByIdDocument, ArticleHeroSectionLinkingCollectionsArticleCompositePageCollectionOrder, ArticleHeroSectionOrder, ArticlePageDocument, ArticlePageOrder, ArticleSectionByIdDocument, ArticleSectionLinkingCollectionsArticleCompositePageCollectionOrder, ArticleSectionOrder, ArticleSidebarContentBlockLinkingCollectionsArticleSidebarCollectionOrder, ArticleSidebarContentBlockOrder, ArticleSidebarLinkingCollectionsArticleSectionCollectionOrder, ArticleSidebarOrder, ArticlesByCategoryDocument, AssetFragmentDoc, AssetLinkFragmentDoc, AssetLinkLinkingCollectionsMapSectionCollectionOrder, AssetLinkLinkingCollectionsTextAndMediaSectionCollectionOrder, AssetLinkOrder, AssetOrder, AuthorLinkingCollectionsArticlePageCollectionOrder, AuthorLinkingCollectionsArticleSidebarCollectionOrder, AuthorOrder, B2BCompositePageOrder, B2BPageDocument, B2BTimetableRouteLinkingCollectionsB2BTimetableSectionCollectionOrder, B2BTimetableRouteOrder, B2BTimetableSectionContentLinkingCollectionsB2BTimetableSectionCollectionOrder, B2BTimetableSectionContentOrder, B2BTimetableSectionLinkingCollectionsB2BCompositePageCollectionOrder, B2BTimetableSectionOrder, B2CCompositePageOrder, B2CPageDocument, B2bTimetableSectionByIdDocument, BannerCollectionDocument, BannerOrder, CabinDetailsOrder, CabinGroupOrder, CabinLinkingCollectionsFerryCollectionOrder, CabinOrder, CampaignBlockLinkingCollectionsMobilePageCollectionOrder, CampaignBlockOrder, CardsSectionByIdDocument, CardsSectionLinkingCollectionsAboutCompositePageCollectionOrder, CardsSectionLinkingCollectionsArticleCompositePageCollectionOrder, CardsSectionLinkingCollectionsB2BCompositePageCollectionOrder, CardsSectionLinkingCollectionsB2CCompositePageCollectionOrder, CardsSectionOrder, CardsSectionSectionButtonsCollectionOrder, CheckmarkListGroupFragmentDoc, CheckmarkListGroupLinkingCollectionsB2BTimetableSectionContentCollectionOrder, CheckmarkListGroupListSectionsCollectionOrder, CheckmarkListGroupOrder, CheckmarkListItemLinkingCollectionsCheckmarkListSectionCollectionOrder, CheckmarkListItemOrder, CheckmarkListSectionFragmentDoc, CheckmarkListSectionItemsCollectionOrder, CheckmarkListSectionLinkingCollectionsCheckmarkListGroupCollectionOrder, CheckmarkListSectionOrder, ConsentTextLinkingCollectionsFormConsentCheckboxFieldCollectionOrder, ConsentTextLinkingCollectionsFormOptionalConsentCheckboxFieldCollectionOrder, ConsentTextOrder, ContentBlockCtasCollectionOrder, ContentBlockFragmentDoc, ContentBlockLinkingCollectionsAppSectionCollectionOrder, ContentBlockLinkingCollectionsArticlePageCollectionOrder, ContentBlockLinkingCollectionsCampaignBlockCollectionOrder, ContentBlockLinkingCollectionsMetaDataAndSeoCollectionOrder, ContentBlockLinkingCollectionsNavigationCollectionOrder, ContentBlockLinkingCollectionsPageSectionCollectionOrder, ContentBlockOrder, ContentService, DXPPageTypes, DataFetchingError, DfdsAppSimpleStringOrder, DynamicFormDocument, DynamicFormFragmentDoc, EntryOrder, EntryReferenceFragmentDoc, EventGroupEventsCollectionOrder, EventGroupLinkingCollectionsFerryCollectionOrder, EventGroupOrder, EventLinkingCollectionsEventGroupCollectionOrder, EventOrder, FaresTiersTncOrder, FeatureListItemFragmentDoc, FeatureListItemLinkingCollectionsFeatureListSectionCollectionOrder, FeatureListItemOrder, FeatureListSectionByIdDocument, FeatureListSectionLinkingCollectionsAboutCompositePageCollectionOrder, FeatureListSectionLinkingCollectionsArticleCompositePageCollectionOrder, FeatureListSectionLinkingCollectionsB2BCompositePageCollectionOrder, FeatureListSectionLinkingCollectionsB2CCompositePageCollectionOrder, FeatureListSectionOrder, FeatureListSectionSectionButtonsCollectionOrder, FeatureListSectionSectionItemsCollectionOrder, FerryCabinsCollectionOrder, FerryEventGroupsCollectionOrder, FerryFacilitiesCollectionOrder, FerryFacilitiesLinkingCollectionsFerryCollectionOrder, FerryFacilitiesOrder, FerryInstructionAndSignalisationCollectionOrder, FerryLinkingCollectionsPaxRouteCollectionOrder, FerryOrder, FerryPetsInfoCollectionOrder, FerryRestaurantsCollectionOrder, FieldControllerFragmentDoc, FieldControllerLinkingCollectionsFormRowCollectionOrder, FieldControllerOrder, FieldFragmentDoc, FieldLinkingCollectionsFieldControllerCollectionOrder, FieldOptionsCollectionOrder, FieldOrder, FlowCabinFaresOrder, FlowCabinOrder, FlowFaresOrder, FlowMealsOrder, FlowTravelOrder, FooterColumnsCollectionOrder, FooterNavigationDocument, FooterOrder, FormCheckboxFieldOrder, FormConsentCheckboxFieldFragmentDoc, FormConsentCheckboxFieldLinkingCollectionsFormCollectionOrder, FormConsentCheckboxFieldOrder, FormInputFieldOrder, FormLinkingCollectionsAppSectionCollectionOrder, FormLinkingCollectionsFormSectionCollectionOrder, FormMarkdownFieldFragmentDoc, FormMarkdownFieldLinkingCollectionsFormCollectionOrder, FormMarkdownFieldLinkingCollectionsFormRowCollectionOrder, FormMarkdownFieldOrder, FormMessageFragmentDoc, FormMessageLinkingCollectionsFormCollectionOrder, FormMessageOrder, FormOptionalConsentCheckboxFieldFragmentDoc, FormOptionalConsentCheckboxFieldLinkingCollectionsFormCollectionOrder, FormOptionalConsentCheckboxFieldOrder, FormOrder, FormRatingFieldOrder, FormRowFragmentDoc, FormRowLinkingCollectionsFormCollectionOrder, FormRowOrder, FormSectionByIdDocument, FormSectionLinkingCollectionsB2BCompositePageCollectionOrder, FormSectionLinkingCollectionsB2CCompositePageCollectionOrder, FormSectionOrder, FormSelectFieldOptionsCollectionOrder, FormSelectFieldOrder, FormSelectOptionLinkingCollectionsFieldCollectionOrder, FormSelectOptionLinkingCollectionsFormSelectFieldCollectionOrder, FormSelectOptionOrder, FormSubmitButtonFragmentDoc, FormSubmitButtonLinkingCollectionsFormCollectionOrder, FormSubmitButtonOrder, FreightTerminalFragmentDoc, FreightTerminalLinkingCollectionsB2BTimetableRouteCollectionOrder, FreightTerminalOrder, GdprSettingsOrder, GenericAppSectionDocument, GenericPageSectionDocument, GenericRouteOrder, HeroPromotionalSectionByIdDocument, HeroPromotionalSectionLinkingCollectionsB2CCompositePageCollectionOrder, HeroPromotionalSectionOrder, HeroSectionByIdDocument, HeroSectionLinkingCollectionsAboutCompositePageCollectionOrder, HeroSectionLinkingCollectionsB2BCompositePageCollectionOrder, HeroSectionLinkingCollectionsB2CCompositePageCollectionOrder, HeroSectionLinksCollectionOrder, HeroSectionOrder, ImageFormat, ImageResizeFocus, ImageResizeStrategy, InstructionAndSignalisationLinkingCollectionsFerryCollectionOrder, InstructionAndSignalisationOrder, KeyValuePairCollectionItemsCollectionOrder, KeyValuePairCollectionOrder, KeyValuePairLinkingCollectionsKeyValuePairCollectionCollectionOrder, LegacyPageTypes, LinkFragmentDoc, LinkLinkingCollectionsBannerCollectionOrder, LinkLinkingCollectionsContentBlockCollectionOrder, LinkLinkingCollectionsFooterCollectionOrder, LinkLinkingCollectionsGdprSettingsCollectionOrder, LinkLinkingCollectionsLinksListCollectionOrder, LinkLinkingCollectionsNavigationCollectionOrder, LinkLinkingCollectionsNavigationItemCollectionOrder, LinkLinkingCollectionsPageSectionCollectionOrder, LinkListSectionByIdDocument, LinkListSectionLinkingCollectionsB2BCompositePageCollectionOrder, LinkListSectionOrder, LinkListSectionSubsectionsCollectionOrder, LinkListSubsectionFragmentDoc, LinkListSubsectionLinkItemsCollectionOrder, LinkListSubsectionLinkingCollectionsLinkListSectionCollectionOrder, LinkListSubsectionOrder, LinkOrder, LinksListLinkingCollectionsPageSectionCollectionOrder, LinksListLinksListItemsCollectionOrder, LinksListOrder, ListItemFragmentDoc, LongStringLinkingCollectionsArrayOfItemsCollectionOrder, LongStringOrder, MapSectionAccordionsCollectionOrder, MapSectionByIdDocument, MapSectionLinkingCollectionsB2BCompositePageCollectionOrder, MapSectionLinkingCollectionsB2CCompositePageCollectionOrder, MapSectionOrder, MealsRestaurantLinkingCollectionsFerryCollectionOrder, MealsRestaurantOrder, MediaCardFragmentDoc, MediaCardLinkingCollectionsCardsSectionCollectionOrder, MediaCardOrder, MetaDataAndSeoFragmentDoc, MetaDataAndSeoLinkingCollectionsAboutCompositePageCollectionOrder, MetaDataAndSeoLinkingCollectionsArticleCategoryOverviewPageCollectionOrder, MetaDataAndSeoLinkingCollectionsArticleCompositePageCollectionOrder, MetaDataAndSeoLinkingCollectionsArticlePageCollectionOrder, MetaDataAndSeoLinkingCollectionsB2BCompositePageCollectionOrder, MetaDataAndSeoLinkingCollectionsB2CCompositePageCollectionOrder, MetaDataAndSeoLinkingCollectionsModularPageCollectionOrder, MetaDataAndSeoOrder, MigrationLogOrder, MobileContentBlockLinkingCollectionsMobileSectionCollectionOrder, MobileContentBlockOrder, MobilePageCampaignBlocksCollectionOrder, MobilePageOrder, MobileScreenMobileSectionsCollectionOrder, MobileScreenOrder, MobileSectionLinkingCollectionsMobileScreenCollectionOrder, MobileSectionOrder, MobileSectionSectionItemsCollectionOrder, ModularPageOrder, ModularPageSectionByIdDocument, NamespaceAndStringLinkingCollectionsArrayOfItemsCollectionOrder, NamespaceAndStringOrder, NavigationDiscoverSectionLinkingCollectionsNavigationCollectionOrder, NavigationDiscoverSectionOrder, NavigationDocument, NavigationItemLinkingCollectionsFooterCollectionOrder, NavigationItemLinkingCollectionsNavigationCollectionOrder, NavigationItemLinkingCollectionsNavigationDiscoverSectionCollectionOrder, NavigationItemLinkingCollectionsNavigationItemCollectionOrder, NavigationItemOrder, NavigationOrder, NavigationPromotionsCollectionOrder, NewsletterSectionByIdDocument, NewsletterSectionLinkingCollectionsB2CCompositePageCollectionOrder, NewsletterSectionOrder, NotificationLinkingCollectionsB2BTimetableSectionContentCollectionOrder, NotificationOrder, OpenGraphSettingsOrder, PageIdBySlugDocument, PageSectionFragmentDoc, PageSectionLinkingCollectionsArticleCategoryOverviewPageCollectionOrder, PageSectionLinkingCollectionsArticlePageCollectionOrder, PageSectionLinkingCollectionsModularPageCollectionOrder, PageSectionOrder, PaxObCardItemsCollectionOrder, PaxObCardOrder, PaxObItemLinkingCollectionsPaxObCardCollectionOrder, PaxObItemOrder, PaxObResourceOrder, PaxRouteFerriesCollectionOrder, PaxRouteOrder, PetsLinkingCollectionsFerryCollectionOrder, PetsOrder, PluralStringLinkingCollectionsArrayOfItemsCollectionOrder, PluralStringOrder, PriceChangedPopupOrder, ProductCardSectionByIdDocument, ProductCardSectionIconItemsCollectionOrder, ProductCardSectionLinkingCollectionsB2CCompositePageCollectionOrder, ProductCardSectionOrder, ReleaseNotesOrder, Repository, ResourceOrder, RichTextItemLinkingCollectionsRichTextSectionCollectionOrder, RichTextItemLinksCollectionOrder, RichTextItemOrder, RichTextSectionByIdDocument, RichTextSectionItemsCollectionOrder, RichTextSectionLinkingCollectionsB2BCompositePageCollectionOrder, RichTextSectionLinkingCollectionsB2CCompositePageCollectionOrder, RichTextSectionOrder, RichTextStringLinkingCollectionsArrayOfItemsCollectionOrder, RichTextStringOrder, RouteContentFragmentDoc, RouteLinkingCollectionsCabinDetailsCollectionOrder, RouteLinkingCollectionsCabinGroupCollectionOrder, RouteLinkingCollectionsFlowCabinFaresCollectionOrder, RouteLinkingCollectionsMealsRestaurantCollectionOrder, RouteOrder, SeabookResourceOrder, SectionThemeFragmentDoc, SectionTypeLinkingCollectionsPageSectionCollectionOrder, SectionTypeOrder, SimpleStringLinkingCollectionsArrayOfItemsCollectionOrder, SimpleStringLinkingCollectionsFooterCollectionOrder, SimpleStringLinkingCollectionsGenericRouteCollectionOrder, SimpleStringLinkingCollectionsNavigationDiscoverSectionCollectionOrder, SimpleStringOrder, SiteSettingsLinkingCollectionsFooterCollectionOrder, SiteSettingsLinkingCollectionsNavigationCollectionOrder, SiteSettingsOrder, TeamNameLinkingCollectionsArrayOfItemsCollectionOrder, TeamNameLinkingCollectionsLongStringCollectionOrder, TeamNameLinkingCollectionsNamespaceAndStringCollectionOrder, TeamNameLinkingCollectionsReleaseNotesCollectionOrder, TeamNameLinkingCollectionsRichTextStringCollectionOrder, TeamNameLinkingCollectionsSimpleStringCollectionOrder, TeamNameLinkingCollectionsTitleAndLinkCollectionOrder, TeamNameLinkingCollectionsTitleAndMediaCollectionOrder, TeamNameOrder, TerminalLinkingCollectionsPaxRouteCollectionOrder, TerminalOrder, TestOrder, TextAndIconItemFragmentDoc, TextAndIconItemLinkingCollectionsProductCardSectionCollectionOrder, TextAndIconItemLinkingCollectionsTextAndIconSectionCollectionOrder, TextAndIconItemOrder, TextAndIconSectionByIdDocument, TextAndIconSectionIconItemsCollectionOrder, TextAndIconSectionLinkingCollectionsAboutCompositePageCollectionOrder, TextAndIconSectionLinkingCollectionsArticleCompositePageCollectionOrder, TextAndIconSectionLinkingCollectionsB2BCompositePageCollectionOrder, TextAndIconSectionOrder, TextAndMediaSectionByIdDocument, TextAndMediaSectionLinkingCollectionsAboutCompositePageCollectionOrder, TextAndMediaSectionLinkingCollectionsArticleCompositePageCollectionOrder, TextAndMediaSectionLinkingCollectionsB2BCompositePageCollectionOrder, TextAndMediaSectionLinkingCollectionsB2CCompositePageCollectionOrder, TextAndMediaSectionOrder, TextCardFragmentDoc, TextCardLinkingCollectionsTextCardSectionCollectionOrder, TextCardOrder, TextCardSectionByIdDocument, TextCardSectionCardsCollectionOrder, TextCardSectionLinkingCollectionsAboutCompositePageCollectionOrder, TextCardSectionLinkingCollectionsArticleCompositePageCollectionOrder, TextCardSectionLinkingCollectionsB2BCompositePageCollectionOrder, TextCardSectionLinkingCollectionsB2CCompositePageCollectionOrder, TextCardSectionOrder, TextCardSectionSectionButtonsCollectionOrder, ThemeLinkingCollectionsAppSectionCollectionOrder, ThemeLinkingCollectionsPageSectionCollectionOrder, ThemeOrder, TimeTableSectionByIdDocument, TimeTableSectionLinkingCollectionsB2CCompositePageCollectionOrder, TimeTableSectionOrder, TitleAndLinkLinkingCollectionsArrayOfItemsCollectionOrder, TitleAndLinkOrder, TitleAndMediaLinkingCollectionsArrayOfItemsCollectionOrder, TitleAndMediaOrder, TrackingAndActivationLinkingCollectionsModularPageCollectionOrder, TrackingAndActivationOrder, TravelSearchSectionByIdDocument, TravelSearchSectionLinkingCollectionsB2CCompositePageCollectionOrder, TravelSearchSectionOrder, TrustpilotSectionByIdDocument, TrustpilotSectionLinkingCollectionsB2CCompositePageCollectionOrder, TrustpilotSectionOrder, UrlLinkingCollectionsAboutCompositePageCollectionOrder, UrlLinkingCollectionsArticleCategoryOverviewPageCollectionOrder, UrlLinkingCollectionsArticleCompositePageCollectionOrder, UrlLinkingCollectionsArticlePageCollectionOrder, UrlLinkingCollectionsB2BCompositePageCollectionOrder, UrlLinkingCollectionsB2CCompositePageCollectionOrder, UrlLinkingCollectionsLinkCollectionOrder, UrlLinkingCollectionsModularPageCollectionOrder, UrlLinkingCollectionsNavigationDiscoverSectionCollectionOrder, UrlLinkingCollectionsUrlRedirectCollectionOrder, UrlLinkingCollectionsWebLinkCollectionOrder, UrlOrder, UrlRedirectOrder, WebLinkFragmentDoc, WebLinkLinkingCollectionsActionCardCollectionOrder, WebLinkLinkingCollectionsCardsSectionCollectionOrder, WebLinkLinkingCollectionsFeatureListSectionCollectionOrder, WebLinkLinkingCollectionsHeroSectionCollectionOrder, WebLinkLinkingCollectionsLinkListSubsectionCollectionOrder, WebLinkLinkingCollectionsMapSectionCollectionOrder, WebLinkLinkingCollectionsMediaCardCollectionOrder, WebLinkLinkingCollectionsRichTextItemCollectionOrder, WebLinkLinkingCollectionsTextAndMediaSectionCollectionOrder, WebLinkLinkingCollectionsTextCardCollectionOrder, WebLinkLinkingCollectionsTextCardSectionCollectionOrder, WebLinkOrder, appendLocaleToUrl, availableLocales, createContentfulClientCache, createContentfulClientCacheWithParams, createContentfulGraphQLClient, createContentfulGraphQLClientWithParams, createContentfulRestClient, ensureError, fetchFooterNavigation, fetchTopNavigations, getAllEntries, getAllLocalizedLandingPaths, getAllLocalizedPathsForAllPages, getAllLocalizedSimpleStrings, getPageQueryByUrl, getRedirects, getResourcesTranslated, getSimpleString, getUrls, locales, sanitizeUrl, startsWithValidLocale, transformLocaleToContententfulsLocale, useGetDynamicFormsData };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map